/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 *
 * @export
 * @interface ActivityLogCandidateResponse
 */
export interface ActivityLogCandidateResponse {
  /**
   *
   * @type {number}
   * @memberof ActivityLogCandidateResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof ActivityLogCandidateResponse
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof ActivityLogCandidateResponse
   */
  last_name: string;
}
/**
 *
 * @export
 * @interface ActivityLogPositionResponse
 */
export interface ActivityLogPositionResponse {
  /**
   *
   * @type {number}
   * @memberof ActivityLogPositionResponse
   */
  id: number;
}
/**
 *
 * @export
 * @interface ActivityLogResponse
 */
export interface ActivityLogResponse {
  /**
   *
   * @type {number}
   * @memberof ActivityLogResponse
   */
  id?: number | null;
  /**
   *
   * @type {string}
   * @memberof ActivityLogResponse
   */
  event: string;
  /**
   *
   * @type {string}
   * @memberof ActivityLogResponse
   */
  created_by?: string | null;
  /**
   *
   * @type {string}
   * @memberof ActivityLogResponse
   */
  created_at?: string | null;
  /**
   *
   * @type {ActivityLogCandidateResponse}
   * @memberof ActivityLogResponse
   */
  candidate?: ActivityLogCandidateResponse | null;
  /**
   *
   * @type {ActivityLogPositionResponse}
   * @memberof ActivityLogResponse
   */
  position?: ActivityLogPositionResponse | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const AgentVoice = {
  Kate: "Kate",
  Steve: "Steve",
} as const;

export type AgentVoice = (typeof AgentVoice)[keyof typeof AgentVoice];

/**
 *
 * @export
 * @interface ApplicationSubmissionResponse
 */
export interface ApplicationSubmissionResponse {
  /**
   *
   * @type {string}
   * @memberof ApplicationSubmissionResponse
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof ApplicationSubmissionResponse
   */
  resume_id: number;
}
/**
 *
 * @export
 * @interface AssistedAnswerFlagEchoExample
 */
export interface AssistedAnswerFlagEchoExample {
  /**
   *
   * @type {string}
   * @memberof AssistedAnswerFlagEchoExample
   */
  question: string;
  /**
   *
   * @type {string}
   * @memberof AssistedAnswerFlagEchoExample
   */
  answer_excerpt: string;
  /**
   *
   * @type {Array<string>}
   * @memberof AssistedAnswerFlagEchoExample
   */
  shared_words: Array<string>;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagEchoExample
   */
  rate: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagEchoExample
   */
  timestamp_seconds: number;
}
/**
 *
 * @export
 * @interface AssistedAnswerFlagReadingError
 */
export interface AssistedAnswerFlagReadingError {
  /**
   *
   * @type {string}
   * @memberof AssistedAnswerFlagReadingError
   */
  transcribed: string;
  /**
   *
   * @type {string}
   * @memberof AssistedAnswerFlagReadingError
   */
  expected: string;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagReadingError
   */
  corpus_correct_count: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagReadingError
   */
  timestamp_seconds: number;
  /**
   *
   * @type {string}
   * @memberof AssistedAnswerFlagReadingError
   */
  excerpt: string;
}
/**
 *
 * @export
 * @interface AssistedAnswerFlagSignalPoints
 */
export interface AssistedAnswerFlagSignalPoints {
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignalPoints
   */
  lag_delta: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignalPoints
   */
  long_lag: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignalPoints
   */
  echo: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignalPoints
   */
  template: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignalPoints
   */
  spoken_markers: number;
}
/**
 *
 * @export
 * @interface AssistedAnswerFlagSignals
 */
export interface AssistedAnswerFlagSignals {
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignals
   */
  lag_delta_seconds: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignals
   */
  long_lag_seconds: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignals
   */
  short_lag_seconds: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignals
   */
  long_answer_count: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignals
   */
  echo_rate: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignals
   */
  template_count: number;
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagSignals
   */
  spoken_markers_per_1k: number;
  /**
   *
   * @type {AssistedAnswerFlagSignalPoints}
   * @memberof AssistedAnswerFlagSignals
   */
  points: AssistedAnswerFlagSignalPoints;
}
/**
 *
 * @export
 * @interface AssistedAnswerFlagTemplateExample
 */
export interface AssistedAnswerFlagTemplateExample {
  /**
   *
   * @type {number}
   * @memberof AssistedAnswerFlagTemplateExample
   */
  timestamp_seconds: number;
  /**
   *
   * @type {string}
   * @memberof AssistedAnswerFlagTemplateExample
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof AssistedAnswerFlagTemplateExample
   */
  asked_about: string;
}
/**
 *
 * @export
 * @interface AutomatedInvite
 */
export interface AutomatedInvite {
  /**
   *
   * @type {string}
   * @memberof AutomatedInvite
   */
  sms_message: string | null;
  /**
   *
   * @type {Array<ResumeEvaluation>}
   * @memberof AutomatedInvite
   */
  flags: Array<ResumeEvaluation> | null;
  /**
   *
   * @type {string}
   * @memberof AutomatedInvite
   */
  source_filter?: string | null;
  /**
   *
   * @type {number}
   * @memberof AutomatedInvite
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof AutomatedInvite
   */
  position_id: number;
  /**
   *
   * @type {Array<string>}
   * @memberof AutomatedInvite
   */
  times?: Array<string>;
  /**
   *
   * @type {boolean}
   * @memberof AutomatedInvite
   */
  paused?: boolean;
  /**
   *
   * @type {string}
   * @memberof AutomatedInvite
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof AutomatedInvite
   */
  updated_at?: string;
}
/**
 *
 * @export
 * @interface AutomatedInviteDefault
 */
export interface AutomatedInviteDefault {
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteDefault
   */
  sms_message: string | null;
  /**
   *
   * @type {Array<ResumeEvaluation>}
   * @memberof AutomatedInviteDefault
   */
  flags: Array<ResumeEvaluation> | null;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteDefault
   */
  source_filter?: string | null;
  /**
   *
   * @type {number}
   * @memberof AutomatedInviteDefault
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof AutomatedInviteDefault
   */
  subscription_id: number;
  /**
   *
   * @type {Array<string>}
   * @memberof AutomatedInviteDefault
   */
  times?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteDefault
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteDefault
   */
  updated_at?: string;
}
/**
 *
 * @export
 * @interface AutomatedInviteDefaultRequest
 */
export interface AutomatedInviteDefaultRequest {
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteDefaultRequest
   */
  sms_message: string | null;
  /**
   *
   * @type {Array<ResumeEvaluation>}
   * @memberof AutomatedInviteDefaultRequest
   */
  flags: Array<ResumeEvaluation> | null;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteDefaultRequest
   */
  source_filter?: string | null;
}
/**
 *
 * @export
 * @interface AutomatedInviteDefaultSourceFilterApplyResponse
 */
export interface AutomatedInviteDefaultSourceFilterApplyResponse {
  /**
   *
   * @type {number}
   * @memberof AutomatedInviteDefaultSourceFilterApplyResponse
   */
  updated_position_count: number;
}
/**
 *
 * @export
 * @interface AutomatedInviteExcludedStage
 */
export interface AutomatedInviteExcludedStage {
  /**
   *
   * @type {number}
   * @memberof AutomatedInviteExcludedStage
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof AutomatedInviteExcludedStage
   */
  subscription_id: number;
  /**
   *
   * @type {number}
   * @memberof AutomatedInviteExcludedStage
   */
  application_stage_id: number;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteExcludedStage
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteExcludedStage
   */
  updated_at?: string;
}
/**
 * Body for the pause/resume PATCH, the only writer of ``AutomatedInvite.paused``.
 * @export
 * @interface AutomatedInvitePausedRequest
 */
export interface AutomatedInvitePausedRequest {
  /**
   *
   * @type {boolean}
   * @memberof AutomatedInvitePausedRequest
   */
  paused: boolean;
}
/**
 *
 * @export
 * @interface AutomatedInviteRequest
 */
export interface AutomatedInviteRequest {
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteRequest
   */
  sms_message: string | null;
  /**
   *
   * @type {Array<ResumeEvaluation>}
   * @memberof AutomatedInviteRequest
   */
  flags: Array<ResumeEvaluation> | null;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteRequest
   */
  source_filter?: string | null;
}
/**
 * Position and saved filter used by the copy-from-position control.
 * @export
 * @interface AutomatedInviteSourceFilterOptionResponse
 */
export interface AutomatedInviteSourceFilterOptionResponse {
  /**
   *
   * @type {number}
   * @memberof AutomatedInviteSourceFilterOptionResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteSourceFilterOptionResponse
   */
  position_title: string | null;
  /**
   *
   * @type {string}
   * @memberof AutomatedInviteSourceFilterOptionResponse
   */
  source_filter: string;
}
/**
 * What the automated invite pipeline is currently doing with a resume, for display on the resume list.  Derived, never stored: `invited` wins over everything else because once a `Candidate` exists the pipeline will never reconsider the resume. `eligible_or_queued` covers both a resume the sender would still pick up and one already sitting in `AutomatedInviteQueue` waiting for its release time.
 * @export
 * @enum {string}
 */

export const AutomatedInviteState = {
  Preparing: "preparing",
  Blocked: "blocked",
  Invited: "invited",
  None: "none",
} as const;

export type AutomatedInviteState =
  (typeof AutomatedInviteState)[keyof typeof AutomatedInviteState];

/**
 * Automated-invite configuration and pause state shown on a position-list card.
 * @export
 * @interface AutomatedInviteSummary
 */
export interface AutomatedInviteSummary {
  /**
   *
   * @type {boolean}
   * @memberof AutomatedInviteSummary
   */
  configured: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AutomatedInviteSummary
   */
  paused: boolean;
}
/**
 *
 * @export
 * @interface BodyPatchEvaluationCheckpoint
 */
export interface BodyPatchEvaluationCheckpoint {
  /**
   *
   * @type {EvaluationCheckpointAction}
   * @memberof BodyPatchEvaluationCheckpoint
   */
  action: EvaluationCheckpointAction;
}

/**
 *
 * @export
 * @interface BodyPostAutomatedInviteExcludedStages
 */
export interface BodyPostAutomatedInviteExcludedStages {
  /**
   *
   * @type {Array<number>}
   * @memberof BodyPostAutomatedInviteExcludedStages
   */
  application_stage_ids: Array<number>;
}
/**
 *
 * @export
 * @interface BodyPostKomboActivate
 */
export interface BodyPostKomboActivate {
  /**
   *
   * @type {string}
   * @memberof BodyPostKomboActivate
   */
  activation_token: string;
}
/**
 *
 * @export
 * @interface BodyPostKomboInit
 */
export interface BodyPostKomboInit {
  /**
   *
   * @type {string}
   * @memberof BodyPostKomboInit
   */
  integration_tool?: string | null;
}
/**
 *
 * @export
 * @interface BodyPostPositionDuplicate
 */
export interface BodyPostPositionDuplicate {
  /**
   *
   * @type {string}
   * @memberof BodyPostPositionDuplicate
   */
  kombo_job_id?: string | null;
}
/**
 *
 * @export
 * @interface BodyPostResumeRejection
 */
export interface BodyPostResumeRejection {
  /**
   *
   * @type {string}
   * @memberof BodyPostResumeRejection
   */
  rejection_reason_id: string;
}
/**
 *
 * @export
 * @interface Call
 */
export interface Call {
  /**
   *
   * @type {string}
   * @memberof Call
   */
  call_id: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  agent_id: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  conversation_flow_id: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  from_number: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  to_number: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  call_status?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  disconnection_reason?: string | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof Call
   */
  call_analysis?: { [key: string]: any } | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  transcript?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  transcript_with_tool_calls?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  transcript_translation?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  recording_url?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  recording_multi_channel_url?: string | null;
  /**
   *
   * @type {number}
   * @memberof Call
   */
  duration_ms?: number | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  call_result: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  twilio_sid?: string | null;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  twilio_recording_url?: string | null;
  /**
   *
   * @type {number}
   * @memberof Call
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof Call
   */
  candidate_id: number;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof Call
   */
  transcript_object: string | null;
}
/**
 *
 * @export
 * @interface CallAnalysisResponse
 */
export interface CallAnalysisResponse {
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  pronunciation: string;
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  fluency: string;
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  grammar: string;
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  coherence: string;
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  vocab: string;
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  overall: string;
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof CallAnalysisResponse
   */
  updated_at: string;
}
/**
 *
 * @export
 * @interface CallInfo
 */
export interface CallInfo {
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  call_id: string;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  agent_id: string;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  conversation_flow_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  from_number?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  to_number?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  call_status?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  disconnection_reason?: string | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof CallInfo
   */
  call_analysis?: { [key: string]: any } | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  transcript?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  transcript_with_tool_calls?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  transcript_translation?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  recording_url?: string | null;
  /**
   *
   * @type {string}
   * @memberof CallInfo
   */
  recording_multi_channel_url?: string | null;
  /**
   *
   * @type {number}
   * @memberof CallInfo
   */
  duration_ms?: number | null;
}
/**
 *
 * @export
 * @interface CallSimulationJobResponse
 */
export interface CallSimulationJobResponse {
  /**
   *
   * @type {number}
   * @memberof CallSimulationJobResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof CallSimulationJobResponse
   */
  position_id: number;
  /**
   *
   * @type {CallSimulationJobStatus}
   * @memberof CallSimulationJobResponse
   */
  status: CallSimulationJobStatus;
  /**
   *
   * @type {SimulationReportRecipients}
   * @memberof CallSimulationJobResponse
   */
  report_recipients: SimulationReportRecipients;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof CallSimulationJobResponse
   */
  transcript: Array<{ [key: string]: any }> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CallSimulationJobResponse
   */
  quality_notes: Array<string> | null;
  /**
   *
   * @type {SimulationQuestionReviewResponse}
   * @memberof CallSimulationJobResponse
   */
  question_review: SimulationQuestionReviewResponse | null;
  /**
   *
   * @type {SimulationSettingsCoverageResponse}
   * @memberof CallSimulationJobResponse
   */
  settings_coverage: SimulationSettingsCoverageResponse | null;
  /**
   *
   * @type {string}
   * @memberof CallSimulationJobResponse
   */
  error_message: string | null;
  /**
   *
   * @type {string}
   * @memberof CallSimulationJobResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof CallSimulationJobResponse
   */
  updated_at: string;
  /**
   *
   * @type {string}
   * @memberof CallSimulationJobResponse
   */
  completed_at: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const CallSimulationJobStatus = {
  Pending: "pending",
  Running: "running",
  Evaluating: "evaluating",
  Complete: "complete",
  Failed: "failed",
} as const;

export type CallSimulationJobStatus =
  (typeof CallSimulationJobStatus)[keyof typeof CallSimulationJobStatus];

/**
 *
 * @export
 * @interface CallSimulationRequest
 */
export interface CallSimulationRequest {
  /**
   *
   * @type {SimulationReportRecipients}
   * @memberof CallSimulationRequest
   */
  report_recipients?: SimulationReportRecipients;
}

/**
 *
 * @export
 * @interface CallTestRequest
 */
export interface CallTestRequest {
  /**
   *
   * @type {string}
   * @memberof CallTestRequest
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CallTestRequest
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CallTestRequest
   */
  phone_number: string;
  /**
   *
   * @type {boolean}
   * @memberof CallTestRequest
   */
  save_evaluation?: boolean;
}
/**
 * We will use Pydantic\'s BaseModel because webhooks are not stored in the database.
 * @export
 * @interface CallWebhook
 */
export interface CallWebhook {
  /**
   *
   * @type {string}
   * @memberof CallWebhook
   */
  event: string;
  /**
   *
   * @type {CallInfo}
   * @memberof CallWebhook
   */
  call: CallInfo;
}
/**
 *
 * @export
 * @interface CandidateApplicationsResponse
 */
export interface CandidateApplicationsResponse {
  /**
   *
   * @type {string}
   * @memberof CandidateApplicationsResponse
   */
  position_title: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateApplicationsResponse
   */
  outcome: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateApplicationsResponse
   */
  current_stage: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateApplicationsResponse
   */
  rejection_reason_name: string | null;
}
/**
 *
 * @export
 * @interface CandidateBulkCreateResponse
 */
export interface CandidateBulkCreateResponse {
  /**
   *
   * @type {Array<CandidateFullResponse>}
   * @memberof CandidateBulkCreateResponse
   */
  candidates: Array<CandidateFullResponse>;
  /**
   *
   * @type {number}
   * @memberof CandidateBulkCreateResponse
   */
  created_count: number;
  /**
   *
   * @type {number}
   * @memberof CandidateBulkCreateResponse
   */
  skipped_count: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const CandidateCategory = {
  RequestForApproval: "request_for_approval",
  NeedFollowUp: "need_follow_up",
  InProcess: "in_process",
  Unqualified: "unqualified",
} as const;

export type CandidateCategory =
  (typeof CandidateCategory)[keyof typeof CandidateCategory];

/**
 *
 * @export
 * @enum {string}
 */

export const CandidateCautionReason = {
  SchedulingNotResponding: "scheduling_not_responding",
  WrongNumber: "wrong_number",
  ReschedulingNotResponding: "rescheduling_not_responding",
  UnknownReason: "unknown_reason",
  FollowUpRequired: "follow_up_required",
} as const;

export type CandidateCautionReason =
  (typeof CandidateCautionReason)[keyof typeof CandidateCautionReason];

/**
 *
 * @export
 * @interface CandidateDecisionRejectRequest
 */
export interface CandidateDecisionRejectRequest {
  /**
   *
   * @type {string}
   * @memberof CandidateDecisionRejectRequest
   */
  rejection_reason_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateDecisionRejectRequest
   */
  rejection_note?: string | null;
}
/**
 *
 * @export
 * @interface CandidateDecisionResponse
 */
export interface CandidateDecisionResponse {
  /**
   *
   * @type {string}
   * @memberof CandidateDecisionResponse
   */
  status: string;
}
/**
 *
 * @export
 * @interface CandidateFullResponse
 */
export interface CandidateFullResponse {
  /**
   *
   * @type {number}
   * @memberof CandidateFullResponse
   */
  resume_id: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  phone_number: string;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  sms_message: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  call_time: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateFullResponse
   */
  call_time_reminder_sent: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateFullResponse
   */
  withdrawn: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateFullResponse
   */
  archived: boolean | null;
  /**
   *
   * @type {number}
   * @memberof CandidateFullResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof CandidateFullResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  stage: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  last_message_time: string | null;
  /**
   *
   * @type {CandidateStatus}
   * @memberof CandidateFullResponse
   */
  status: CandidateStatus | null;
  /**
   *
   * @type {CandidateCautionReason}
   * @memberof CandidateFullResponse
   */
  caution_reason: CandidateCautionReason | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CandidateFullResponse
   */
  applying_positions: Array<string> | null;
  /**
   *
   * @type {number}
   * @memberof CandidateFullResponse
   */
  rank: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  evaluation_shared_at: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {CandidateCategory}
   * @memberof CandidateFullResponse
   */
  category: CandidateCategory | null;
  /**
   *
   * @type {EvaluationResponse}
   * @memberof CandidateFullResponse
   */
  evaluation: EvaluationResponse | null;
  /**
   *
   * @type {string}
   * @memberof CandidateFullResponse
   */
  screened_at: string | null;
  /**
   *
   * @type {HiringStageResponse}
   * @memberof CandidateFullResponse
   */
  hiring_stage: HiringStageResponse | null;
  /**
   *
   * @type {MessageDirection}
   * @memberof CandidateFullResponse
   */
  last_message_direction: MessageDirection | null;
}

/**
 *
 * @export
 * @interface CandidatePatchRequest
 */
export interface CandidatePatchRequest {
  /**
   *
   * @type {number}
   * @memberof CandidatePatchRequest
   */
  resume_id?: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidatePatchRequest
   */
  first_name?: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidatePatchRequest
   */
  last_name?: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidatePatchRequest
   */
  phone_number?: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidatePatchRequest
   */
  sms_message?: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidatePatchRequest
   */
  call_time?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidatePatchRequest
   */
  call_time_reminder_sent?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidatePatchRequest
   */
  withdrawn?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidatePatchRequest
   */
  archived?: boolean | null;
}
/**
 * Classification of a post-screening candidate reply.  ``None`` means no classification was recorded; ``UNCLASSIFIED`` means classification completed without a confident result.
 * @export
 * @enum {string}
 */

export const CandidateReplyCategory = {
  NeedsReply: "needs_reply",
  HumanRequested: "human_requested",
  SurveyResponse: "survey_response",
  NoReplyNeeded: "no_reply_needed",
  Unclassified: "unclassified",
} as const;

export type CandidateReplyCategory =
  (typeof CandidateReplyCategory)[keyof typeof CandidateReplyCategory];

/**
 *
 * @export
 * @interface CandidateRequest
 */
export interface CandidateRequest {
  /**
   *
   * @type {number}
   * @memberof CandidateRequest
   */
  resume_id?: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateRequest
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateRequest
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateRequest
   */
  phone_number: string;
  /**
   *
   * @type {string}
   * @memberof CandidateRequest
   */
  sms_message: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateRequest
   */
  call_time?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateRequest
   */
  call_time_reminder_sent?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateRequest
   */
  withdrawn?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateRequest
   */
  archived?: boolean | null;
}
/**
 *
 * @export
 * @interface CandidateResponse
 */
export interface CandidateResponse {
  /**
   *
   * @type {number}
   * @memberof CandidateResponse
   */
  resume_id: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  phone_number: string;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  sms_message: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  call_time: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateResponse
   */
  call_time_reminder_sent: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateResponse
   */
  withdrawn: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateResponse
   */
  archived: boolean | null;
  /**
   *
   * @type {number}
   * @memberof CandidateResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof CandidateResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  stage: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  last_message_time: string | null;
  /**
   *
   * @type {CandidateStatus}
   * @memberof CandidateResponse
   */
  status: CandidateStatus | null;
  /**
   *
   * @type {CandidateCautionReason}
   * @memberof CandidateResponse
   */
  caution_reason: CandidateCautionReason | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CandidateResponse
   */
  applying_positions: Array<string> | null;
  /**
   *
   * @type {number}
   * @memberof CandidateResponse
   */
  rank: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  evaluation_shared_at: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateResponse
   */
  remote_url: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const CandidateStatus = {
  NotDelivered: "not_delivered",
  Scheduling: "scheduling",
  Scheduled: "scheduled",
  Ongoing: "ongoing",
  Rescheduling: "rescheduling",
  Completed: "completed",
  NeedToContact: "need_to_contact",
  Withdrawn: "withdrawn",
} as const;

export type CandidateStatus =
  (typeof CandidateStatus)[keyof typeof CandidateStatus];

/**
 *
 * @export
 * @interface CandidateTimelineEntry
 */
export interface CandidateTimelineEntry {
  /**
   *
   * @type {number}
   * @memberof CandidateTimelineEntry
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof CandidateTimelineEntry
   */
  candidate_id?: number;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  from_number?: string;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  to_number?: string;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  message_sid?: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  status?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateTimelineEntry
   */
  is_manual?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CandidateTimelineEntry
   */
  resume_automation_after_send?: boolean;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  reason?: string | null;
  /**
   *
   * @type {number}
   * @memberof CandidateTimelineEntry
   */
  error_code?: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CandidateTimelineEntry
   */
  updated_at?: string;
  /**
   *
   * @type {boolean}
   * @memberof CandidateTimelineEntry
   */
  is_inbound: boolean;
  /**
   *
   * @type {CandidateTimelineEventKind}
   * @memberof CandidateTimelineEntry
   */
  event_kind?: CandidateTimelineEventKind;
}

/**
 * Discriminator for what the timeline entry represents. ``message`` is the default (a real SMS row); the other values are synthesized entries the chat merges in at read time. User-visible text for non-message kinds lives on the frontend so non-English orgs can localize without touching the backend.
 * @export
 * @enum {string}
 */

export const CandidateTimelineEventKind = {
  Message: "message",
  InboundCall: "inbound_call",
  InboundCallSystemError: "inbound_call_system_error",
} as const;

export type CandidateTimelineEventKind =
  (typeof CandidateTimelineEventKind)[keyof typeof CandidateTimelineEventKind];

/**
 * Candidate fields plus contact and automation controls for the GET/PATCH candidate endpoints.  Kept off `CandidateResponse` itself so `CandidateFullResponse` (the table/list path, which never populates it) doesn\'t inherit.
 * @export
 * @interface CandidateWithContactStatusResponse
 */
export interface CandidateWithContactStatusResponse {
  /**
   *
   * @type {number}
   * @memberof CandidateWithContactStatusResponse
   */
  resume_id: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  phone_number: string;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  sms_message: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  call_time: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateWithContactStatusResponse
   */
  call_time_reminder_sent: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateWithContactStatusResponse
   */
  withdrawn: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateWithContactStatusResponse
   */
  archived: boolean | null;
  /**
   *
   * @type {number}
   * @memberof CandidateWithContactStatusResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof CandidateWithContactStatusResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  stage: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  last_message_time: string | null;
  /**
   *
   * @type {CandidateStatus}
   * @memberof CandidateWithContactStatusResponse
   */
  status: CandidateStatus | null;
  /**
   *
   * @type {CandidateCautionReason}
   * @memberof CandidateWithContactStatusResponse
   */
  caution_reason: CandidateCautionReason | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CandidateWithContactStatusResponse
   */
  applying_positions: Array<string> | null;
  /**
   *
   * @type {number}
   * @memberof CandidateWithContactStatusResponse
   */
  rank: number | null;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  evaluation_shared_at: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {string}
   * @memberof CandidateWithContactStatusResponse
   */
  email_address: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CandidateWithContactStatusResponse
   */
  can_resume_automated_communication: boolean;
}

/**
 * The parts of a recruiter-facing email addressed to a relay address.
 * @export
 * @interface CommunicationRelayDraft
 */
export interface CommunicationRelayDraft {
  /**
   *
   * @type {string}
   * @memberof CommunicationRelayDraft
   */
  to_email: string;
  /**
   *
   * @type {string}
   * @memberof CommunicationRelayDraft
   */
  to_name: string;
  /**
   *
   * @type {string}
   * @memberof CommunicationRelayDraft
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof CommunicationRelayDraft
   */
  body: string;
}
/**
 * The draft a recruiter can send to reach one candidate through the relay.
 * @export
 * @interface CommunicationRelayDraftResponse
 */
export interface CommunicationRelayDraftResponse {
  /**
   *
   * @type {CommunicationRelayDraft}
   * @memberof CommunicationRelayDraftResponse
   */
  draft: CommunicationRelayDraft | null;
}
/**
 *
 * @export
 * @interface CompanyAnalysisRequest
 */
export interface CompanyAnalysisRequest {
  /**
   *
   * @type {string}
   * @memberof CompanyAnalysisRequest
   */
  company_url?: string | null;
}
/**
 *
 * @export
 * @interface CompanyAnalysisResponse
 */
export interface CompanyAnalysisResponse {
  /**
   *
   * @type {string}
   * @memberof CompanyAnalysisResponse
   */
  company_url: string | null;
  /**
   *
   * @type {number}
   * @memberof CompanyAnalysisResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof CompanyAnalysisResponse
   */
  company_id: number | null;
  /**
   *
   * @type {string}
   * @memberof CompanyAnalysisResponse
   */
  error_message: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyAnalysisResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof CompanyAnalysisResponse
   */
  updated_at: string;
  /**
   *
   * @type {string}
   * @memberof CompanyAnalysisResponse
   */
  user_id: string;
}
/**
 *
 * @export
 * @interface CompanyFaq
 */
export interface CompanyFaq {
  /**
   *
   * @type {string}
   * @memberof CompanyFaq
   */
  question: string;
  /**
   *
   * @type {string}
   * @memberof CompanyFaq
   */
  answer: string;
  /**
   *
   * @type {number}
   * @memberof CompanyFaq
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof CompanyFaq
   */
  company_id: number;
  /**
   *
   * @type {string}
   * @memberof CompanyFaq
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyFaq
   */
  updated_at?: string;
}
/**
 *
 * @export
 * @interface CompanyFaqRequest
 */
export interface CompanyFaqRequest {
  /**
   *
   * @type {string}
   * @memberof CompanyFaqRequest
   */
  question: string;
  /**
   *
   * @type {string}
   * @memberof CompanyFaqRequest
   */
  answer: string;
}
/**
 *
 * @export
 * @interface CompanyRequest
 */
export interface CompanyRequest {
  /**
   *
   * @type {string}
   * @memberof CompanyRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CompanyRequest
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CompanyRequest
   */
  culture?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CompanyRequest
   */
  is_default?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CompanyRequest
   */
  confirmed?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CompanyRequest
   */
  public_slug?: string | null;
}
/**
 *
 * @export
 * @interface CompanyResponse
 */
export interface CompanyResponse {
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  culture: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CompanyResponse
   */
  is_default: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CompanyResponse
   */
  confirmed: boolean | null;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  public_slug: string | null;
  /**
   *
   * @type {number}
   * @memberof CompanyResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  logo_file: string | null;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  updated_at: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  org_id: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  user_id: string;
  /**
   *
   * @type {string}
   * @memberof CompanyResponse
   */
  logo_url: string | null;
}
/**
 *
 * @export
 * @interface DailySummaryRecipientRequest
 */
export interface DailySummaryRecipientRequest {
  /**
   *
   * @type {string}
   * @memberof DailySummaryRecipientRequest
   */
  user_id: string;
}
/**
 *
 * @export
 * @interface DailySummaryRecipientResponse
 */
export interface DailySummaryRecipientResponse {
  /**
   *
   * @type {number}
   * @memberof DailySummaryRecipientResponse
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof DailySummaryRecipientResponse
   */
  subscription_id?: number;
  /**
   *
   * @type {string}
   * @memberof DailySummaryRecipientResponse
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof DailySummaryRecipientResponse
   */
  user_id: string;
}
/**
 * Why an SMS could not reach a candidate, classified from the last Twilio Lookup result and delivery error code.
 * @export
 * @enum {string}
 */

export const DeliveryFailureReason = {
  Landline: "landline",
  InvalidMobile: "invalid_mobile",
  RegionBlocked: "region_blocked",
  Inactive: "inactive",
  Unreachable: "unreachable",
  Unknown: "unknown",
} as const;

export type DeliveryFailureReason =
  (typeof DeliveryFailureReason)[keyof typeof DeliveryFailureReason];

/**
 *
 * @export
 * @enum {string}
 */

export const EmailRecommendationCategory = {
  HighlyRecommended: "highly_recommended",
  Recommended: "recommended",
  NotRecommended: "not_recommended",
} as const;

export type EmailRecommendationCategory =
  (typeof EmailRecommendationCategory)[keyof typeof EmailRecommendationCategory];

/**
 *
 * @export
 * @interface EvaluateCandidateBulkResponse
 */
export interface EvaluateCandidateBulkResponse {
  /**
   *
   * @type {number}
   * @memberof EvaluateCandidateBulkResponse
   */
  count: number | null;
}
/**
 *
 * @export
 * @interface EvaluateCandidateRequest
 */
export interface EvaluateCandidateRequest {
  /**
   *
   * @type {number}
   * @memberof EvaluateCandidateRequest
   */
  candidate_id: number;
}
/**
 * Client-facing view of a flagged evaluation, exposed only when `score` clears the threshold.
 * @export
 * @interface EvaluationAssistedAnswerFlagResponse
 */
export interface EvaluationAssistedAnswerFlagResponse {
  /**
   *
   * @type {number}
   * @memberof EvaluationAssistedAnswerFlagResponse
   */
  score: number;
  /**
   *
   * @type {number}
   * @memberof EvaluationAssistedAnswerFlagResponse
   */
  algorithm_version: number;
  /**
   *
   * @type {AssistedAnswerFlagSignals}
   * @memberof EvaluationAssistedAnswerFlagResponse
   */
  signals: AssistedAnswerFlagSignals;
  /**
   *
   * @type {Array<AssistedAnswerFlagTemplateExample>}
   * @memberof EvaluationAssistedAnswerFlagResponse
   */
  template_examples: Array<AssistedAnswerFlagTemplateExample>;
  /**
   *
   * @type {Array<number>}
   * @memberof EvaluationAssistedAnswerFlagResponse
   */
  template_timestamps_seconds: Array<number>;
  /**
   *
   * @type {AssistedAnswerFlagEchoExample}
   * @memberof EvaluationAssistedAnswerFlagResponse
   */
  echo_example: AssistedAnswerFlagEchoExample | null;
  /**
   *
   * @type {Array<AssistedAnswerFlagReadingError>}
   * @memberof EvaluationAssistedAnswerFlagResponse
   */
  reading_errors: Array<AssistedAnswerFlagReadingError>;
}
/**
 *
 * @export
 * @interface EvaluationCandidateInterestResponse
 */
export interface EvaluationCandidateInterestResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationCandidateInterestResponse
   */
  attraction: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationCandidateInterestResponse
   */
  career_fit: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationCandidateInterestResponse
   */
  job_search_context: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationCandidateInterestResponse
   */
  workplace_preferences: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationCandidateInterestResponse
   */
  open_to_alternatives: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationCandidateInterestResponse
   */
  concerns: string | null;
}
/**
 *
 * @export
 * @interface EvaluationCareerHistoryResponse
 */
export interface EvaluationCareerHistoryResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationCareerHistoryResponse
   */
  career_summary: string;
}
/**
 *
 * @export
 * @interface EvaluationChatRequest
 */
export interface EvaluationChatRequest {
  /**
   *
   * @type {string}
   * @memberof EvaluationChatRequest
   */
  message: string;
}
/**
 *
 * @export
 * @interface EvaluationChatResponse
 */
export interface EvaluationChatResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationChatResponse
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof EvaluationChatResponse
   */
  id: number | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationChatResponse
   */
  user_id: string;
  /**
   *
   * @type {boolean}
   * @memberof EvaluationChatResponse
   */
  is_human: boolean;
  /**
   *
   * @type {string}
   * @memberof EvaluationChatResponse
   */
  created_at: string;
  /**
   *
   * @type {number}
   * @memberof EvaluationChatResponse
   */
  evaluation_id: number | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const EvaluationCheckpointAction = {
  Accepted: "accepted",
  Onhold: "onhold",
  Denied: "denied",
} as const;

export type EvaluationCheckpointAction =
  (typeof EvaluationCheckpointAction)[keyof typeof EvaluationCheckpointAction];

/**
 *
 * @export
 * @interface EvaluationCheckpointResponse
 */
export interface EvaluationCheckpointResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationCheckpointResponse
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationCheckpointResponse
   */
  decision: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationCheckpointResponse
   */
  context: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationCheckpointResponse
   */
  suggestion: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationCheckpointResponse
   */
  action: string | null;
  /**
   *
   * @type {number}
   * @memberof EvaluationCheckpointResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof EvaluationCheckpointResponse
   */
  evaluation_id: number;
  /**
   *
   * @type {string}
   * @memberof EvaluationCheckpointResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationCheckpointResponse
   */
  updated_at: string;
}
/**
 *
 * @export
 * @interface EvaluationEmailRecipient
 */
export interface EvaluationEmailRecipient {
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailRecipient
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailRecipient
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailRecipient
   */
  last_name: string;
  /**
   *
   * @type {Array<EmailRecommendationCategory>}
   * @memberof EvaluationEmailRecipient
   */
  conditions?: Array<EmailRecommendationCategory> | null;
  /**
   *
   * @type {boolean}
   * @memberof EvaluationEmailRecipient
   */
  attach_resume_if_available?: boolean;
  /**
   *
   * @type {number}
   * @memberof EvaluationEmailRecipient
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof EvaluationEmailRecipient
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailRecipient
   */
  created_at?: string;
}
/**
 *
 * @export
 * @interface EvaluationEmailRecipientRequest
 */
export interface EvaluationEmailRecipientRequest {
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailRecipientRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailRecipientRequest
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailRecipientRequest
   */
  last_name: string;
  /**
   *
   * @type {Array<EmailRecommendationCategory>}
   * @memberof EvaluationEmailRecipientRequest
   */
  conditions?: Array<EmailRecommendationCategory> | null;
  /**
   *
   * @type {boolean}
   * @memberof EvaluationEmailRecipientRequest
   */
  attach_resume_if_available?: boolean;
}
/**
 *
 * @export
 * @interface EvaluationEmailSettingRequest
 */
export interface EvaluationEmailSettingRequest {
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailSettingRequest
   */
  opening_text: string | null;
}
/**
 *
 * @export
 * @interface EvaluationEmailSettingResponse
 */
export interface EvaluationEmailSettingResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationEmailSettingResponse
   */
  opening_text: string | null;
}
/**
 *
 * @export
 * @interface EvaluationFullResponse
 */
export interface EvaluationFullResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  recommendation: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  qualification_recommendation: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  contextual_recommendation: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  overall_message: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  profile_summary: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  reason_summary: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  next_step_summary: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  error_message: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  exported_at: string | null;
  /**
   *
   * @type {number}
   * @memberof EvaluationFullResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof EvaluationFullResponse
   */
  call_id: number;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationFullResponse
   */
  updated_at: string;
  /**
   *
   * @type {EvaluationAssistedAnswerFlagResponse}
   * @memberof EvaluationFullResponse
   */
  assisted_answer_flag: EvaluationAssistedAnswerFlagResponse | null;
  /**
   *
   * @type {Array<EvaluationCheckpointResponse>}
   * @memberof EvaluationFullResponse
   */
  evaluation_checkpoints: Array<EvaluationCheckpointResponse>;
  /**
   *
   * @type {Array<EvaluationItemResponse>}
   * @memberof EvaluationFullResponse
   */
  evaluation_items: Array<EvaluationItemResponse>;
  /**
   *
   * @type {Array<EvaluationNextStepResponse>}
   * @memberof EvaluationFullResponse
   */
  evaluation_next_steps: Array<EvaluationNextStepResponse>;
  /**
   *
   * @type {EvaluationCareerHistoryResponse}
   * @memberof EvaluationFullResponse
   */
  evaluation_career_history: EvaluationCareerHistoryResponse | null;
  /**
   *
   * @type {EvaluationCandidateInterestResponse}
   * @memberof EvaluationFullResponse
   */
  evaluation_candidate_interest: EvaluationCandidateInterestResponse | null;
  /**
   *
   * @type {EvaluationPreviousEmploymentResponse}
   * @memberof EvaluationFullResponse
   */
  evaluation_previous_employment: EvaluationPreviousEmploymentResponse | null;
  /**
   *
   * @type {EvaluationNextAvailabilityResponse}
   * @memberof EvaluationFullResponse
   */
  evaluation_next_availability: EvaluationNextAvailabilityResponse | null;
}
/**
 *
 * @export
 * @interface EvaluationItemResponse
 */
export interface EvaluationItemResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  short_title: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  category: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  question_type: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  confirmation_answer: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  decision: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  rating: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  rationale: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  evidence_transcript: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  evidence_resume: string | null;
  /**
   *
   * @type {number}
   * @memberof EvaluationItemResponse
   */
  order: number;
  /**
   *
   * @type {number}
   * @memberof EvaluationItemResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof EvaluationItemResponse
   */
  evaluation_id: number;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationItemResponse
   */
  updated_at: string;
}
/**
 * Client-facing view of an evaluation\'s next-interview-availability extraction.  ``status`` is passed through as the raw stored string (see ``NextAvailabilityStatus``); an unrecognized value is left for the client to treat as \"not assessed\" rather than raising here.
 * @export
 * @interface EvaluationNextAvailabilityResponse
 */
export interface EvaluationNextAvailabilityResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationNextAvailabilityResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationNextAvailabilityResponse
   */
  answer: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationNextAvailabilityResponse
   */
  said_at?: string | null;
}
/**
 *
 * @export
 * @interface EvaluationNextStepResponse
 */
export interface EvaluationNextStepResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationNextStepResponse
   */
  category: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationNextStepResponse
   */
  recommendation: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationNextStepResponse
   */
  sample_question: string;
}
/**
 *
 * @export
 * @interface EvaluationPreviousEmploymentResponse
 */
export interface EvaluationPreviousEmploymentResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationPreviousEmploymentResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationPreviousEmploymentResponse
   */
  summary: string | null;
}
/**
 *
 * @export
 * @interface EvaluationRecipientRequest
 */
export interface EvaluationRecipientRequest {
  /**
   *
   * @type {string}
   * @memberof EvaluationRecipientRequest
   */
  email: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationRecipientRequest
   */
  first_name: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationRecipientRequest
   */
  last_name: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationRecipientRequest
   */
  custom_note: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EvaluationRecipientRequest
   */
  attach_resume_if_available?: boolean;
}
/**
 *
 * @export
 * @interface EvaluationRecipientResponse
 */
export interface EvaluationRecipientResponse {
  /**
   *
   * @type {Array<EvaluationRecipientRequest>}
   * @memberof EvaluationRecipientResponse
   */
  recipients: Array<EvaluationRecipientRequest>;
  /**
   *
   * @type {string}
   * @memberof EvaluationRecipientResponse
   */
  created_at: string;
}
/**
 *
 * @export
 * @interface EvaluationResponse
 */
export interface EvaluationResponse {
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  recommendation: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  qualification_recommendation: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  contextual_recommendation: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  overall_message: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  profile_summary: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  reason_summary: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  next_step_summary: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  error_message: string | null;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  exported_at: string | null;
  /**
   *
   * @type {number}
   * @memberof EvaluationResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof EvaluationResponse
   */
  call_id: number;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof EvaluationResponse
   */
  updated_at: string;
  /**
   *
   * @type {EvaluationAssistedAnswerFlagResponse}
   * @memberof EvaluationResponse
   */
  assisted_answer_flag: EvaluationAssistedAnswerFlagResponse | null;
}
/**
 *
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
  /**
   *
   * @type {Array<ValidationError>}
   * @memberof HTTPValidationError
   */
  detail?: Array<ValidationError>;
}
/**
 * One turn of the Ask sidebar conversation, replayed in full on every request since the service holds no state.
 * @export
 * @interface HelpCenterChatMessage
 */
export interface HelpCenterChatMessage {
  /**
   *
   * @type {string}
   * @memberof HelpCenterChatMessage
   */
  message: string;
  /**
   *
   * @type {boolean}
   * @memberof HelpCenterChatMessage
   */
  is_human: boolean;
}
/**
 * One Help Center doc page, as the frontend\'s `searchIndex` (see `data/help-center/search-index.ts`) represents it.
 * @export
 * @interface HelpCenterChatPassage
 */
export interface HelpCenterChatPassage {
  /**
   *
   * @type {string}
   * @memberof HelpCenterChatPassage
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof HelpCenterChatPassage
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof HelpCenterChatPassage
   */
  section_label: string;
  /**
   *
   * @type {string}
   * @memberof HelpCenterChatPassage
   */
  body: string;
}
/**
 *
 * @export
 * @interface HelpCenterChatRequest
 */
export interface HelpCenterChatRequest {
  /**
   *
   * @type {Array<HelpCenterChatMessage>}
   * @memberof HelpCenterChatRequest
   */
  messages: Array<HelpCenterChatMessage>;
  /**
   *
   * @type {Array<HelpCenterChatPassage>}
   * @memberof HelpCenterChatRequest
   */
  passages: Array<HelpCenterChatPassage>;
}
/**
 *
 * @export
 * @interface HelpCenterChatResponse
 */
export interface HelpCenterChatResponse {
  /**
   *
   * @type {string}
   * @memberof HelpCenterChatResponse
   */
  message: string;
  /**
   *
   * @type {Array<string>}
   * @memberof HelpCenterChatResponse
   */
  source_slugs: Array<string>;
}
/**
 * Post-screening hiring-pipeline state shown on a position-list card.
 * @export
 * @interface HiringPipelineSummary
 */
export interface HiringPipelineSummary {
  /**
   *
   * @type {number}
   * @memberof HiringPipelineSummary
   */
  in_process_count: number;
  /**
   *
   * @type {number}
   * @memberof HiringPipelineSummary
   */
  hired_count: number;
  /**
   *
   * @type {boolean}
   * @memberof HiringPipelineSummary
   */
  in_process_awaiting_reply: boolean;
}
/**
 * Where a candidate sits in the post-screening hiring funnel.  Derived, never stored: a pure function of the ``CandidateHiringStage`` columns plus today\'s date, so ``onboarding`` flips on by itself as the start date nears (see ``onboarding_lead``). Distinct from ``CandidateCategory`` and from ``CandidateResponse.stage`` (the ATS\'s own stage string).
 * @export
 * @enum {string}
 */

export const HiringStage = {
  InProcess: "in_process",
  Offer: "offer",
  Hire: "hire",
  Onboarding: "onboarding",
} as const;

export type HiringStage = (typeof HiringStage)[keyof typeof HiringStage];

/**
 * One row of the org-wide hiring-stage listing: a hiring-stage row plus the candidate and position it belongs to.  The position page reads the same facts off ``CandidateFullResponse``, which already knows whose position it is showing. This listing spans every position the caller can edit, so each row has to name its own candidate and position — that context is the whole difference between the two shapes.
 * @export
 * @interface HiringStageListItemResponse
 */
export interface HiringStageListItemResponse {
  /**
   *
   * @type {HiringStage}
   * @memberof HiringStageListItemResponse
   */
  stage: HiringStage;
  /**
   *
   * @type {string}
   * @memberof HiringStageListItemResponse
   */
  in_process_at: string | null;
  /**
   *
   * @type {number}
   * @memberof HiringStageListItemResponse
   */
  offer_salary_usd: number | null;
  /**
   *
   * @type {string}
   * @memberof HiringStageListItemResponse
   */
  offered_on: string | null;
  /**
   *
   * @type {string}
   * @memberof HiringStageListItemResponse
   */
  accepted_at: string | null;
  /**
   *
   * @type {string}
   * @memberof HiringStageListItemResponse
   */
  start_date: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HiringStageListItemResponse
   */
  tracked: boolean;
  /**
   *
   * @type {number}
   * @memberof HiringStageListItemResponse
   */
  candidate_id: number;
  /**
   *
   * @type {string}
   * @memberof HiringStageListItemResponse
   */
  candidate_name: string;
  /**
   *
   * @type {number}
   * @memberof HiringStageListItemResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof HiringStageListItemResponse
   */
  position_title: string | null;
}

/**
 * The whole offer as the recruiter\'s modal submits it — a full replacement, not a patch.  Every field is sent on every write, so a cleared start date arrives as an explicit ``null`` instead of being indistinguishable from \"unchanged\". ``accepted`` is the boolean the modal shows; the server owns the instant it happened (``accepted_at``), which is why acceptance is not a timestamp here.
 * @export
 * @interface HiringStageOfferRequest
 */
export interface HiringStageOfferRequest {
  /**
   *
   * @type {number}
   * @memberof HiringStageOfferRequest
   */
  offer_salary_usd?: number | null;
  /**
   *
   * @type {string}
   * @memberof HiringStageOfferRequest
   */
  offered_on: string;
  /**
   *
   * @type {boolean}
   * @memberof HiringStageOfferRequest
   */
  accepted: boolean;
  /**
   *
   * @type {string}
   * @memberof HiringStageOfferRequest
   */
  start_date?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HiringStageOfferRequest
   */
  tracked?: boolean | null;
}
/**
 * The hiring stage as the candidate list exposes it, with the derived stage resolved server-side.  Only the recruiter-visible state; the audit columns (``created_by`` / timestamps) stay internal.
 * @export
 * @interface HiringStageResponse
 */
export interface HiringStageResponse {
  /**
   *
   * @type {HiringStage}
   * @memberof HiringStageResponse
   */
  stage: HiringStage;
  /**
   *
   * @type {string}
   * @memberof HiringStageResponse
   */
  in_process_at: string | null;
  /**
   *
   * @type {number}
   * @memberof HiringStageResponse
   */
  offer_salary_usd: number | null;
  /**
   *
   * @type {string}
   * @memberof HiringStageResponse
   */
  offered_on: string | null;
  /**
   *
   * @type {string}
   * @memberof HiringStageResponse
   */
  accepted_at: string | null;
  /**
   *
   * @type {string}
   * @memberof HiringStageResponse
   */
  start_date: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HiringStageResponse
   */
  tracked: boolean;
}

/**
 * The tracking flag on its own, for the badge toggle in the candidate row.  Separate from ``HiringStageOfferRequest`` because tracking is settable at every stage: an In Process candidate has no offer to replace, and an Onboarding one is past the point where ``record_offer`` accepts anything at all.
 * @export
 * @interface HiringStageTrackedRequest
 */
export interface HiringStageTrackedRequest {
  /**
   *
   * @type {boolean}
   * @memberof HiringStageTrackedRequest
   */
  tracked: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IntegrationProviderEnum = {
  Adpworkforcenow: "adpworkforcenow",
  Ashby: "ashby",
  Bamboohr: "bamboohr",
  Bullhorn: "bullhorn",
  Dayforce: "dayforce",
  Greenhouse: "greenhouse",
  Fountain: "fountain",
  Icims: "icims",
  Lever: "lever",
  Recruitee: "recruitee",
  Successfactors: "successfactors",
  Ukgpro: "ukgpro",
  Teamtailor: "teamtailor",
  Workable: "workable",
  Workday: "workday",
} as const;

export type IntegrationProviderEnum =
  (typeof IntegrationProviderEnum)[keyof typeof IntegrationProviderEnum];

/**
 *
 * @export
 * @interface IntegrationRequest
 */
export interface IntegrationRequest {
  /**
   *
   * @type {string}
   * @memberof IntegrationRequest
   */
  provider: string;
  /**
   *
   * @type {string}
   * @memberof IntegrationRequest
   */
  payload: string;
}
/**
 *
 * @export
 * @interface IntegrationResponse
 */
export interface IntegrationResponse {
  /**
   *
   * @type {number}
   * @memberof IntegrationResponse
   */
  id: number;
  /**
   *
   * @type {IntegrationProviderEnum}
   * @memberof IntegrationResponse
   */
  provider: IntegrationProviderEnum;
}

/**
 * Current state of one position, resume, or candidate ATS sync.
 * @export
 * @interface IntegrationSyncStatusResponse
 */
export interface IntegrationSyncStatusResponse {
  /**
   *
   * @type {SyncType}
   * @memberof IntegrationSyncStatusResponse
   */
  sync_type: SyncType;
  /**
   *
   * @type {number}
   * @memberof IntegrationSyncStatusResponse
   */
  position_id: number | null;
  /**
   *
   * @type {number}
   * @memberof IntegrationSyncStatusResponse
   */
  sync_result_id: number | null;
  /**
   *
   * @type {SyncResultStatus}
   * @memberof IntegrationSyncStatusResponse
   */
  status: SyncResultStatus;
}

/**
 *
 * @export
 * @interface InvitationSlotsResponse
 */
export interface InvitationSlotsResponse {
  /**
   *
   * @type {number}
   * @memberof InvitationSlotsResponse
   */
  available_slots: number;
  /**
   *
   * @type {number}
   * @memberof InvitationSlotsResponse
   */
  completed_count: number;
  /**
   *
   * @type {number}
   * @memberof InvitationSlotsResponse
   */
  active_count: number;
  /**
   *
   * @type {number}
   * @memberof InvitationSlotsResponse
   */
  position_id: number;
}
/**
 *
 * @export
 * @interface JobAnalysisRequest
 */
export interface JobAnalysisRequest {
  /**
   *
   * @type {number}
   * @memberof JobAnalysisRequest
   */
  company_id: number;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisRequest
   */
  kombo_job_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisRequest
   */
  job_description_url?: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisRequest
   */
  file_hash?: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisRequest
   */
  retell_call_id?: string | null;
}
/**
 *
 * @export
 * @interface JobAnalysisResponse
 */
export interface JobAnalysisResponse {
  /**
   *
   * @type {number}
   * @memberof JobAnalysisResponse
   */
  company_id: number;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  kombo_job_id: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  job_description_url: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  file_hash: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  retell_call_id: string | null;
  /**
   *
   * @type {number}
   * @memberof JobAnalysisResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof JobAnalysisResponse
   */
  position_id: number | null;
  /**
   *
   * @type {JobAnalysisStage}
   * @memberof JobAnalysisResponse
   */
  stage: JobAnalysisStage;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  error_message: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  openai_file_id: string | null;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof JobAnalysisResponse
   */
  updated_at: string;
}

/**
 * Processing stages of a job analysis, declared in the order they are reached.
 * @export
 * @enum {string}
 */

export const JobAnalysisStage = {
  Queued: "queued",
  FetchingJob: "fetching_job",
  ReadingJob: "reading_job",
  GeneratingCriteria: "generating_criteria",
  Verifying: "verifying",
  Saving: "saving",
} as const;

export type JobAnalysisStage =
  (typeof JobAnalysisStage)[keyof typeof JobAnalysisStage];

/**
 *
 * @export
 * @interface JobBoardBoostAnchor
 */
export interface JobBoardBoostAnchor {
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostAnchor
   */
  amount_cents: number;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostAnchor
   */
  applicants_low: number;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostAnchor
   */
  applicants_high: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const JobBoardBoostAvailability = {
  Available: "available",
  Unknown: "unknown",
} as const;

export type JobBoardBoostAvailability =
  (typeof JobBoardBoostAvailability)[keyof typeof JobBoardBoostAvailability];

/**
 * Structured allocation stance; customer-facing copy and currency formatting belong to the client.
 * @export
 * @interface JobBoardBoostCallout
 */
export interface JobBoardBoostCallout {
  /**
   *
   * @type {JobBoardBoostCalloutStrategy}
   * @memberof JobBoardBoostCallout
   */
  strategy: JobBoardBoostCalloutStrategy;
  /**
   *
   * @type {JobBoardBoostPlatform}
   * @memberof JobBoardBoostCallout
   */
  primary_platform?: JobBoardBoostPlatform | null;
  /**
   *
   * @type {JobBoardBoostCalloutReason}
   * @memberof JobBoardBoostCallout
   */
  reason: JobBoardBoostCalloutReason;
}

/**
 * Reasons the client can render without model-authored copy.
 * @export
 * @enum {string}
 */

export const JobBoardBoostCalloutReason = {
  StrongestMarketSignal: "strongest_market_signal",
  HighestApplicantVolume: "highest_applicant_volume",
  LowestCostPerApplicant: "lowest_cost_per_applicant",
  BroadestReach: "broadest_reach",
  BalancedCoverage: "balanced_coverage",
  NoReliableMarketData: "no_reliable_market_data",
} as const;

export type JobBoardBoostCalloutReason =
  (typeof JobBoardBoostCalloutReason)[keyof typeof JobBoardBoostCalloutReason];

/**
 *
 * @export
 * @enum {string}
 */

export const JobBoardBoostCalloutStrategy = {
  Concentrate: "concentrate",
  Split: "split",
  None: "none",
} as const;

export type JobBoardBoostCalloutStrategy =
  (typeof JobBoardBoostCalloutStrategy)[keyof typeof JobBoardBoostCalloutStrategy];

/**
 *
 * @export
 * @interface JobBoardBoostCheckoutConfirmResponse
 */
export interface JobBoardBoostCheckoutConfirmResponse {
  /**
   *
   * @type {JobBoardBoostCheckoutStatus}
   * @memberof JobBoardBoostCheckoutConfirmResponse
   */
  checkout_status: JobBoardBoostCheckoutStatus;
}

/**
 *
 * @export
 * @interface JobBoardBoostCheckoutPlatformAmount
 */
export interface JobBoardBoostCheckoutPlatformAmount {
  /**
   *
   * @type {JobBoardBoostPlatform}
   * @memberof JobBoardBoostCheckoutPlatformAmount
   */
  platform: JobBoardBoostPlatform;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostCheckoutPlatformAmount
   */
  amount_cents: number;
}

/**
 *
 * @export
 * @interface JobBoardBoostCheckoutRequest
 */
export interface JobBoardBoostCheckoutRequest {
  /**
   *
   * @type {Array<JobBoardBoostCheckoutPlatformAmount>}
   * @memberof JobBoardBoostCheckoutRequest
   */
  platforms: Array<JobBoardBoostCheckoutPlatformAmount>;
  /**
   *
   * @type {string}
   * @memberof JobBoardBoostCheckoutRequest
   */
  request_uuid: string;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostCheckoutRequest
   */
  recommendation_id?: number | null;
}
/**
 *
 * @export
 * @interface JobBoardBoostCheckoutResponse
 */
export interface JobBoardBoostCheckoutResponse {
  /**
   *
   * @type {string}
   * @memberof JobBoardBoostCheckoutResponse
   */
  checkout_url: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const JobBoardBoostCheckoutStatus = {
  CheckoutPending: "checkout_pending",
  Paid: "paid",
  CheckoutExpired: "checkout_expired",
  PaymentFailed: "payment_failed",
} as const;

export type JobBoardBoostCheckoutStatus =
  (typeof JobBoardBoostCheckoutStatus)[keyof typeof JobBoardBoostCheckoutStatus];

/**
 *
 * @export
 * @enum {string}
 */

export const JobBoardBoostDisplayStatus = {
  PaidPending: "paid_pending",
  Live: "live",
  Expired: "expired",
  ReconciliationRequired: "reconciliation_required",
} as const;

export type JobBoardBoostDisplayStatus =
  (typeof JobBoardBoostDisplayStatus)[keyof typeof JobBoardBoostDisplayStatus];

/**
 *
 * @export
 * @enum {string}
 */

export const JobBoardBoostPlatform = {
  Linkedin: "linkedin",
  Indeed: "indeed",
  Ziprecruiter: "ziprecruiter",
} as const;

export type JobBoardBoostPlatform =
  (typeof JobBoardBoostPlatform)[keyof typeof JobBoardBoostPlatform];

/**
 *
 * @export
 * @interface JobBoardBoostPlatformRecommendation
 */
export interface JobBoardBoostPlatformRecommendation {
  /**
   *
   * @type {JobBoardBoostPlatform}
   * @memberof JobBoardBoostPlatformRecommendation
   */
  platform: JobBoardBoostPlatform;
  /**
   *
   * @type {JobBoardBoostAvailability}
   * @memberof JobBoardBoostPlatformRecommendation
   */
  availability: JobBoardBoostAvailability;
  /**
   *
   * @type {JobBoardBoostUnavailableReason}
   * @memberof JobBoardBoostPlatformRecommendation
   */
  unavailable_reason?: JobBoardBoostUnavailableReason | null;
  /**
   *
   * @type {Array<JobBoardBoostAnchor>}
   * @memberof JobBoardBoostPlatformRecommendation
   */
  anchors?: Array<JobBoardBoostAnchor>;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostPlatformRecommendation
   */
  saturation_amount_cents?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof JobBoardBoostPlatformRecommendation
   */
  recommended?: boolean;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostPlatformRecommendation
   */
  recommended_amount_cents?: number | null;
}

/**
 *
 * @export
 * @interface JobBoardBoostRecommendationRequest
 */
export interface JobBoardBoostRecommendationRequest {
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostRecommendationRequest
   */
  budget_cents: number;
}
/**
 *
 * @export
 * @interface JobBoardBoostRecommendationResponse
 */
export interface JobBoardBoostRecommendationResponse {
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostRecommendationResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof JobBoardBoostRecommendationResponse
   */
  generated_at: string;
  /**
   *
   * @type {boolean}
   * @memberof JobBoardBoostRecommendationResponse
   */
  stale: boolean;
  /**
   *
   * @type {Array<JobBoardBoostPlatformRecommendation>}
   * @memberof JobBoardBoostRecommendationResponse
   */
  platforms: Array<JobBoardBoostPlatformRecommendation>;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostRecommendationResponse
   */
  split_threshold_cents: number | null;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostRecommendationResponse
   */
  recommended_budget_cents: number;
  /**
   *
   * @type {JobBoardBoostCallout}
   * @memberof JobBoardBoostRecommendationResponse
   */
  callout: JobBoardBoostCallout;
}
/**
 * A position\'s current boost status derived from its latest paid order.
 * @export
 * @interface JobBoardBoostSummary
 */
export interface JobBoardBoostSummary {
  /**
   *
   * @type {JobBoardBoostDisplayStatus}
   * @memberof JobBoardBoostSummary
   */
  status: JobBoardBoostDisplayStatus;
  /**
   *
   * @type {Array<JobBoardBoostCheckoutPlatformAmount>}
   * @memberof JobBoardBoostSummary
   */
  platforms: Array<JobBoardBoostCheckoutPlatformAmount>;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostSummary
   */
  total_amount_cents: number;
  /**
   *
   * @type {number}
   * @memberof JobBoardBoostSummary
   */
  day_of_boost?: number | null;
  /**
   *
   * @type {string}
   * @memberof JobBoardBoostSummary
   */
  ends_on?: string | null;
  /**
   *
   * @type {string}
   * @memberof JobBoardBoostSummary
   */
  ended_on?: string | null;
}

/**
 * Server-renderable reasons why a platform estimate is unavailable.
 * @export
 * @enum {string}
 */

export const JobBoardBoostUnavailableReason = {
  InsufficientMarketData: "insufficient_market_data",
  UnsupportedLocation: "unsupported_location",
  LowPlatformRelevance: "low_platform_relevance",
} as const;

export type JobBoardBoostUnavailableReason =
  (typeof JobBoardBoostUnavailableReason)[keyof typeof JobBoardBoostUnavailableReason];

/**
 *
 * @export
 * @interface KomboApplicationStage
 */
export interface KomboApplicationStage {
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStage
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStage
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStage
   */
  kombo_stage_id: string;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStage
   */
  remote_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStage
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStage
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStage
   */
  updated_at?: string;
}
/**
 *
 * @export
 * @interface KomboApplicationStageTransitionDefaultResponse
 */
export interface KomboApplicationStageTransitionDefaultResponse {
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  subscription_id?: number;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  event?: string;
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  application_stage_id?: number | null;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  rejection_reason_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionDefaultResponse
   */
  application_stage_name: string | null;
}
/**
 *
 * @export
 * @interface KomboApplicationStageTransitionRequest
 */
export interface KomboApplicationStageTransitionRequest {
  /**
   *
   * @type {StageTransitionEvent}
   * @memberof KomboApplicationStageTransitionRequest
   */
  event: StageTransitionEvent;
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStageTransitionRequest
   */
  application_stage_id: number | null;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionRequest
   */
  rejection_reason_id: string | null;
}

/**
 *
 * @export
 * @interface KomboApplicationStageTransitionResponse
 */
export interface KomboApplicationStageTransitionResponse {
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStageTransitionResponse
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStageTransitionResponse
   */
  position_id?: number;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionResponse
   */
  event?: string;
  /**
   *
   * @type {number}
   * @memberof KomboApplicationStageTransitionResponse
   */
  application_stage_id?: number | null;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionResponse
   */
  rejection_reason_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionResponse
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionResponse
   */
  updated_at?: string;
  /**
   *
   * @type {string}
   * @memberof KomboApplicationStageTransitionResponse
   */
  application_stage_name: string | null;
}
/**
 *
 * @export
 * @interface KomboDataChangedData
 */
export interface KomboDataChangedData {
  /**
   *
   * @type {string}
   * @memberof KomboDataChangedData
   */
  integration_id?: string | null;
}
/**
 * Kombo\'s ``*.data-changed`` notification (the modern successor to ``sync-finished``).  It only says \"some model changed for this integration\" (thin, 30s-debounced, no ordering guarantees), so we react by re-syncing the affected integration to pick up the change — including offer-stage transitions — faster than the periodic poll.
 * @export
 * @interface KomboDataChangedWebhook
 */
export interface KomboDataChangedWebhook {
  /**
   *
   * @type {string}
   * @memberof KomboDataChangedWebhook
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboDataChangedWebhook
   */
  type?: string | null;
  /**
   *
   * @type {KomboDataChangedData}
   * @memberof KomboDataChangedWebhook
   */
  data: KomboDataChangedData;
}
/**
 *
 * @export
 * @interface KomboJobState
 */
export interface KomboJobState {
  /**
   *
   * @type {number}
   * @memberof KomboJobState
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof KomboJobState
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  kombo_job_id: string;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  remote_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  location?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  job_code?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  status?: string | null;
  /**
   *
   * @type {KomboJobVisibility}
   * @memberof KomboJobState
   */
  visibility?: KomboJobVisibility | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  post_url?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  remote_url?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  opened_at?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  remote_deleted_at?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  remote_created_at?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof KomboJobState
   */
  updated_at?: string;
}

/**
 * Normalized visibility of an ATS job.
 * @export
 * @enum {string}
 */

export const KomboJobVisibility = {
  Public: "PUBLIC",
  Internal: "INTERNAL",
  Unlisted: "UNLISTED",
  Confidential: "CONFIDENTIAL",
} as const;

export type KomboJobVisibility =
  (typeof KomboJobVisibility)[keyof typeof KomboJobVisibility];

/**
 *
 * @export
 * @interface KomboRejectionReason
 */
export interface KomboRejectionReason {
  /**
   *
   * @type {string}
   * @memberof KomboRejectionReason
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof KomboRejectionReason
   */
  remote_id: string;
  /**
   *
   * @type {string}
   * @memberof KomboRejectionReason
   */
  name: string;
}
/**
 *
 * @export
 * @interface KomboSyncData
 */
export interface KomboSyncData {
  /**
   *
   * @type {string}
   * @memberof KomboSyncData
   */
  sync_id?: string | null;
  /**
   *
   * @type {KomboSyncState}
   * @memberof KomboSyncData
   */
  sync_state?: KomboSyncState | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncData
   */
  sync_started_at?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncData
   */
  sync_ended_at?: string | null;
  /**
   *
   * @type {number}
   * @memberof KomboSyncData
   */
  sync_duration_seconds?: number | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncData
   */
  integration_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncData
   */
  integration_tool?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncData
   */
  integration_category?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncData
   */
  log_url?: string | null;
  /**
   *
   * @type {KomboSyncEndUser}
   * @memberof KomboSyncData
   */
  end_user: KomboSyncEndUser;
}

/**
 *
 * @export
 * @interface KomboSyncEndUser
 */
export interface KomboSyncEndUser {
  /**
   *
   * @type {string}
   * @memberof KomboSyncEndUser
   */
  origin_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncEndUser
   */
  creator_email?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncEndUser
   */
  organization_name?: string | null;
}
/**
 *
 * @export
 * @interface KomboSyncFinishedWebhook
 */
export interface KomboSyncFinishedWebhook {
  /**
   *
   * @type {string}
   * @memberof KomboSyncFinishedWebhook
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof KomboSyncFinishedWebhook
   */
  type?: string | null;
  /**
   *
   * @type {KomboSyncData}
   * @memberof KomboSyncFinishedWebhook
   */
  data: KomboSyncData;
}
/**
 *
 * @export
 * @enum {string}
 */

export const KomboSyncState = {
  Succeeded: "SUCCEEDED",
  Failed: "FAILED",
  PartiallyFailed: "PARTIALLY_FAILED",
  AuthenticationFailed: "AUTHENTICATION_FAILED",
  Cancelled: "CANCELLED",
  TimedOut: "TIMED_OUT",
} as const;

export type KomboSyncState =
  (typeof KomboSyncState)[keyof typeof KomboSyncState];

/**
 *
 * @export
 * @interface KomboTool
 */
export interface KomboTool {
  /**
   *
   * @type {string}
   * @memberof KomboTool
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof KomboTool
   */
  label: string;
  /**
   *
   * @type {KomboToolAsset}
   * @memberof KomboTool
   */
  assets: KomboToolAsset;
  /**
   *
   * @type {boolean}
   * @memberof KomboTool
   */
  is_enabled: boolean;
}
/**
 *
 * @export
 * @interface KomboToolAsset
 */
export interface KomboToolAsset {
  /**
   *
   * @type {string}
   * @memberof KomboToolAsset
   */
  logo_url: string;
  /**
   *
   * @type {string}
   * @memberof KomboToolAsset
   */
  icon_url: string;
  /**
   *
   * @type {string}
   * @memberof KomboToolAsset
   */
  icon_black_url: string;
}
/**
 *
 * @export
 * @interface LivePositionResponse
 */
export interface LivePositionResponse {
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  title: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  overview: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  required_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  preferred_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  resume_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  work_location: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  work_arrangement: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  residency_requirements: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  work_authorization: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  employment_type: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  salary_range: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  shift_availability: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  compensation_and_benefits: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  desired_start_date: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  next_step: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  additional_questions: string | null;
  /**
   *
   * @type {boolean}
   * @memberof LivePositionResponse
   */
  faq_opt_out: boolean;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  interview_language: string;
  /**
   *
   * @type {boolean}
   * @memberof LivePositionResponse
   */
  published: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof LivePositionResponse
   */
  archived: boolean | null;
  /**
   *
   * @type {number}
   * @memberof LivePositionResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  public_id: string;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  kombo_job_id: string | null;
  /**
   *
   * @type {number}
   * @memberof LivePositionResponse
   */
  company_id: number;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  user_id: string;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  company_name: string | null;
  /**
   *
   * @type {boolean}
   * @memberof LivePositionResponse
   */
  company_is_default: boolean;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  job_description_url: string | null;
  /**
   *
   * @type {boolean}
   * @memberof LivePositionResponse
   */
  integrated: boolean;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  location: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  job_code: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  status: string | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {PositionSeniorityLevel}
   * @memberof LivePositionResponse
   */
  seniority_level: PositionSeniorityLevel | null;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof LivePositionResponse
   */
  updated_at: string;
  /**
   *
   * @type {PositionCategory}
   * @memberof LivePositionResponse
   */
  category: PositionCategory;
  /**
   *
   * @type {number}
   * @memberof LivePositionResponse
   */
  request_for_approval_count: number;
  /**
   *
   * @type {number}
   * @memberof LivePositionResponse
   */
  need_follow_up_count: number;
  /**
   * Parsed qualifications (Q1, Q2, ... with Required/Preferred + verification type).  Single source of truth for qualification parsing — the frontend consumes this instead of re-parsing ``required_qualifications`` / ``preferred_qualifications``.  Splits the newline-separated columns exactly as the conversation-flow builder does (see ``Retell.create_conversation_flow``) so the ``Q1, Q2, ...`` ids match the ``S3_Q{n}`` interview-flow node ids.
   * @type {Array<QualificationResponse>}
   * @memberof LivePositionResponse
   */
  qualifications: Array<QualificationResponse>;
}

/**
 * Which side wrote a message, from the candidate\'s perspective.
 * @export
 * @enum {string}
 */

export const MessageDirection = {
  Inbound: "inbound",
  Outbound: "outbound",
} as const;

export type MessageDirection =
  (typeof MessageDirection)[keyof typeof MessageDirection];

/**
 *
 * @export
 * @interface OfferStageConfigRequest
 */
export interface OfferStageConfigRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof OfferStageConfigRequest
   */
  stage_names: Array<string>;
}
/**
 *
 * @export
 * @interface OfferStageConfigResponse
 */
export interface OfferStageConfigResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof OfferStageConfigResponse
   */
  available: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof OfferStageConfigResponse
   */
  selected: Array<string>;
}
/**
 *
 * @export
 * @interface OnboardingTourResponse
 */
export interface OnboardingTourResponse {
  /**
   *
   * @type {boolean}
   * @memberof OnboardingTourResponse
   */
  pending: boolean;
}
/**
 * A team-management row from the current provider membership.
 * @export
 * @interface OrganizationMemberResponse
 */
export interface OrganizationMemberResponse {
  /**
   *
   * @type {string}
   * @memberof OrganizationMemberResponse
   */
  user_id: string;
  /**
   *
   * @type {string}
   * @memberof OrganizationMemberResponse
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof OrganizationMemberResponse
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OrganizationMemberResponse
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof OrganizationMemberResponse
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof OrganizationMemberResponse
   */
  picture: string;
  /**
   *
   * @type {boolean}
   * @memberof OrganizationMemberResponse
   */
  is_admin: boolean;
  /**
   *
   * @type {OrganizationMemberStatus}
   * @memberof OrganizationMemberResponse
   */
  status: OrganizationMemberStatus;
}

/**
 *
 * @export
 * @enum {string}
 */

export const OrganizationMemberStatus = {
  Active: "active",
  Deactivated: "deactivated",
} as const;

export type OrganizationMemberStatus =
  (typeof OrganizationMemberStatus)[keyof typeof OrganizationMemberStatus];

/**
 *
 * @export
 * @interface PhoneNumberLookupResponse
 */
export interface PhoneNumberLookupResponse {
  /**
   *
   * @type {string}
   * @memberof PhoneNumberLookupResponse
   */
  line_type: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PhoneNumberLookupResponse
   */
  is_sms_capable: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const PositionCategory = {
  RequestForApproval: "request_for_approval",
  CriticalRisk: "critical_risk",
  MinorRisk: "minor_risk",
  Ongoing: "ongoing",
} as const;

export type PositionCategory =
  (typeof PositionCategory)[keyof typeof PositionCategory];

/**
 *
 * @export
 * @interface PositionChatRequest
 */
export interface PositionChatRequest {
  /**
   *
   * @type {string}
   * @memberof PositionChatRequest
   */
  message: string;
}
/**
 *
 * @export
 * @interface PositionChatResponse
 */
export interface PositionChatResponse {
  /**
   *
   * @type {string}
   * @memberof PositionChatResponse
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof PositionChatResponse
   */
  id: number | null;
  /**
   *
   * @type {string}
   * @memberof PositionChatResponse
   */
  user_id: string;
  /**
   *
   * @type {boolean}
   * @memberof PositionChatResponse
   */
  is_human: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionChatResponse
   */
  created_at: string;
  /**
   *
   * @type {number}
   * @memberof PositionChatResponse
   */
  position_id: number | null;
}
/**
 *
 * @export
 * @interface PositionConversationFlowMetrics
 */
export interface PositionConversationFlowMetrics {
  /**
   *
   * @type {number}
   * @memberof PositionConversationFlowMetrics
   */
  version: number;
  /**
   *
   * @type {number}
   * @memberof PositionConversationFlowMetrics
   */
  baseline_flow_bytes: number;
  /**
   *
   * @type {number}
   * @memberof PositionConversationFlowMetrics
   */
  reserved_context_bytes: number;
  /**
   *
   * @type {number}
   * @memberof PositionConversationFlowMetrics
   */
  effective_flow_bytes: number;
  /**
   *
   * @type {number}
   * @memberof PositionConversationFlowMetrics
   */
  max_flow_bytes: number;
  /**
   *
   * @type {boolean}
   * @memberof PositionConversationFlowMetrics
   */
  within_limit: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PositionConversationFlowMetrics
   */
  preview_lines: Array<string>;
}
/**
 *
 * @export
 * @interface PositionConversationFlowMetricsRequest
 */
export interface PositionConversationFlowMetricsRequest {
  /**
   *
   * @type {string}
   * @memberof PositionConversationFlowMetricsRequest
   */
  required_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionConversationFlowMetricsRequest
   */
  preferred_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionConversationFlowMetricsRequest
   */
  additional_questions?: string | null;
  /**
   *
   * @type {number}
   * @memberof PositionConversationFlowMetricsRequest
   */
  version: number;
}
/**
 *
 * @export
 * @interface PositionFaq
 */
export interface PositionFaq {
  /**
   *
   * @type {string}
   * @memberof PositionFaq
   */
  question: string;
  /**
   *
   * @type {string}
   * @memberof PositionFaq
   */
  answer?: string | null;
  /**
   *
   * @type {number}
   * @memberof PositionFaq
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof PositionFaq
   */
  position_id: number;
  /**
   *
   * @type {PositionFaqSource}
   * @memberof PositionFaq
   */
  source?: PositionFaqSource;
  /**
   *
   * @type {number}
   * @memberof PositionFaq
   */
  source_review_item_id?: number | null;
  /**
   *
   * @type {string}
   * @memberof PositionFaq
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof PositionFaq
   */
  updated_at?: string;
}

/**
 * Whole-``manual``-set replace for the FAQ collection PUT (the setup wizard\'s single-save path).  ``candidate_question`` (needs-answer) rows are never part of this payload and are left untouched.
 * @export
 * @interface PositionFaqBulkRequest
 */
export interface PositionFaqBulkRequest {
  /**
   *
   * @type {Array<PositionFaqRequest>}
   * @memberof PositionFaqBulkRequest
   */
  faqs?: Array<PositionFaqRequest>;
  /**
   *
   * @type {boolean}
   * @memberof PositionFaqBulkRequest
   */
  faq_opt_out?: boolean;
}
/**
 * The final question/answer to store on the new CompanyFaq when moving a PositionFaq (may differ from the source row).
 * @export
 * @interface PositionFaqMoveRequest
 */
export interface PositionFaqMoveRequest {
  /**
   *
   * @type {string}
   * @memberof PositionFaqMoveRequest
   */
  question: string;
  /**
   *
   * @type {string}
   * @memberof PositionFaqMoveRequest
   */
  answer: string;
}
/**
 *
 * @export
 * @interface PositionFaqRequest
 */
export interface PositionFaqRequest {
  /**
   *
   * @type {string}
   * @memberof PositionFaqRequest
   */
  question: string;
  /**
   *
   * @type {string}
   * @memberof PositionFaqRequest
   */
  answer?: string | null;
}
/**
 * Where a position FAQ row came from.  ``manual`` rows are entered/edited by a human; ``candidate_question`` rows are auto-accumulated from interview questions the assistant could not answer. The answer starts NULL until a human fills it.
 * @export
 * @enum {string}
 */

export const PositionFaqSource = {
  Manual: "manual",
  CandidateQuestion: "candidate_question",
} as const;

export type PositionFaqSource =
  (typeof PositionFaqSource)[keyof typeof PositionFaqSource];

/**
 * A ``PositionResponse`` plus the candidate FAQ, for the endpoints whose frontend consumers read it.  Carries the ``position_faqs`` rows (materialized by ``PositionService.build_position_full_response``) and derives ``frequently_asked_questions`` from them in memory — a computed field, no session or relationship. The lighter ``PositionResponse`` omits FAQ entirely.
 * @export
 * @interface PositionFullResponse
 */
export interface PositionFullResponse {
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  title: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  overview: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  required_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  preferred_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  resume_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  work_location: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  work_arrangement: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  residency_requirements: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  work_authorization: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  employment_type: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  salary_range: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  shift_availability: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  compensation_and_benefits: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  desired_start_date: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  next_step: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  additional_questions: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionFullResponse
   */
  faq_opt_out: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  interview_language: string;
  /**
   *
   * @type {boolean}
   * @memberof PositionFullResponse
   */
  published: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionFullResponse
   */
  archived: boolean | null;
  /**
   *
   * @type {number}
   * @memberof PositionFullResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  public_id: string;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  kombo_job_id: string | null;
  /**
   *
   * @type {number}
   * @memberof PositionFullResponse
   */
  company_id: number;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  user_id: string;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  company_name: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionFullResponse
   */
  company_is_default: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  job_description_url: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionFullResponse
   */
  integrated: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  location: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  job_code: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  status: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {PositionSeniorityLevel}
   * @memberof PositionFullResponse
   */
  seniority_level: PositionSeniorityLevel | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  updated_at: string;
  /**
   *
   * @type {Array<PositionFaq>}
   * @memberof PositionFullResponse
   */
  position_faqs: Array<PositionFaq>;
  /**
   *
   * @type {JobBoardBoostSummary}
   * @memberof PositionFullResponse
   */
  job_board_boost: JobBoardBoostSummary | null;
  /**
   *
   * @type {QualificationAnalysisSummary}
   * @memberof PositionFullResponse
   */
  qualification_analysis_summary: QualificationAnalysisSummary | null;
  /**
   * Parsed qualifications (Q1, Q2, ... with Required/Preferred + verification type).  Single source of truth for qualification parsing — the frontend consumes this instead of re-parsing ``required_qualifications`` / ``preferred_qualifications``.  Splits the newline-separated columns exactly as the conversation-flow builder does (see ``Retell.create_conversation_flow``) so the ``Q1, Q2, ...`` ids match the ``S3_Q{n}`` interview-flow node ids.
   * @type {Array<QualificationResponse>}
   * @memberof PositionFullResponse
   */
  qualifications: Array<QualificationResponse>;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  public_position_url: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionFullResponse
   */
  frequently_asked_questions: string | null;
}

/**
 * A position plus the aggregate summaries required only by the position list.
 * @export
 * @interface PositionListItemResponse
 */
export interface PositionListItemResponse {
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  title: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  overview: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  required_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  preferred_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  resume_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  work_location: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  work_arrangement: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  residency_requirements: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  work_authorization: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  employment_type: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  salary_range: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  shift_availability: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  compensation_and_benefits: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  desired_start_date: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  next_step: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  additional_questions: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionListItemResponse
   */
  faq_opt_out: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  interview_language: string;
  /**
   *
   * @type {boolean}
   * @memberof PositionListItemResponse
   */
  published: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionListItemResponse
   */
  archived: boolean | null;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  public_id: string;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  kombo_job_id: string | null;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  company_id: number;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  user_id: string;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  company_name: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionListItemResponse
   */
  company_is_default: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  job_description_url: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionListItemResponse
   */
  integrated: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  location: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  job_code: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  status: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {PositionSeniorityLevel}
   * @memberof PositionListItemResponse
   */
  seniority_level: PositionSeniorityLevel | null;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  candidate_count: number;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  resume_count: number;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  scheduled_count: number;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  interviewed_count: number;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  recommended_count: number;
  /**
   *
   * @type {number}
   * @memberof PositionListItemResponse
   */
  total_candidate_count: number;
  /**
   *
   * @type {AutomatedInviteSummary}
   * @memberof PositionListItemResponse
   */
  automated_invite: AutomatedInviteSummary;
  /**
   *
   * @type {HiringPipelineSummary}
   * @memberof PositionListItemResponse
   */
  hiring_pipeline: HiringPipelineSummary;
  /**
   *
   * @type {JobBoardBoostSummary}
   * @memberof PositionListItemResponse
   */
  job_board_boost: JobBoardBoostSummary | null;
  /**
   * Parsed qualifications (Q1, Q2, ... with Required/Preferred + verification type).  Single source of truth for qualification parsing — the frontend consumes this instead of re-parsing ``required_qualifications`` / ``preferred_qualifications``.  Splits the newline-separated columns exactly as the conversation-flow builder does (see ``Retell.create_conversation_flow``) so the ``Q1, Q2, ...`` ids match the ``S3_Q{n}`` interview-flow node ids.
   * @type {Array<QualificationResponse>}
   * @memberof PositionListItemResponse
   */
  qualifications: Array<QualificationResponse>;
  /**
   *
   * @type {string}
   * @memberof PositionListItemResponse
   */
  public_position_url: string | null;
}

/**
 *
 * @export
 * @interface PositionPatchRequest
 */
export interface PositionPatchRequest {
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  overview?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  required_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  preferred_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  resume_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  work_location?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  work_arrangement?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  residency_requirements?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  work_authorization?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  employment_type?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  salary_range?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  shift_availability?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  compensation_and_benefits?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  desired_start_date?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  next_step?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  additional_questions?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionPatchRequest
   */
  faq_opt_out?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  interview_language?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionPatchRequest
   */
  published?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionPatchRequest
   */
  archived?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof PositionPatchRequest
   */
  kombo_job_id?: string | null;
  /**
   *
   * @type {number}
   * @memberof PositionPatchRequest
   */
  company_id?: number | null;
  /**
   *
   * @type {PositionSeniorityLevel}
   * @memberof PositionPatchRequest
   */
  seniority_level?: PositionSeniorityLevel | null;
}

/**
 *
 * @export
 * @interface PositionQualificationChatResponse
 */
export interface PositionQualificationChatResponse {
  /**
   *
   * @type {string}
   * @memberof PositionQualificationChatResponse
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof PositionQualificationChatResponse
   */
  id: number | null;
  /**
   *
   * @type {string}
   * @memberof PositionQualificationChatResponse
   */
  user_id: string;
  /**
   *
   * @type {boolean}
   * @memberof PositionQualificationChatResponse
   */
  is_human: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionQualificationChatResponse
   */
  created_at: string;
  /**
   *
   * @type {number}
   * @memberof PositionQualificationChatResponse
   */
  position_id: number | null;
}
/**
 * The findings on the stored qualification lines that keep a position from going live.
 * @export
 * @interface PositionQualificationCheckResponse
 */
export interface PositionQualificationCheckResponse {
  /**
   *
   * @type {Array<QualificationFinding>}
   * @memberof PositionQualificationCheckResponse
   */
  blocking_findings: Array<QualificationFinding>;
}
/**
 *
 * @export
 * @interface PositionQualificationQuestionGenerationRequest
 */
export interface PositionQualificationQuestionGenerationRequest {
  /**
   *
   * @type {number}
   * @memberof PositionQualificationQuestionGenerationRequest
   */
  company_id?: number | null;
  /**
   *
   * @type {string}
   * @memberof PositionQualificationQuestionGenerationRequest
   */
  qualification_text: string;
  /**
   *
   * @type {VerificationType}
   * @memberof PositionQualificationQuestionGenerationRequest
   */
  verification_type_override?: VerificationType | null;
  /**
   *
   * @type {number}
   * @memberof PositionQualificationQuestionGenerationRequest
   */
  current_behavioral_count: number;
}

/**
 *
 * @export
 * @interface PositionQualificationQuestionGenerationResponse
 */
export interface PositionQualificationQuestionGenerationResponse {
  /**
   *
   * @type {VerificationType}
   * @memberof PositionQualificationQuestionGenerationResponse
   */
  verification_type: VerificationType;
  /**
   *
   * @type {string}
   * @memberof PositionQualificationQuestionGenerationResponse
   */
  question: string;
  /**
   *
   * @type {VerificationType}
   * @memberof PositionQualificationQuestionGenerationResponse
   */
  downgraded_from?: VerificationType | null;
  /**
   *
   * @type {string}
   * @memberof PositionQualificationQuestionGenerationResponse
   */
  experience_fallback_question?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionQualificationQuestionGenerationResponse
   */
  confirmation_question?: string | null;
}

/**
 *
 * @export
 * @interface PositionRequest
 */
export interface PositionRequest {
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  title: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  overview: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  required_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  preferred_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  resume_qualifications?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  work_location?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  work_arrangement?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  residency_requirements?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  work_authorization?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  employment_type?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  salary_range?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  shift_availability?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  compensation_and_benefits?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  desired_start_date?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  next_step?: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  additional_questions?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionRequest
   */
  faq_opt_out?: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  interview_language?: string;
  /**
   *
   * @type {boolean}
   * @memberof PositionRequest
   */
  published?: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionRequest
   */
  archived?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof PositionRequest
   */
  kombo_job_id?: string | null;
  /**
   *
   * @type {number}
   * @memberof PositionRequest
   */
  company_id?: number | null;
  /**
   *
   * @type {PositionSeniorityLevel}
   * @memberof PositionRequest
   */
  seniority_level?: PositionSeniorityLevel | null;
}

/**
 *
 * @export
 * @interface PositionResponse
 */
export interface PositionResponse {
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  title: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  overview: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  required_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  preferred_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  resume_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  work_location: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  work_arrangement: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  residency_requirements: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  work_authorization: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  employment_type: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  salary_range: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  shift_availability: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  compensation_and_benefits: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  desired_start_date: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  next_step: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  additional_questions: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionResponse
   */
  faq_opt_out: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  interview_language: string;
  /**
   *
   * @type {boolean}
   * @memberof PositionResponse
   */
  published: boolean | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionResponse
   */
  archived: boolean | null;
  /**
   *
   * @type {number}
   * @memberof PositionResponse
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  public_id: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  kombo_job_id: string | null;
  /**
   *
   * @type {number}
   * @memberof PositionResponse
   */
  company_id: number;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  user_id: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  company_name: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionResponse
   */
  company_is_default: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  job_description_url: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PositionResponse
   */
  integrated: boolean;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  location: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  job_code: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  status: string | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {PositionSeniorityLevel}
   * @memberof PositionResponse
   */
  seniority_level: PositionSeniorityLevel | null;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  updated_at: string;
  /**
   * Parsed qualifications (Q1, Q2, ... with Required/Preferred + verification type).  Single source of truth for qualification parsing — the frontend consumes this instead of re-parsing ``required_qualifications`` / ``preferred_qualifications``.  Splits the newline-separated columns exactly as the conversation-flow builder does (see ``Retell.create_conversation_flow``) so the ``Q1, Q2, ...`` ids match the ``S3_Q{n}`` interview-flow node ids.
   * @type {Array<QualificationResponse>}
   * @memberof PositionResponse
   */
  qualifications: Array<QualificationResponse>;
  /**
   *
   * @type {string}
   * @memberof PositionResponse
   */
  public_position_url: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const PositionRole = {
  PositionEditor: "position-editor",
} as const;

export type PositionRole = (typeof PositionRole)[keyof typeof PositionRole];

/**
 *
 * @export
 * @enum {string}
 */

export const PositionSeniorityLevel = {
  Entry: "entry",
  Mid: "mid",
  Senior: "senior",
  Lead: "lead",
} as const;

export type PositionSeniorityLevel =
  (typeof PositionSeniorityLevel)[keyof typeof PositionSeniorityLevel];

/**
 *
 * @export
 * @interface PostDeployCallDispatchResponse
 */
export interface PostDeployCallDispatchResponse {
  /**
   *
   * @type {string}
   * @memberof PostDeployCallDispatchResponse
   */
  call_id: string;
}
/**
 *
 * @export
 * @interface PostDeployCallRequest
 */
export interface PostDeployCallRequest {
  /**
   *
   * @type {number}
   * @memberof PostDeployCallRequest
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof PostDeployCallRequest
   */
  to_number: string;
  /**
   *
   * @type {string}
   * @memberof PostDeployCallRequest
   */
  first_name?: string;
  /**
   *
   * @type {string}
   * @memberof PostDeployCallRequest
   */
  last_name?: string;
  /**
   *
   * @type {string}
   * @memberof PostDeployCallRequest
   */
  github_sha: string;
  /**
   *
   * @type {string}
   * @memberof PostDeployCallRequest
   */
  github_branch: string;
  /**
   *
   * @type {number}
   * @memberof PostDeployCallRequest
   */
  github_run_id: number;
  /**
   *
   * @type {number}
   * @memberof PostDeployCallRequest
   */
  github_run_attempt: number;
  /**
   *
   * @type {string}
   * @memberof PostDeployCallRequest
   */
  github_run_url: string;
}
/**
 *
 * @export
 * @interface ProfileRequest
 */
export interface ProfileRequest {
  /**
   *
   * @type {string}
   * @memberof ProfileRequest
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof ProfileRequest
   */
  last_name: string;
}
/**
 *
 * @export
 * @interface PublicPositionResponse
 */
export interface PublicPositionResponse {
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  public_id: string;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  company_name: string;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  company_slug: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  company_logo_url: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  location: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  overview: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  employment_type: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  salary_range: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  shift_availability: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  compensation_and_benefits: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  desired_start_date: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  required_qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof PublicPositionResponse
   */
  preferred_qualifications: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PublicPositionResponse
   */
  has_ats_integration: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const QualificationAnalysisStatus = {
  Analyzed: "analyzed",
  Fallback: "fallback",
  FallbackAfterValidation: "fallback_after_validation",
} as const;

export type QualificationAnalysisStatus =
  (typeof QualificationAnalysisStatus)[keyof typeof QualificationAnalysisStatus];

/**
 * The read-only projection of the analysis record for the position detail response.
 * @export
 * @interface QualificationAnalysisSummary
 */
export interface QualificationAnalysisSummary {
  /**
   *
   * @type {string}
   * @memberof QualificationAnalysisSummary
   */
  seniority_level_evidence: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof QualificationAnalysisSummary
   */
  needs_review_texts: Array<string>;
  /**
   *
   * @type {Array<QualificationFinding>}
   * @memberof QualificationAnalysisSummary
   */
  findings: Array<QualificationFinding>;
  /**
   *
   * @type {QualificationAuditStatus}
   * @memberof QualificationAnalysisSummary
   */
  audit_status: QualificationAuditStatus;
  /**
   *
   * @type {QualificationAudit}
   * @memberof QualificationAnalysisSummary
   */
  audit_result: QualificationAudit | null;
  /**
   *
   * @type {Array<string>}
   * @memberof QualificationAnalysisSummary
   */
  auto_fixes: Array<string>;
  /**
   *
   * @type {QualificationAnalysisStatus}
   * @memberof QualificationAnalysisSummary
   */
  analysis_status: QualificationAnalysisStatus;
  /**
   *
   * @type {boolean}
   * @memberof QualificationAnalysisSummary
   */
  is_stale: boolean;
  /**
   *
   * @type {string}
   * @memberof QualificationAnalysisSummary
   */
  analyzed_at: string;
}

/**
 *
 * @export
 * @interface QualificationAudit
 */
export interface QualificationAudit {
  /**
   *
   * @type {Array<QualificationAuditMissingRequirement>}
   * @memberof QualificationAudit
   */
  missing_requirements: Array<QualificationAuditMissingRequirement>;
  /**
   *
   * @type {Array<QualificationAuditLineFinding>}
   * @memberof QualificationAudit
   */
  abstract_method_lines: Array<QualificationAuditLineFinding>;
  /**
   *
   * @type {Array<QualificationAuditLineFinding>}
   * @memberof QualificationAudit
   */
  generic_question_lines: Array<QualificationAuditLineFinding>;
  /**
   *
   * @type {Array<QualificationAuditDuplicateTopic>}
   * @memberof QualificationAudit
   */
  duplicate_topics: Array<QualificationAuditDuplicateTopic>;
  /**
   *
   * @type {Array<QualificationAuditWrongFormLine>}
   * @memberof QualificationAudit
   */
  wrong_form_lines: Array<QualificationAuditWrongFormLine>;
}
/**
 *
 * @export
 * @interface QualificationAuditDuplicateTopic
 */
export interface QualificationAuditDuplicateTopic {
  /**
   * The two or more line texts that test the same topic
   * @type {Array<string>}
   * @memberof QualificationAuditDuplicateTopic
   */
  texts: Array<string>;
  /**
   *
   * @type {string}
   * @memberof QualificationAuditDuplicateTopic
   */
  why: string;
}
/**
 *
 * @export
 * @interface QualificationAuditLineFinding
 */
export interface QualificationAuditLineFinding {
  /**
   * The qualification line text being judged
   * @type {string}
   * @memberof QualificationAuditLineFinding
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof QualificationAuditLineFinding
   */
  why: string;
}
/**
 *
 * @export
 * @interface QualificationAuditMissingRequirement
 */
export interface QualificationAuditMissingRequirement {
  /**
   * The requirement from the job description, quoted
   * @type {string}
   * @memberof QualificationAuditMissingRequirement
   */
  job_description_requirement: string;
  /**
   *
   * @type {string}
   * @memberof QualificationAuditMissingRequirement
   */
  category: QualificationAuditMissingRequirementCategoryEnum;
  /**
   *
   * @type {string}
   * @memberof QualificationAuditMissingRequirement
   */
  expected_destination: QualificationAuditMissingRequirementExpectedDestinationEnum;
  /**
   *
   * @type {string}
   * @memberof QualificationAuditMissingRequirement
   */
  found_in: QualificationAuditMissingRequirementFoundInEnum;
  /**
   * Quote the job description words and, when a dropped reason was wrong, say why it does not hold
   * @type {string}
   * @memberof QualificationAuditMissingRequirement
   */
  why: string;
}

export const QualificationAuditMissingRequirementCategoryEnum = {
  License: "license",
  Certification: "certification",
  Transportation: "transportation",
  Education: "education",
  Years: "years",
  Physical: "physical",
  Travel: "travel",
  Overtime: "overtime",
  Shift: "shift",
  Onsite: "onsite",
  Visa: "visa",
  Other: "other",
} as const;

export type QualificationAuditMissingRequirementCategoryEnum =
  (typeof QualificationAuditMissingRequirementCategoryEnum)[keyof typeof QualificationAuditMissingRequirementCategoryEnum];
export const QualificationAuditMissingRequirementExpectedDestinationEnum = {
  Line: "line",
  Conditions: "conditions",
} as const;

export type QualificationAuditMissingRequirementExpectedDestinationEnum =
  (typeof QualificationAuditMissingRequirementExpectedDestinationEnum)[keyof typeof QualificationAuditMissingRequirementExpectedDestinationEnum];
export const QualificationAuditMissingRequirementFoundInEnum = {
  None: "none",
  DroppedWithBadReason: "dropped_with_bad_reason",
} as const;

export type QualificationAuditMissingRequirementFoundInEnum =
  (typeof QualificationAuditMissingRequirementFoundInEnum)[keyof typeof QualificationAuditMissingRequirementFoundInEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const QualificationAuditStatus = {
  Done: "done",
  Failed: "failed",
  NotApplicable: "not_applicable",
} as const;

export type QualificationAuditStatus =
  (typeof QualificationAuditStatus)[keyof typeof QualificationAuditStatus];

/**
 *
 * @export
 * @interface QualificationAuditWrongFormLine
 */
export interface QualificationAuditWrongFormLine {
  /**
   *
   * @type {string}
   * @memberof QualificationAuditWrongFormLine
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof QualificationAuditWrongFormLine
   */
  suggested_action: QualificationAuditWrongFormLineSuggestedActionEnum;
  /**
   *
   * @type {VerificationType}
   * @memberof QualificationAuditWrongFormLine
   */
  suggested_form?: VerificationType | null;
  /**
   *
   * @type {string}
   * @memberof QualificationAuditWrongFormLine
   */
  why: string;
}

export const QualificationAuditWrongFormLineSuggestedActionEnum = {
  ChangeForm: "change_form",
  Remove: "remove",
  MoveToConditions: "move_to_conditions",
  RewriteText: "rewrite_text",
} as const;

export type QualificationAuditWrongFormLineSuggestedActionEnum =
  (typeof QualificationAuditWrongFormLineSuggestedActionEnum)[keyof typeof QualificationAuditWrongFormLineSuggestedActionEnum];

/**
 *
 * @export
 * @interface QualificationFinding
 */
export interface QualificationFinding {
  /**
   *
   * @type {string}
   * @memberof QualificationFinding
   */
  issue_code: string;
  /**
   *
   * @type {QualificationFindingSeverity}
   * @memberof QualificationFinding
   */
  severity: QualificationFindingSeverity;
  /**
   *
   * @type {string}
   * @memberof QualificationFinding
   */
  subject_text?: string | null;
  /**
   *
   * @type {string}
   * @memberof QualificationFinding
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof QualificationFinding
   */
  hint?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const QualificationFindingSeverity = {
  Block: "block",
  Warn: "warn",
} as const;

export type QualificationFindingSeverity =
  (typeof QualificationFindingSeverity)[keyof typeof QualificationFindingSeverity];

/**
 * API-serializable view of a parsed :class:`Qualification`.  Exposed on the Position response so the frontend can render qualification metadata (and tie ``S3_Q{n}`` interview nodes back to the right qualification) without re-implementing the parsing in TypeScript.
 * @export
 * @interface QualificationResponse
 */
export interface QualificationResponse {
  /**
   *
   * @type {string}
   * @memberof QualificationResponse
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof QualificationResponse
   */
  text: string;
  /**
   *
   * @type {boolean}
   * @memberof QualificationResponse
   */
  required: boolean;
  /**
   *
   * @type {VerificationType}
   * @memberof QualificationResponse
   */
  verification_type: VerificationType;
  /**
   *
   * @type {string}
   * @memberof QualificationResponse
   */
  custom_question?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const RecruiterCostBasis = {
  Hourly: "hourly",
  Yearly: "yearly",
} as const;

export type RecruiterCostBasis =
  (typeof RecruiterCostBasis)[keyof typeof RecruiterCostBasis];

/**
 *
 * @export
 * @interface RejectionMessageRequest
 */
export interface RejectionMessageRequest {
  /**
   *
   * @type {string}
   * @memberof RejectionMessageRequest
   */
  message_text: string;
}
/**
 *
 * @export
 * @interface RejectionMessageResponse
 */
export interface RejectionMessageResponse {
  /**
   *
   * @type {string}
   * @memberof RejectionMessageResponse
   */
  message_text: string;
  /**
   *
   * @type {string}
   * @memberof RejectionMessageResponse
   */
  updated_at?: string | null;
}
/**
 *
 * @export
 * @interface ResponsePostresumes
 */
export interface ResponsePostresumes {
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  first_name: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  last_name: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  phone_number: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  email_address: string;
  /**
   *
   * @type {boolean}
   * @memberof ResponsePostresumes
   */
  archived: boolean;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  file_name: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  file_hash: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  openai_file_id: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  evaluation: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  evaluation_description: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  qualifications: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  kombo_application_id: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  kombo_candidate_id: string;
  /**
   *
   * @type {number}
   * @memberof ResponsePostresumes
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof ResponsePostresumes
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof ResponsePostresumes
   */
  rank: number;
  /**
   *
   * @type {string}
   * @memberof ResponsePostresumes
   */
  stage: string;
  /**
   *
   * @type {Array<any>}
   * @memberof ResponsePostresumes
   */
  applying_positions: Array<any>;
  /**
   *
   * @type {AutomatedInviteState}
   * @memberof ResponsePostresumes
   */
  automated_invite_state: AutomatedInviteState;
  /**
   *
   * @type {number}
   * @memberof ResponsePostresumes
   */
  resume_match_count: number;
  /**
   *
   * @type {boolean}
   * @memberof ResponsePostresumes
   */
  has_similarity_signal: boolean;
}

/**
 *
 * @export
 * @interface ResumeAttachmentResponse
 */
export interface ResumeAttachmentResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeAttachmentResponse
   */
  file_name: string;
  /**
   *
   * @type {string}
   * @memberof ResumeAttachmentResponse
   */
  content_type: string;
  /**
   *
   * @type {number}
   * @memberof ResumeAttachmentResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof ResumeAttachmentResponse
   */
  resume_id: number;
  /**
   *
   * @type {string}
   * @memberof ResumeAttachmentResponse
   */
  file_url?: string | null;
}
/**
 *
 * @export
 * @interface ResumeChatRequest
 */
export interface ResumeChatRequest {
  /**
   *
   * @type {string}
   * @memberof ResumeChatRequest
   */
  message: string;
}
/**
 *
 * @export
 * @interface ResumeChatResponse
 */
export interface ResumeChatResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeChatResponse
   */
  message: string;
  /**
   *
   * @type {number}
   * @memberof ResumeChatResponse
   */
  id: number | null;
  /**
   *
   * @type {string}
   * @memberof ResumeChatResponse
   */
  user_id: string;
  /**
   *
   * @type {boolean}
   * @memberof ResumeChatResponse
   */
  is_human: boolean;
  /**
   *
   * @type {string}
   * @memberof ResumeChatResponse
   */
  created_at: string;
  /**
   *
   * @type {number}
   * @memberof ResumeChatResponse
   */
  resume_id: number | null;
}
/**
 * Evidence types for matched resumes.
 * @export
 * @enum {string}
 */

export const ResumeContactMatchEvidence = {
  PhoneNumber: "phone number",
  Email: "email",
  Name: "name",
} as const;

export type ResumeContactMatchEvidence =
  (typeof ResumeContactMatchEvidence)[keyof typeof ResumeContactMatchEvidence];

/**
 * Details of a matched resume from another position.  Does not include IDs or links to avoid granting access to unpermitted resources.
 * @export
 * @interface ResumeContactMatchResponse
 */
export interface ResumeContactMatchResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeContactMatchResponse
   */
  position_title: string;
  /**
   *
   * @type {boolean}
   * @memberof ResumeContactMatchResponse
   */
  position_archived: boolean;
  /**
   *
   * @type {string}
   * @memberof ResumeContactMatchResponse
   */
  first_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeContactMatchResponse
   */
  last_name: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ResumeContactMatchResponse
   */
  resume_archived: boolean;
  /**
   *
   * @type {string}
   * @memberof ResumeContactMatchResponse
   */
  resume_created_at: string;
  /**
   *
   * @type {Array<ResumeContactMatchEvidence>}
   * @memberof ResumeContactMatchResponse
   */
  evidence: Array<ResumeContactMatchEvidence>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ResumeEvaluation = {
  HighPotential: "high potential",
  ModeratePotential: "moderate potential",
  LowPotential: "low potential",
  NotSuitable: "not suitable",
  CannotProcess: "cannot process",
  NoEvaluation: "no evaluation",
} as const;

export type ResumeEvaluation =
  (typeof ResumeEvaluation)[keyof typeof ResumeEvaluation];

/**
 *
 * @export
 * @interface ResumeIndividualResponse
 */
export interface ResumeIndividualResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  first_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  last_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  phone_number: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  email_address: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ResumeIndividualResponse
   */
  archived: boolean;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  file_name: string;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  file_hash: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  openai_file_id: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  evaluation: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  evaluation_description: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  kombo_application_id: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  kombo_candidate_id: string | null;
  /**
   *
   * @type {number}
   * @memberof ResumeIndividualResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof ResumeIndividualResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  updated_at: string;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  file_url: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeIndividualResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {Array<ResumeAttachmentResponse>}
   * @memberof ResumeIndividualResponse
   */
  attachments: Array<ResumeAttachmentResponse> | null;
  /**
   *
   * @type {AutomatedInviteState}
   * @memberof ResumeIndividualResponse
   */
  automated_invite_state: AutomatedInviteState;
}

/**
 *
 * @export
 * @interface ResumeListResponse
 */
export interface ResumeListResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  first_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  last_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  phone_number: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  email_address: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ResumeListResponse
   */
  archived: boolean;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  file_name: string;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  file_hash: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  openai_file_id: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  evaluation: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  evaluation_description: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  kombo_application_id: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  kombo_candidate_id: string | null;
  /**
   *
   * @type {number}
   * @memberof ResumeListResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof ResumeListResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof ResumeListResponse
   */
  rank: number | null;
  /**
   *
   * @type {string}
   * @memberof ResumeListResponse
   */
  stage: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ResumeListResponse
   */
  applying_positions: Array<string> | null;
  /**
   *
   * @type {AutomatedInviteState}
   * @memberof ResumeListResponse
   */
  automated_invite_state: AutomatedInviteState;
  /**
   *
   * @type {number}
   * @memberof ResumeListResponse
   */
  resume_match_count: number;
  /**
   *
   * @type {boolean}
   * @memberof ResumeListResponse
   */
  has_similarity_signal: boolean;
}

/**
 *
 * @export
 * @interface ResumeRequest
 */
export interface ResumeRequest {
  /**
   *
   * @type {string}
   * @memberof ResumeRequest
   */
  first_name?: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeRequest
   */
  last_name?: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeRequest
   */
  phone_number?: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeRequest
   */
  email_address?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ResumeRequest
   */
  archived?: boolean;
}
/**
 * One matching line pair oriented from the viewed resume.
 * @export
 * @interface ResumeSimilarityBulletPairResponse
 */
export interface ResumeSimilarityBulletPairResponse {
  /**
   *
   * @type {ResumeSimilarityEvidenceKind}
   * @memberof ResumeSimilarityBulletPairResponse
   */
  kind: ResumeSimilarityEvidenceKind;
  /**
   *
   * @type {string}
   * @memberof ResumeSimilarityBulletPairResponse
   */
  raw: string;
  /**
   *
   * @type {string}
   * @memberof ResumeSimilarityBulletPairResponse
   */
  other_raw: string;
}

/**
 * How a pair of resume lines matched.
 * @export
 * @enum {string}
 */

export const ResumeSimilarityEvidenceKind = {
  Exact: "exact",
  Near: "near",
} as const;

export type ResumeSimilarityEvidenceKind =
  (typeof ResumeSimilarityEvidenceKind)[keyof typeof ResumeSimilarityEvidenceKind];

/**
 * One permission-filtered similarity match for the resume detail response.
 * @export
 * @interface ResumeSimilarityMatchResponse
 */
export interface ResumeSimilarityMatchResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeSimilarityMatchResponse
   */
  other_position_title: string;
  /**
   *
   * @type {boolean}
   * @memberof ResumeSimilarityMatchResponse
   */
  other_position_archived: boolean;
  /**
   *
   * @type {string}
   * @memberof ResumeSimilarityMatchResponse
   */
  other_first_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeSimilarityMatchResponse
   */
  other_last_name: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ResumeSimilarityMatchResponse
   */
  other_resume_archived: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ResumeSimilarityMatchResponse
   */
  same_contact_info: boolean;
  /**
   *
   * @type {number}
   * @memberof ResumeSimilarityMatchResponse
   */
  score: number;
  /**
   *
   * @type {Array<ResumeSimilarityBulletPairResponse>}
   * @memberof ResumeSimilarityMatchResponse
   */
  bullet_pairs: Array<ResumeSimilarityBulletPairResponse>;
}
/**
 * A single resume plus its contact-info matches (getResume endpoint only).
 * @export
 * @interface ResumeWithMatchesResponse
 */
export interface ResumeWithMatchesResponse {
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  first_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  last_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  phone_number: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  email_address: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ResumeWithMatchesResponse
   */
  archived: boolean;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  file_name: string;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  file_hash: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  openai_file_id: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  evaluation: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  evaluation_description: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  qualifications: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  kombo_application_id: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  kombo_candidate_id: string | null;
  /**
   *
   * @type {number}
   * @memberof ResumeWithMatchesResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof ResumeWithMatchesResponse
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  updated_at: string;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  file_url: string | null;
  /**
   *
   * @type {string}
   * @memberof ResumeWithMatchesResponse
   */
  remote_url: string | null;
  /**
   *
   * @type {Array<ResumeAttachmentResponse>}
   * @memberof ResumeWithMatchesResponse
   */
  attachments: Array<ResumeAttachmentResponse> | null;
  /**
   *
   * @type {AutomatedInviteState}
   * @memberof ResumeWithMatchesResponse
   */
  automated_invite_state: AutomatedInviteState;
  /**
   *
   * @type {Array<ResumeContactMatchResponse>}
   * @memberof ResumeWithMatchesResponse
   */
  contact_matches: Array<ResumeContactMatchResponse>;
  /**
   *
   * @type {Array<ResumeSimilarityMatchResponse>}
   * @memberof ResumeWithMatchesResponse
   */
  similarity_matches: Array<ResumeSimilarityMatchResponse>;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ReviewItemCategory = {
  CandidateSmsReply: "candidate_sms_reply",
  ResumeNotReadyToInvite: "resume_not_ready_to_invite",
  InvitationSmsDeliveryFailed: "invitation_sms_delivery_failed",
  CallUnsuccessful: "call_unsuccessful",
  UnansweredFaq: "unanswered_faq",
  RecruiterFollowUpRequested: "recruiter_follow_up_requested",
  SmsOptOut: "sms_opt_out",
  WrongSmsRecipient: "wrong_sms_recipient",
  ArchivedApplicationCallback: "archived_application_callback",
  CandidateAdvancement: "candidate_advancement",
} as const;

export type ReviewItemCategory =
  (typeof ReviewItemCategory)[keyof typeof ReviewItemCategory];

/**
 * Human-declared handled-state for a review_item.  ``UNKNOWN`` is a one-time backfilled marker for rows that predate resolution tracking — its handled-state is genuinely unknowable, so it is terminal: it never transitions to or from any other value. The \"open, not yet handled\" state is ``resolution_status IS NULL``, not a fourth enum member, keeping \"nobody has declared this handled yet\" (NULL) distinct from \"handled-state cannot be known\" (``unknown``).
 * @export
 * @enum {string}
 */

export const ReviewItemResolution = {
  Resolved: "resolved",
  Dismissed: "dismissed",
  Unknown: "unknown",
} as const;

export type ReviewItemResolution =
  (typeof ReviewItemResolution)[keyof typeof ReviewItemResolution];

/**
 *
 * @export
 * @interface ReviewItemResolutionRequest
 */
export interface ReviewItemResolutionRequest {
  /**
   *
   * @type {ReviewItemResolution}
   * @memberof ReviewItemResolutionRequest
   */
  resolution_status: ReviewItemResolution | null;
}

/**
 *
 * @export
 * @interface ReviewItemResponse
 */
export interface ReviewItemResponse {
  /**
   *
   * @type {number}
   * @memberof ReviewItemResponse
   */
  id: number;
  /**
   *
   * @type {ReviewItemCategory}
   * @memberof ReviewItemResponse
   */
  category: ReviewItemCategory;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  description: string | null;
  /**
   *
   * @type {number}
   * @memberof ReviewItemResponse
   */
  candidate_id: number | null;
  /**
   *
   * @type {number}
   * @memberof ReviewItemResponse
   */
  position_id: number | null;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  company_name: string;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  position_title: string | null;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  position_location: string | null;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  first_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  last_name: string | null;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  phone_number: string | null;
  /**
   *
   * @type {CandidateReplyCategory}
   * @memberof ReviewItemResponse
   */
  candidate_reply_category: CandidateReplyCategory | null;
  /**
   *
   * @type {boolean}
   * @memberof ReviewItemResponse
   */
  candidate_archived: boolean;
  /**
   *
   * @type {DeliveryFailureReason}
   * @memberof ReviewItemResponse
   */
  delivery_failure_reason: DeliveryFailureReason | null;
  /**
   *
   * @type {string}
   * @memberof ReviewItemResponse
   */
  created_at: string;
}

/**
 * Member-supplied ROI dashboard settings. The four values are set together, and each must be positive.
 * @export
 * @interface RoiMetricsSettingsRequest
 */
export interface RoiMetricsSettingsRequest {
  /**
   *
   * @type {number}
   * @memberof RoiMetricsSettingsRequest
   */
  annual_hiring_target: number;
  /**
   *
   * @type {number}
   * @memberof RoiMetricsSettingsRequest
   */
  time_to_fill_days: number;
  /**
   *
   * @type {number}
   * @memberof RoiMetricsSettingsRequest
   */
  recruiter_hourly_cost_usd: number;
  /**
   *
   * @type {RecruiterCostBasis}
   * @memberof RoiMetricsSettingsRequest
   */
  recruiter_cost_basis: RecruiterCostBasis;
}

/**
 *
 * @export
 * @interface RoiMetricsSettingsResponse
 */
export interface RoiMetricsSettingsResponse {
  /**
   *
   * @type {number}
   * @memberof RoiMetricsSettingsResponse
   */
  annual_hiring_target: number;
  /**
   *
   * @type {number}
   * @memberof RoiMetricsSettingsResponse
   */
  time_to_fill_days: number;
  /**
   *
   * @type {number}
   * @memberof RoiMetricsSettingsResponse
   */
  recruiter_hourly_cost_usd: number;
  /**
   *
   * @type {RecruiterCostBasis}
   * @memberof RoiMetricsSettingsResponse
   */
  recruiter_cost_basis: RecruiterCostBasis;
}

/**
 *
 * @export
 * @interface SettingsCoverageRewriteRequest
 */
export interface SettingsCoverageRewriteRequest {
  /**
   *
   * @type {string}
   * @memberof SettingsCoverageRewriteRequest
   */
  comment: string;
}
/**
 *
 * @export
 * @interface SimulationQuestionReviewCard
 */
export interface SimulationQuestionReviewCard {
  /**
   * Short descriptive name, e.g. \'Identity verified\', \'Qualification 3\', \'Salary range\'
   * @type {string}
   * @memberof SimulationQuestionReviewCard
   */
  label: string;
  /**
   * True if the interviewer successfully covered this item
   * @type {boolean}
   * @memberof SimulationQuestionReviewCard
   */
  passed: boolean;
  /**
   * Exact words the AI interviewer spoke. Empty string if not covered.
   * @type {string}
   * @memberof SimulationQuestionReviewCard
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof SimulationQuestionReviewCard
   */
  check_type?: SimulationQuestionReviewCardCheckTypeEnum | null;
  /**
   * Follow-up questions triggered by this card\'s response
   * @type {Array<SimulationQuestionReviewChildCard>}
   * @memberof SimulationQuestionReviewCard
   */
  children?: Array<SimulationQuestionReviewChildCard>;
}

export const SimulationQuestionReviewCardCheckTypeEnum = {
  Yesno: "yesno",
  Knowledge: "knowledge",
  Method: "method",
  Example: "example",
  Star: "star",
} as const;

export type SimulationQuestionReviewCardCheckTypeEnum =
  (typeof SimulationQuestionReviewCardCheckTypeEnum)[keyof typeof SimulationQuestionReviewCardCheckTypeEnum];

/**
 *
 * @export
 * @interface SimulationQuestionReviewCategory
 */
export interface SimulationQuestionReviewCategory {
  /**
   * Category name: GREETING, COMPANY & POSITION, QUALIFICATION, ADDITIONAL QUESTIONS, CONDITIONS, INTEREST & CAREER, Q&A & CLOSING
   * @type {string}
   * @memberof SimulationQuestionReviewCategory
   */
  category: string;
  /**
   * Display number for this category in the timeline (1-based)
   * @type {number}
   * @memberof SimulationQuestionReviewCategory
   */
  start_number: number;
  /**
   * Cards in this category
   * @type {Array<SimulationQuestionReviewCard>}
   * @memberof SimulationQuestionReviewCategory
   */
  cards: Array<SimulationQuestionReviewCard>;
}
/**
 *
 * @export
 * @interface SimulationQuestionReviewChildCard
 */
export interface SimulationQuestionReviewChildCard {
  /**
   * Short descriptive name, e.g. \'Identity verified\', \'Qualification 3\', \'Salary range\'
   * @type {string}
   * @memberof SimulationQuestionReviewChildCard
   */
  label: string;
  /**
   * True if the interviewer successfully covered this item
   * @type {boolean}
   * @memberof SimulationQuestionReviewChildCard
   */
  passed: boolean;
  /**
   * Exact words the AI interviewer spoke. Empty string if not covered.
   * @type {string}
   * @memberof SimulationQuestionReviewChildCard
   */
  text: string;
  /**
   *
   * @type {string}
   * @memberof SimulationQuestionReviewChildCard
   */
  check_type?: SimulationQuestionReviewChildCardCheckTypeEnum | null;
  /**
   * Why this was asked, e.g. \'Candidate answered Yes → detailed experience question asked\'
   * @type {string}
   * @memberof SimulationQuestionReviewChildCard
   */
  trigger_reason: string;
}

export const SimulationQuestionReviewChildCardCheckTypeEnum = {
  Yesno: "yesno",
  Knowledge: "knowledge",
  Method: "method",
  Example: "example",
  Star: "star",
} as const;

export type SimulationQuestionReviewChildCardCheckTypeEnum =
  (typeof SimulationQuestionReviewChildCardCheckTypeEnum)[keyof typeof SimulationQuestionReviewChildCardCheckTypeEnum];

/**
 * API surface for the persisted question review. Mirrors `SimulationQuestionReview` but exposes each suggestion with its server-assigned stable id.
 * @export
 * @interface SimulationQuestionReviewResponse
 */
export interface SimulationQuestionReviewResponse {
  /**
   *
   * @type {Array<SimulationQuestionReviewCategory>}
   * @memberof SimulationQuestionReviewResponse
   */
  sequence: Array<SimulationQuestionReviewCategory>;
  /**
   *
   * @type {Array<SimulationQuestionSuggestion>}
   * @memberof SimulationQuestionReviewResponse
   */
  suggestions: Array<SimulationQuestionSuggestion>;
}
/**
 * A suggestion as exposed by the API: the LLM action plus a stable id the frontend uses to track approve/ignore state and to apply the change.
 * @export
 * @interface SimulationQuestionSuggestion
 */
export interface SimulationQuestionSuggestion {
  /**
   * Type of suggestion
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  action: SimulationQuestionSuggestionActionEnum;
  /**
   * 0-based index in the additional_questions list
   * @type {number}
   * @memberof SimulationQuestionSuggestion
   */
  source_question_index: number;
  /**
   * The original additional question text
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  source_question: string;
  /**
   * Conversational explanation of the recommendation, as if Hope is explaining
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  target_qualification_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  custom_question_text?: string | null;
  /**
   *
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  new_qualification_text?: string | null;
  /**
   *
   * @type {VerificationType}
   * @memberof SimulationQuestionSuggestion
   */
  new_verification_type?: VerificationType | null;
  /**
   *
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  condition_guidance?: string | null;
  /**
   * Stable suggestion id (e.g. \'s-0\')
   * @type {string}
   * @memberof SimulationQuestionSuggestion
   */
  id: string;
}

export const SimulationQuestionSuggestionActionEnum = {
  MergeToCustomQuestion: "merge_to_custom_question",
  RemoveDuplicate: "remove_duplicate",
  AddQualification: "add_qualification",
  MoveToCondition: "move_to_condition",
} as const;

export type SimulationQuestionSuggestionActionEnum =
  (typeof SimulationQuestionSuggestionActionEnum)[keyof typeof SimulationQuestionSuggestionActionEnum];

/**
 *
 * @export
 * @enum {string}
 */

export const SimulationReportRecipients = {
  All: "all",
  Self: "self",
} as const;

export type SimulationReportRecipients =
  (typeof SimulationReportRecipients)[keyof typeof SimulationReportRecipients];

/**
 * A judgement as persisted and exposed by the API: the LLM verdict plus the text it was judged against. ``configured_text`` comes from the generator\'s own input snapshot, so the UI keeps comparing against the wording that was judged even after the position is edited.
 * @export
 * @interface SimulationSettingCoverageResult
 */
export interface SimulationSettingCoverageResult {
  /**
   * Key of the judged setting, echoed exactly from the input list
   * @type {string}
   * @memberof SimulationSettingCoverageResult
   */
  setting_key: SimulationSettingCoverageResultSettingKeyEnum;
  /**
   * \'spoken\' = configured content reached the candidate (paraphrase/summary counts); \'diverged\' = topic addressed but the candidate was materially misinformed; \'missing\' = topic never addressed
   * @type {string}
   * @memberof SimulationSettingCoverageResult
   */
  verdict: SimulationSettingCoverageResultVerdictEnum;
  /**
   * Verbatim excerpt of the agent utterance(s) that delivered this setting. Empty when verdict is \'missing\'.
   * @type {string}
   * @memberof SimulationSettingCoverageResult
   */
  spoken_quote: string;
  /**
   * For \'diverged\'/\'missing\': 1-2 sentences addressed to the recruiter naming concretely what was lost, invented, or contradicted. Empty for \'spoken\'.
   * @type {string}
   * @memberof SimulationSettingCoverageResult
   */
  note: string;
  /**
   *
   * @type {string}
   * @memberof SimulationSettingCoverageResult
   */
  suggested_rewrite?: string | null;
  /**
   * The setting text sent to the judge (header lines already stripped for next_step)
   * @type {string}
   * @memberof SimulationSettingCoverageResult
   */
  configured_text: string;
}

export const SimulationSettingCoverageResultSettingKeyEnum = {
  Overview: "overview",
  NextStep: "next_step",
} as const;

export type SimulationSettingCoverageResultSettingKeyEnum =
  (typeof SimulationSettingCoverageResultSettingKeyEnum)[keyof typeof SimulationSettingCoverageResultSettingKeyEnum];
export const SimulationSettingCoverageResultVerdictEnum = {
  Spoken: "spoken",
  Diverged: "diverged",
  Missing: "missing",
} as const;

export type SimulationSettingCoverageResultVerdictEnum =
  (typeof SimulationSettingCoverageResultVerdictEnum)[keyof typeof SimulationSettingCoverageResultVerdictEnum];

/**
 * API/persisted surface for `CallSimulationJob.settings_coverage`. An empty ``judgements`` list means nothing was judgeable; a NULL column means coverage was never generated (older jobs, or a failure).
 * @export
 * @interface SimulationSettingsCoverageResponse
 */
export interface SimulationSettingsCoverageResponse {
  /**
   *
   * @type {Array<SimulationSettingCoverageResult>}
   * @memberof SimulationSettingsCoverageResponse
   */
  judgements: Array<SimulationSettingCoverageResult>;
}
/**
 *
 * @export
 * @enum {string}
 */

export const StageTransitionEvent = {
  ResumeAssessmentIsCompleted: "resume_assessment_is_completed",
  ResumeIsEvaluatedAsNotSuitable: "resume_is_evaluated_as_not_suitable",
  ResumeAssessmentIsSkippedOrFailed: "resume_assessment_is_skipped_or_failed",
  MovedToAiScheduling: "moved_to_ai_scheduling",
  Scheduled: "scheduled",
  UnresponsiveToSchedulingFor5Days: "unresponsive_to_scheduling_for_5_days",
  WithdrawnBeforePhoneCall: "withdrawn_before_phone_call",
  EvaluationHighlyRecommend: "evaluation_highly_recommend",
  EvaluationHighlyRecommendConditional:
    "evaluation_highly_recommend_conditional",
  EvaluationRecommend: "evaluation_recommend",
  EvaluationRecommendConditional: "evaluation_recommend_conditional",
  EvaluationNotRecommend: "evaluation_not_recommend",
  Rejected: "rejected",
} as const;

export type StageTransitionEvent =
  (typeof StageTransitionEvent)[keyof typeof StageTransitionEvent];

/**
 *
 * @export
 * @interface StatisticsDetail
 */
export interface StatisticsDetail {
  /**
   *
   * @type {number}
   * @memberof StatisticsDetail
   */
  position_id: number;
  /**
   *
   * @type {string}
   * @memberof StatisticsDetail
   */
  position_title: string | null;
  /**
   *
   * @type {number}
   * @memberof StatisticsDetail
   */
  count: number | null;
}
/**
 *
 * @export
 * @interface StatisticsDetails
 */
export interface StatisticsDetails {
  /**
   *
   * @type {number}
   * @memberof StatisticsDetails
   */
  total: number | null;
  /**
   *
   * @type {Array<StatisticsDetail>}
   * @memberof StatisticsDetails
   */
  details: Array<StatisticsDetail>;
}
/**
 *
 * @export
 * @interface StatisticsResponse
 */
export interface StatisticsResponse {
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  call_count: StatisticsDetails;
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  call_duration: StatisticsDetails;
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  resume_count: StatisticsDetails;
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  message_count: StatisticsDetails;
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  hired_count: StatisticsDetails;
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  time_to_hire_days: StatisticsDetails;
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  offer_count: StatisticsDetails;
  /**
   *
   * @type {string}
   * @memberof StatisticsResponse
   */
  offer_since: string | null;
  /**
   *
   * @type {StatisticsDetails}
   * @memberof StatisticsResponse
   */
  time_to_offer_days: StatisticsDetails;
}
/**
 *
 * @export
 * @interface SubscriptionResponse
 */
export interface SubscriptionResponse {
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  plan_type: string;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  phone_number: string | null;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  sms_phone_number: string | null;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  agent_name: string | null;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  agent_voice_id: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SubscriptionResponse
   */
  deleted: boolean;
  /**
   *
   * @type {number}
   * @memberof SubscriptionResponse
   */
  id: number | null;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  updated_at: string;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  free_trial_end_date: string | null;
  /**
   *
   * @type {string}
   * @memberof SubscriptionResponse
   */
  org_id: string;
}
/**
 * Candidate sync history response retained for API compatibility.
 * @export
 * @interface SyncCandidateResultResponse
 */
export interface SyncCandidateResultResponse {
  /**
   *
   * @type {number}
   * @memberof SyncCandidateResultResponse
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateResultResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateResultResponse
   */
  reason: string | null;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateResultResponse
   */
  api_called_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateResultResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateResultResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof SyncCandidateResultResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof SyncCandidateResultResponse
   */
  position_id: number | null;
}
/**
 * Candidate sync status response retained for API compatibility.
 * @export
 * @interface SyncCandidateStatusResponse
 */
export interface SyncCandidateStatusResponse {
  /**
   *
   * @type {number}
   * @memberof SyncCandidateStatusResponse
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateStatusResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateStatusResponse
   */
  reason: string | null;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateStatusResponse
   */
  api_called_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateStatusResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateStatusResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof SyncCandidateStatusResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof SyncCandidateStatusResponse
   */
  sync_result_id: number | null;
  /**
   *
   * @type {string}
   * @memberof SyncCandidateStatusResponse
   */
  last_succeeded_at: string | null;
  /**
   *
   * @type {number}
   * @memberof SyncCandidateStatusResponse
   */
  position_id: number | null;
}
/**
 * Position sync history response retained for API compatibility.
 * @export
 * @interface SyncPositionResultResponse
 */
export interface SyncPositionResultResponse {
  /**
   *
   * @type {number}
   * @memberof SyncPositionResultResponse
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof SyncPositionResultResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof SyncPositionResultResponse
   */
  reason: string | null;
  /**
   *
   * @type {string}
   * @memberof SyncPositionResultResponse
   */
  api_called_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncPositionResultResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncPositionResultResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof SyncPositionResultResponse
   */
  id: number;
}
/**
 * Position sync status response retained for API compatibility.
 * @export
 * @interface SyncPositionStatusResponse
 */
export interface SyncPositionStatusResponse {
  /**
   *
   * @type {number}
   * @memberof SyncPositionStatusResponse
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof SyncPositionStatusResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof SyncPositionStatusResponse
   */
  reason: string | null;
  /**
   *
   * @type {string}
   * @memberof SyncPositionStatusResponse
   */
  api_called_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncPositionStatusResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncPositionStatusResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof SyncPositionStatusResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof SyncPositionStatusResponse
   */
  sync_result_id: number | null;
  /**
   *
   * @type {string}
   * @memberof SyncPositionStatusResponse
   */
  last_succeeded_at: string | null;
}
/**
 * Lifecycle state of an ATS synchronization run.
 * @export
 * @enum {string}
 */

export const SyncResultStatus = {
  Waiting: "waiting",
  Succeeded: "succeeded",
  Failed: "failed",
} as const;

export type SyncResultStatus =
  (typeof SyncResultStatus)[keyof typeof SyncResultStatus];

/**
 * Resume sync history response retained for API compatibility.
 * @export
 * @interface SyncResumeResultResponse
 */
export interface SyncResumeResultResponse {
  /**
   *
   * @type {number}
   * @memberof SyncResumeResultResponse
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof SyncResumeResultResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof SyncResumeResultResponse
   */
  reason: string | null;
  /**
   *
   * @type {string}
   * @memberof SyncResumeResultResponse
   */
  api_called_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncResumeResultResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncResumeResultResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof SyncResumeResultResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof SyncResumeResultResponse
   */
  position_id: number | null;
}
/**
 * Resume sync status response retained for API compatibility.
 * @export
 * @interface SyncResumeStatusResponse
 */
export interface SyncResumeStatusResponse {
  /**
   *
   * @type {number}
   * @memberof SyncResumeStatusResponse
   */
  integration_id: number;
  /**
   *
   * @type {string}
   * @memberof SyncResumeStatusResponse
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof SyncResumeStatusResponse
   */
  reason: string | null;
  /**
   *
   * @type {string}
   * @memberof SyncResumeStatusResponse
   */
  api_called_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncResumeStatusResponse
   */
  created_at: string;
  /**
   *
   * @type {string}
   * @memberof SyncResumeStatusResponse
   */
  updated_at: string;
  /**
   *
   * @type {number}
   * @memberof SyncResumeStatusResponse
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof SyncResumeStatusResponse
   */
  sync_result_id: number | null;
  /**
   *
   * @type {string}
   * @memberof SyncResumeStatusResponse
   */
  last_succeeded_at: string | null;
  /**
   *
   * @type {number}
   * @memberof SyncResumeStatusResponse
   */
  position_id: number | null;
}
/**
 * Kind of data synchronized from the ATS integration.
 * @export
 * @enum {string}
 */

export const SyncType = {
  Position: "position",
  Candidate: "candidate",
  Resume: "resume",
} as const;

export type SyncType = (typeof SyncType)[keyof typeof SyncType];

/**
 *
 * @export
 * @interface TodoGuidance
 */
export interface TodoGuidance {
  /**
   *
   * @type {number}
   * @memberof TodoGuidance
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof TodoGuidance
   */
  candidate_id: number;
  /**
   *
   * @type {string}
   * @memberof TodoGuidance
   */
  situation_summary: string;
  /**
   *
   * @type {string}
   * @memberof TodoGuidance
   */
  recommended_action: string;
  /**
   *
   * @type {string}
   * @memberof TodoGuidance
   */
  suggested_text_message?: string | null;
  /**
   *
   * @type {string}
   * @memberof TodoGuidance
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof TodoGuidance
   */
  updated_at?: string;
}
/**
 *
 * @export
 * @interface UnresponsiveCandidateLogResponse
 */
export interface UnresponsiveCandidateLogResponse {
  /**
   *
   * @type {number}
   * @memberof UnresponsiveCandidateLogResponse
   */
  candidate_id: number;
  /**
   *
   * @type {UnresponsiveCandidateReason}
   * @memberof UnresponsiveCandidateLogResponse
   */
  reason?: UnresponsiveCandidateReason | null;
  /**
   *
   * @type {string}
   * @memberof UnresponsiveCandidateLogResponse
   */
  flagged_at: string;
}

/**
 *
 * @export
 * @enum {string}
 */

export const UnresponsiveCandidateReason = {
  NoResponse: "no_response",
  NoSchedule: "no_schedule",
  MissedCall: "missed_call",
} as const;

export type UnresponsiveCandidateReason =
  (typeof UnresponsiveCandidateReason)[keyof typeof UnresponsiveCandidateReason];

/**
 *
 * @export
 * @interface UserInvitationRequest
 */
export interface UserInvitationRequest {
  /**
   *
   * @type {string}
   * @memberof UserInvitationRequest
   */
  email: string;
  /**
   *
   * @type {boolean}
   * @memberof UserInvitationRequest
   */
  is_admin?: boolean;
  /**
   *
   * @type {Array<number>}
   * @memberof UserInvitationRequest
   */
  position_ids?: Array<number>;
}
/**
 *
 * @export
 * @interface UserInvitationResponse
 */
export interface UserInvitationResponse {
  /**
   *
   * @type {string}
   * @memberof UserInvitationResponse
   */
  invitation_id: string;
  /**
   *
   * @type {string}
   * @memberof UserInvitationResponse
   */
  inviter_name: string;
  /**
   *
   * @type {string}
   * @memberof UserInvitationResponse
   */
  invitee_email: string;
  /**
   *
   * @type {string}
   * @memberof UserInvitationResponse
   */
  invitation_url?: string | null;
  /**
   *
   * @type {Array<number>}
   * @memberof UserInvitationResponse
   */
  position_ids?: Array<number>;
  /**
   *
   * @type {boolean}
   * @memberof UserInvitationResponse
   */
  pending_grants_recorded?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserInvitationResponse
   */
  created_at?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserInvitationResponse
   */
  expires_at?: string | null;
}
/**
 *
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
  /**
   *
   * @type {Array<ValidationErrorLocInner>}
   * @memberof ValidationError
   */
  loc: Array<ValidationErrorLocInner>;
  /**
   *
   * @type {string}
   * @memberof ValidationError
   */
  msg: string;
  /**
   *
   * @type {string}
   * @memberof ValidationError
   */
  type: string;
  /**
   *
   * @type {any}
   * @memberof ValidationError
   */
  input?: any;
  /**
   *
   * @type {object}
   * @memberof ValidationError
   */
  ctx?: object;
}
/**
 *
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {}
/**
 * How Hope verifies a qualification on the call, named after the question form.  Determined by a text marker appended to the qualification string: - ``(YesNo)`` or no marker -> yes/no or numeric self-report only - ``(Knowledge)`` -> ask candidate to explain a concept or rule - ``(Method)`` -> ask candidate to explain how they perform a concrete task - ``(Example)`` -> one concrete past example (Situation + Action) - ``(STAR)`` -> full STAR probe (Situation, Task, Action, Result)  Older marker names (``Fact``, ``Skill``, ``Experience``, ``Behavioral``, ``YesNoQuestion``, ``AskExample``, ``ConfirmDeeply``) parse as aliases of the canonical members and are never written back.
 * @export
 * @enum {string}
 */

export const VerificationType = {
  YesNo: "YesNo",
  Knowledge: "Knowledge",
  Method: "Method",
  Example: "Example",
  Star: "STAR",
} as const;

export type VerificationType =
  (typeof VerificationType)[keyof typeof VerificationType];

/**
 * Retell connection details exposed to the web client.
 * @export
 * @interface WebCallConnectionResponse
 */
export interface WebCallConnectionResponse {
  /**
   *
   * @type {string}
   * @memberof WebCallConnectionResponse
   */
  access_token: string;
  /**
   *
   * @type {string}
   * @memberof WebCallConnectionResponse
   */
  call_id: string;
  /**
   *
   * @type {string}
   * @memberof WebCallConnectionResponse
   */
  transport: string;
  /**
   *
   * @type {Array<WebCallIceServer>}
   * @memberof WebCallConnectionResponse
   */
  ice_servers: Array<WebCallIceServer>;
  /**
   *
   * @type {number}
   * @memberof WebCallConnectionResponse
   */
  expires_at: number;
}
/**
 * ICE server details needed by the browser transport.
 * @export
 * @interface WebCallIceServer
 */
export interface WebCallIceServer {
  /**
   *
   * @type {Array<string>}
   * @memberof WebCallIceServer
   */
  urls: Array<string>;
  /**
   *
   * @type {string}
   * @memberof WebCallIceServer
   */
  username?: string | null;
  /**
   *
   * @type {string}
   * @memberof WebCallIceServer
   */
  credential?: string | null;
}
/**
 *
 * @export
 * @interface WeeklyStatisticsDetail
 */
export interface WeeklyStatisticsDetail {
  /**
   *
   * @type {string}
   * @memberof WeeklyStatisticsDetail
   */
  week_start: string;
  /**
   *
   * @type {number}
   * @memberof WeeklyStatisticsDetail
   */
  call_count: number;
  /**
   *
   * @type {number}
   * @memberof WeeklyStatisticsDetail
   */
  call_duration_minutes: number;
  /**
   *
   * @type {number}
   * @memberof WeeklyStatisticsDetail
   */
  resume_count: number;
  /**
   *
   * @type {number}
   * @memberof WeeklyStatisticsDetail
   */
  message_count: number;
}
/**
 *
 * @export
 * @interface WeeklyStatisticsResponse
 */
export interface WeeklyStatisticsResponse {
  /**
   *
   * @type {Array<WeeklyStatisticsDetail>}
   * @memberof WeeklyStatisticsResponse
   */
  details: Array<WeeklyStatisticsDetail>;
}
/**
 *
 * @export
 * @interface WeeklySummaryRecipientRequest
 */
export interface WeeklySummaryRecipientRequest {
  /**
   *
   * @type {string}
   * @memberof WeeklySummaryRecipientRequest
   */
  user_id: string;
}
/**
 *
 * @export
 * @interface WeeklySummaryRecipientResponse
 */
export interface WeeklySummaryRecipientResponse {
  /**
   *
   * @type {number}
   * @memberof WeeklySummaryRecipientResponse
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof WeeklySummaryRecipientResponse
   */
  subscription_id?: number;
  /**
   *
   * @type {string}
   * @memberof WeeklySummaryRecipientResponse
   */
  created_at?: string;
  /**
   *
   * @type {string}
   * @memberof WeeklySummaryRecipientResponse
   */
  user_id: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Member Activate
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateOrganizationMember: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("activateOrganizationMember", "userId", userId);
      const localVarPath =
        `/api/organization/members/{user_id}/activate`.replace(
          `{${"user_id"}}`,
          encodeURIComponent(String(userId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Automated Invite Default Source Filter Apply
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyAutomatedInviteDefaultSourceFilter: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/automated_invite/apply_default_source_filter/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Complete Login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeLogin: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/auth/complete-login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Member Deactivate
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deactivateOrganizationMember: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("deactivateOrganizationMember", "userId", userId);
      const localVarPath =
        `/api/organization/members/{user_id}/deactivate`.replace(
          `{${"user_id"}}`,
          encodeURIComponent(String(userId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Faq Delete
     * @param {number} faqId
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCompanyFaq: async (
      faqId: number,
      companyId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'faqId' is not null or undefined
      assertParamExists("deleteCompanyFaq", "faqId", faqId);
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("deleteCompanyFaq", "companyId", companyId);
      const localVarPath = `/api/companies/{company_id}/faqs/{faq_id}/`
        .replace(`{${"faq_id"}}`, encodeURIComponent(String(faqId)))
        .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Invite User Delete
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationInvitation: async (
      invitationId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'invitationId' is not null or undefined
      assertParamExists(
        "deleteOrganizationInvitation",
        "invitationId",
        invitationId,
      );
      const localVarPath =
        `/api/organization/invitations/{invitation_id}`.replace(
          `{${"invitation_id"}}`,
          encodeURIComponent(String(invitationId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permission Delete
     * @param {number} positionId
     * @param {string} userId
     * @param {PositionRole} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationPermission: async (
      positionId: number,
      userId: string,
      role: PositionRole,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "deleteOrganizationPermission",
        "positionId",
        positionId,
      );
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("deleteOrganizationPermission", "userId", userId);
      // verify required parameter 'role' is not null or undefined
      assertParamExists("deleteOrganizationPermission", "role", role);
      const localVarPath =
        `/api/organization/permissions/{user_id}/{position_id}/{role}`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
          .replace(`{${"role"}}`, encodeURIComponent(String(role)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Role Delete
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationRole: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("deleteOrganizationRole", "userId", userId);
      const localVarPath = `/api/organization/roles/{user_id}/admin`.replace(
        `{${"user_id"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Faq Delete
     * @param {number} faqId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePositionFaq: async (
      faqId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'faqId' is not null or undefined
      assertParamExists("deletePositionFaq", "faqId", faqId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("deletePositionFaq", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/faqs/{faq_id}/`
        .replace(`{${"faq_id"}}`, encodeURIComponent(String(faqId)))
        .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Activity Logs Get
     * @param {number | null} [candidateId]
     * @param {number | null} [positionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActivityLogs: async (
      candidateId?: number | null,
      positionId?: number | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/activity_logs/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (candidateId !== undefined) {
        localVarQueryParameter["candidate_id"] = candidateId;
      }

      if (positionId !== undefined) {
        localVarQueryParameter["position_id"] = positionId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllStages: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/stages/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Automated Invite Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInvite: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getAutomatedInvite", "positionId", positionId);
      const localVarPath =
        `/api/automations/automated_invite/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Automated Invite Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInviteDefault: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/automated_invite/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Excluded Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInviteExcludedStages: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/automated_invite/excluded_stages/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Return saved source filters from positions this member can edit.
     * @summary Automated Invite Source Filter Options Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInviteSourceFilterOptions: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/automated_invite/source_filter_options/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Call Analysis Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCallAnalysis: async (
      candidateId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getCallAnalysis", "candidateId", candidateId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCallAnalysis", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/calls/analysis/`
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Calls Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCalls: async (
      candidateId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getCalls", "candidateId", candidateId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCalls", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/calls/`
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidate: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCandidate", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getCandidate", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Get Previous Applications
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidatePreviousApplications: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getCandidatePreviousApplications",
        "positionId",
        positionId,
      );
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists(
        "getCandidatePreviousApplications",
        "candidateId",
        candidateId,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/previous_applications/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Sources Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateSources: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/candidate_sources/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Integration Sync Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateSyncHistory: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCandidateSyncHistory", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/sync/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Timeline Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateTimeline: async (
      candidateId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getCandidateTimeline", "candidateId", candidateId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCandidateTimeline", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/timeline/`
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Guidance Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateTodoGuidance: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCandidateTodoGuidance", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getCandidateTodoGuidance", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/todo_guidance/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidates Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidates: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getCandidates", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/candidates/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Companies Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/companies/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Get
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany: async (
      companyId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("getCompany", "companyId", companyId);
      const localVarPath = `/api/companies/{company_id}/`.replace(
        `{${"company_id"}}`,
        encodeURIComponent(String(companyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Analysis Get
     * @param {number} companyAnalysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAnalysis: async (
      companyAnalysisId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyAnalysisId' is not null or undefined
      assertParamExists(
        "getCompanyAnalysis",
        "companyAnalysisId",
        companyAnalysisId,
      );
      const localVarPath =
        `/api/companies/analyses/{company_analysis_id}/`.replace(
          `{${"company_analysis_id"}}`,
          encodeURIComponent(String(companyAnalysisId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Faq List
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyFaqs: async (
      companyId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("getCompanyFaqs", "companyId", companyId);
      const localVarPath = `/api/companies/{company_id}/faqs/`.replace(
        `{${"company_id"}}`,
        encodeURIComponent(String(companyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Daily Recipient Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailySummaryRecipients: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/summary_recipients/daily/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deactivated Members Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeactivatedOrganizationMembers: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/organization/members/deactivated`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluation: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getEvaluation", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getEvaluation", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{candidate_id}/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Chat Get
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationChat: async (
      evaluationId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'evaluationId' is not null or undefined
      assertParamExists("getEvaluationChat", "evaluationId", evaluationId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getEvaluationChat", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{evaluation_id}/chat/`
          .replace(
            `{${"evaluation_id"}}`,
            encodeURIComponent(String(evaluationId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Email Recipient Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationEmailRecipients: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getEvaluationEmailRecipients",
        "positionId",
        positionId,
      );
      const localVarPath =
        `/api/automations/evaluation_email_recipients/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Email Setting Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationEmailSetting: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getEvaluationEmailSetting", "positionId", positionId);
      const localVarPath =
        `/api/automations/evaluation_email_settings/positions/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Email Setting Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationEmailSettingDefault: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/evaluation_email_settings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Latest Recipients Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationRecipients: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getEvaluationRecipients", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/evaluations/recipients/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluations Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluations: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getEvaluations", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/evaluations/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Return candidates from live positions visible to the caller.
     * @summary Live Position Candidates Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGlobalCandidates: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/positions/live/candidates/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * List hiring-stage rows across the caller\'s org, scoped to (for non-admins) the positions they may edit.
     * @summary Hiring Stages Get
     * @param {Array<HiringStage>} [stage]
     * @param {number} [limit]
     * @param {boolean} [pending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHiringStages: async (
      stage?: Array<HiringStage>,
      limit?: number,
      pending?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/hiring_stages/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (stage) {
        localVarQueryParameter["stage"] = stage;
      }

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      if (pending !== undefined) {
        localVarQueryParameter["pending"] = pending;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Read the current sync statuses for the active integration.
     * @summary Integration Sync Statuses Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrationSyncStatuses: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/sync/statuses/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Integrations Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrations: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Invitation Slots Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvitationSlots: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getInvitationSlots", "positionId", positionId);
      const localVarPath =
        `/api/automations/automated_invite/{position_id}/invitation_slots/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Job Analysis Get
     * @param {number} jobAnalysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobAnalysis: async (
      jobAnalysisId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'jobAnalysisId' is not null or undefined
      assertParamExists("getJobAnalysis", "jobAnalysisId", jobAnalysisId);
      const localVarPath = `/api/positions/analyses/{job_analysis_id}/`.replace(
        `{${"job_analysis_id"}}`,
        encodeURIComponent(String(jobAnalysisId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Called by the frontend on ``?boost=success``; shares the confirm routine with the Stripe webhook so payment is recorded exactly once regardless of which one lands first.
     * @summary Boost Checkout Confirm Get
     * @param {number} positionId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobBoardBoostCheckoutConfirm: async (
      positionId: number,
      sessionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getJobBoardBoostCheckoutConfirm",
        "positionId",
        positionId,
      );
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists(
        "getJobBoardBoostCheckoutConfirm",
        "sessionId",
        sessionId,
      );
      const localVarPath =
        `/api/positions/{position_id}/job_board_boost/checkout/confirm`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (sessionId !== undefined) {
        localVarQueryParameter["session_id"] = sessionId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Boost Recommendation Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobBoardBoostRecommendation: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getJobBoardBoostRecommendation",
        "positionId",
        positionId,
      );
      const localVarPath =
        `/api/positions/{position_id}/job_board_boost/recommendation`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Job States Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobStates: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/job_states/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Kombo Tools Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKomboTools: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/kombo/tools`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Call Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestCall: async (
      candidateId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getLatestCall", "candidateId", candidateId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getLatestCall", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/calls/latest/`
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Call Simulation Get Latest
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestCallSimulation: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getLatestCallSimulation", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/call_simulations/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Qualification Chat Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestPositionQualificationChat: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getLatestPositionQualificationChat",
        "positionId",
        positionId,
      );
      const localVarPath =
        `/api/positions/{position_id}/qualification/chat/latest/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Live Positions Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLivePositions: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/positions/live/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Offer Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferStages: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/stages/offer/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * No `validate_subscription`: a first-time user may not have an active subscription yet.
     * @summary Onboarding Tour Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboardingTour: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/onboarding_tour/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Invite User Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationInvitations: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/organization/invitations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Members Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationMembers: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/organization/members/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Phone Number Lookup Get
     * @param {string} phoneNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPhoneNumberLookup: async (
      phoneNumber: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'phoneNumber' is not null or undefined
      assertParamExists("getPhoneNumberLookup", "phoneNumber", phoneNumber);
      const localVarPath = `/api/phone_number_lookup/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (phoneNumber !== undefined) {
        localVarQueryParameter["phone_number"] = phoneNumber;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPosition: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getPosition", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Chat Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionChat: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getPositionChat", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/chat/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Faqs Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionFaqs: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getPositionFaqs", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/faqs/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Return each active member\'s positions with the requested role.
     * @summary Position Memberships Get
     * @param {PositionRole} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionMemberships: async (
      role?: PositionRole,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/organization/permissions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (role !== undefined) {
        localVarQueryParameter["role"] = role;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Return the findings on the stored qualification lines that keep the position from going live.  Only block-severity findings are included; warnings are not. The call has no side effects, and a position of another organization responds 404.
     * @summary Position Qualification Check Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionQualificationCheck: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getPositionQualificationCheck",
        "positionId",
        positionId,
      );
      const localVarPath =
        `/api/positions/{position_id}/qualification_check`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Stages Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionStages: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getPositionStages", "positionId", positionId);
      const localVarPath = `/api/integrations/stages/{position_id}/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Integration Sync Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionSyncHistory: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/positions/sync/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Users Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionUsers: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getPositionUsers", "positionId", positionId);
      const localVarPath =
        `/api/organization/permissions/position/{position_id}`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Positions Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositions: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/positions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get Public Position
     * @param {string} positionPublicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPosition: async (
      positionPublicId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionPublicId' is not null or undefined
      assertParamExists(
        "getPublicPosition",
        "positionPublicId",
        positionPublicId,
      );
      const localVarPath = `/public_api/position/{position_public_id}/`.replace(
        `{${"position_public_id"}}`,
        encodeURIComponent(String(positionPublicId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get Public Positions
     * @param {string} companySlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPositions: async (
      companySlug: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companySlug' is not null or undefined
      assertParamExists("getPublicPositions", "companySlug", companySlug);
      const localVarPath = `/public_api/positions/{company_slug}/`.replace(
        `{${"company_slug"}}`,
        encodeURIComponent(String(companySlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Rejection Message Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRejectionMessage: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/rejection_message/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Rejection Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRejectionReasons: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/rejection_reasons/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Get
     * @param {number} positionId
     * @param {number} resumeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResume: async (
      positionId: number,
      resumeId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getResume", "positionId", positionId);
      // verify required parameter 'resumeId' is not null or undefined
      assertParamExists("getResume", "resumeId", resumeId);
      const localVarPath = `/api/positions/{position_id}/resumes/{resume_id}/`
        .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
        .replace(`{${"resume_id"}}`, encodeURIComponent(String(resumeId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Chat Get
     * @param {number} resumeId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResumeChat: async (
      resumeId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'resumeId' is not null or undefined
      assertParamExists("getResumeChat", "resumeId", resumeId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getResumeChat", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/resumes/{resume_id}/chat/`
          .replace(`{${"resume_id"}}`, encodeURIComponent(String(resumeId)))
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Integration Sync Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResumeSyncHistory: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getResumeSyncHistory", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/resumes/sync/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resumes Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResumes: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getResumes", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/resumes/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * List open review items, scoped to the caller\'s org and (for non-admins) editable positions.
     * @summary Review Items Get
     * @param {Array<ReviewItemCategory>} [category]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReviewItems: async (
      category?: Array<ReviewItemCategory>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/review_items/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (category) {
        localVarQueryParameter["category"] = category;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Return the organization\'s ROI dashboard settings, or ``null`` when no member has saved them yet.
     * @summary Roi Metrics Settings Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoiSettings: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/roi_settings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Share Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShareEvaluation: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getShareEvaluation", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("getShareEvaluation", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{candidate_id}/share/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stage Transitions Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStageTransitions: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getStageTransitions", "positionId", positionId);
      const localVarPath =
        `/api/automations/stage_transitions/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stage Transitions Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStageTransitionsDefault: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/stage_transitions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Statistics Get
     * @param {string | null} [before]
     * @param {string | null} [after]
     * @param {Array<number>} [companyIds]
     * @param {Array<number>} [positionIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatistics: async (
      before?: string | null,
      after?: string | null,
      companyIds?: Array<number>,
      positionIds?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/statistics/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (before !== undefined) {
        localVarQueryParameter["before"] =
          (before as any) instanceof Date
            ? (before as any).toISOString()
            : before;
      }

      if (after !== undefined) {
        localVarQueryParameter["after"] =
          (after as any) instanceof Date ? (after as any).toISOString() : after;
      }

      if (companyIds) {
        localVarQueryParameter["company_ids"] = companyIds;
      }

      if (positionIds) {
        localVarQueryParameter["position_ids"] = positionIds;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Subscription Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/subscription/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Integration Sync Status Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncCandidateStatus: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getSyncCandidateStatus", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/sync/status/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Integration Sync Status Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncPositionStatus: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/positions/sync/status/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Integration Sync Status Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncResumeStatus: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("getSyncResumeStatus", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/resumes/sync/status/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Timeline Translate Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTranslatedCandidateTimeline: async (
      candidateId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists(
        "getTranslatedCandidateTimeline",
        "candidateId",
        candidateId,
      );
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getTranslatedCandidateTimeline",
        "positionId",
        positionId,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/timeline/translate/`
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get Unresponsive Candidate Log
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnresponsiveCandidateLog: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "getUnresponsiveCandidateLog",
        "positionId",
        positionId,
      );
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists(
        "getUnresponsiveCandidateLog",
        "candidateId",
        candidateId,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/unresponsive_log/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary User Positions Get
     * @param {string} userId
     * @param {PositionRole} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPositions: async (
      userId: string,
      role?: PositionRole,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getUserPositions", "userId", userId);
      const localVarPath =
        `/api/organization/permissions/user/{user_id}`.replace(
          `{${"user_id"}}`,
          encodeURIComponent(String(userId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (role !== undefined) {
        localVarQueryParameter["role"] = role;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Weekly Statistics Get
     * @param {string | null} [before]
     * @param {string | null} [after]
     * @param {Array<number>} [companyIds]
     * @param {Array<number>} [positionIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWeeklyStatistics: async (
      before?: string | null,
      after?: string | null,
      companyIds?: Array<number>,
      positionIds?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/statistics/weekly`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (before !== undefined) {
        localVarQueryParameter["before"] =
          (before as any) instanceof Date
            ? (before as any).toISOString()
            : before;
      }

      if (after !== undefined) {
        localVarQueryParameter["after"] =
          (after as any) instanceof Date ? (after as any).toISOString() : after;
      }

      if (companyIds) {
        localVarQueryParameter["company_ids"] = companyIds;
      }

      if (positionIds) {
        localVarQueryParameter["position_ids"] = positionIds;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Weekly Recipient Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWeeklySummaryRecipients: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/automations/summary_recipients/weekly/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Admin-only atomic move of an answered position FAQ into the company library; see ``PositionService.move_faq_to_company`` for the locking/transaction contract.
     * @summary Position Faq Move To Company
     * @param {number} faqId
     * @param {number} positionId
     * @param {PositionFaqMoveRequest} positionFaqMoveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    movePositionFaqToCompany: async (
      faqId: number,
      positionId: number,
      positionFaqMoveRequest: PositionFaqMoveRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'faqId' is not null or undefined
      assertParamExists("movePositionFaqToCompany", "faqId", faqId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("movePositionFaqToCompany", "positionId", positionId);
      // verify required parameter 'positionFaqMoveRequest' is not null or undefined
      assertParamExists(
        "movePositionFaqToCompany",
        "positionFaqMoveRequest",
        positionFaqMoveRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/faqs/{faq_id}/move_to_company/`
          .replace(`{${"faq_id"}}`, encodeURIComponent(String(faqId)))
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionFaqMoveRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Automated Invite Paused Patch
     * @param {number} positionId
     * @param {AutomatedInvitePausedRequest} automatedInvitePausedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutomatedInvitePaused: async (
      positionId: number,
      automatedInvitePausedRequest: AutomatedInvitePausedRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchAutomatedInvitePaused", "positionId", positionId);
      // verify required parameter 'automatedInvitePausedRequest' is not null or undefined
      assertParamExists(
        "patchAutomatedInvitePaused",
        "automatedInvitePausedRequest",
        automatedInvitePausedRequest,
      );
      const localVarPath =
        `/api/automations/automated_invite/{position_id}/paused/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        automatedInvitePausedRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {CandidatePatchRequest} candidatePatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCandidate: async (
      positionId: number,
      candidateId: number,
      candidatePatchRequest: CandidatePatchRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchCandidate", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("patchCandidate", "candidateId", candidateId);
      // verify required parameter 'candidatePatchRequest' is not null or undefined
      assertParamExists(
        "patchCandidate",
        "candidatePatchRequest",
        candidatePatchRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        candidatePatchRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Mark ``candidate``\'s placement as ours to follow, or stop following it, without touching the offer.  Separate from the PUT: the toggle must work with no offer to resend — an In Process candidate has none yet, an Onboarding one can no longer submit one.
     * @summary Candidate Tracked Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {HiringStageTrackedRequest} hiringStageTrackedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCandidateTracked: async (
      positionId: number,
      candidateId: number,
      hiringStageTrackedRequest: HiringStageTrackedRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchCandidateTracked", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("patchCandidateTracked", "candidateId", candidateId);
      // verify required parameter 'hiringStageTrackedRequest' is not null or undefined
      assertParamExists(
        "patchCandidateTracked",
        "hiringStageTrackedRequest",
        hiringStageTrackedRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/hiring_stage/tracked/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hiringStageTrackedRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Patch
     * @param {number} companyId
     * @param {CompanyRequest} companyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCompany: async (
      companyId: number,
      companyRequest: CompanyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("patchCompany", "companyId", companyId);
      // verify required parameter 'companyRequest' is not null or undefined
      assertParamExists("patchCompany", "companyRequest", companyRequest);
      const localVarPath = `/api/companies/{company_id}/`.replace(
        `{${"company_id"}}`,
        encodeURIComponent(String(companyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        companyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvaluation: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchEvaluation", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("patchEvaluation", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{candidate_id}/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Checkpoint Patch
     * @param {number} candidateId
     * @param {number} evaluationCheckpointId
     * @param {number} positionId
     * @param {BodyPatchEvaluationCheckpoint} bodyPatchEvaluationCheckpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvaluationCheckpoint: async (
      candidateId: number,
      evaluationCheckpointId: number,
      positionId: number,
      bodyPatchEvaluationCheckpoint: BodyPatchEvaluationCheckpoint,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists(
        "patchEvaluationCheckpoint",
        "candidateId",
        candidateId,
      );
      // verify required parameter 'evaluationCheckpointId' is not null or undefined
      assertParamExists(
        "patchEvaluationCheckpoint",
        "evaluationCheckpointId",
        evaluationCheckpointId,
      );
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchEvaluationCheckpoint", "positionId", positionId);
      // verify required parameter 'bodyPatchEvaluationCheckpoint' is not null or undefined
      assertParamExists(
        "patchEvaluationCheckpoint",
        "bodyPatchEvaluationCheckpoint",
        bodyPatchEvaluationCheckpoint,
      );
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{candidate_id}/checkpoint/{evaluation_checkpoint_id}`
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          )
          .replace(
            `{${"evaluation_checkpoint_id"}}`,
            encodeURIComponent(String(evaluationCheckpointId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bodyPatchEvaluationCheckpoint,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluations Patch
     * @param {number} positionId
     * @param {Array<EvaluateCandidateRequest>} evaluateCandidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvaluationsBulk: async (
      positionId: number,
      evaluateCandidateRequest: Array<EvaluateCandidateRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchEvaluationsBulk", "positionId", positionId);
      // verify required parameter 'evaluateCandidateRequest' is not null or undefined
      assertParamExists(
        "patchEvaluationsBulk",
        "evaluateCandidateRequest",
        evaluateCandidateRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/evaluations/bulk/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        evaluateCandidateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Patch
     * @param {number} positionId
     * @param {PositionPatchRequest} positionPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPosition: async (
      positionId: number,
      positionPatchRequest: PositionPatchRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchPosition", "positionId", positionId);
      // verify required parameter 'positionPatchRequest' is not null or undefined
      assertParamExists(
        "patchPosition",
        "positionPatchRequest",
        positionPatchRequest,
      );
      const localVarPath = `/api/positions/{position_id}/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionPatchRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Patch
     * @param {number} positionId
     * @param {number} resumeId
     * @param {ResumeRequest} resumeRequest
     * @param {boolean} [cancelQueuedInvite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchResume: async (
      positionId: number,
      resumeId: number,
      resumeRequest: ResumeRequest,
      cancelQueuedInvite?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("patchResume", "positionId", positionId);
      // verify required parameter 'resumeId' is not null or undefined
      assertParamExists("patchResume", "resumeId", resumeId);
      // verify required parameter 'resumeRequest' is not null or undefined
      assertParamExists("patchResume", "resumeRequest", resumeRequest);
      const localVarPath = `/api/positions/{position_id}/resumes/{resume_id}/`
        .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
        .replace(`{${"resume_id"}}`, encodeURIComponent(String(resumeId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cancelQueuedInvite !== undefined) {
        localVarQueryParameter["cancel_queued_invite"] = cancelQueuedInvite;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        resumeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Apply a resolution transition (admin bypass; non-admin needs CAN_EDIT on the item\'s position).  Domain errors map to 409: an ``unknown``-row transition, an Undo colliding with another open advancement, or an Undo of an already-offered candidate.
     * @summary Review Item Patch
     * @param {number} reviewItemId
     * @param {ReviewItemResolutionRequest} reviewItemResolutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchReviewItem: async (
      reviewItemId: number,
      reviewItemResolutionRequest: ReviewItemResolutionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'reviewItemId' is not null or undefined
      assertParamExists("patchReviewItem", "reviewItemId", reviewItemId);
      // verify required parameter 'reviewItemResolutionRequest' is not null or undefined
      assertParamExists(
        "patchReviewItem",
        "reviewItemResolutionRequest",
        reviewItemResolutionRequest,
      );
      const localVarPath = `/api/review_items/{review_item_id}/`.replace(
        `{${"review_item_id"}}`,
        encodeURIComponent(String(reviewItemId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        reviewItemResolutionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Automated Invite Post
     * @param {number} positionId
     * @param {AutomatedInviteRequest} automatedInviteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutomatedInvite: async (
      positionId: number,
      automatedInviteRequest: AutomatedInviteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postAutomatedInvite", "positionId", positionId);
      // verify required parameter 'automatedInviteRequest' is not null or undefined
      assertParamExists(
        "postAutomatedInvite",
        "automatedInviteRequest",
        automatedInviteRequest,
      );
      const localVarPath =
        `/api/automations/automated_invite/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        automatedInviteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Automated Invite Default Post
     * @param {AutomatedInviteDefaultRequest} automatedInviteDefaultRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutomatedInviteDefault: async (
      automatedInviteDefaultRequest: AutomatedInviteDefaultRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'automatedInviteDefaultRequest' is not null or undefined
      assertParamExists(
        "postAutomatedInviteDefault",
        "automatedInviteDefaultRequest",
        automatedInviteDefaultRequest,
      );
      const localVarPath = `/api/automations/automated_invite/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        automatedInviteDefaultRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Excluded Stages Post
     * @param {BodyPostAutomatedInviteExcludedStages} bodyPostAutomatedInviteExcludedStages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutomatedInviteExcludedStages: async (
      bodyPostAutomatedInviteExcludedStages: BodyPostAutomatedInviteExcludedStages,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bodyPostAutomatedInviteExcludedStages' is not null or undefined
      assertParamExists(
        "postAutomatedInviteExcludedStages",
        "bodyPostAutomatedInviteExcludedStages",
        bodyPostAutomatedInviteExcludedStages,
      );
      const localVarPath = `/api/automations/automated_invite/excluded_stages/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bodyPostAutomatedInviteExcludedStages,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Initiate an immediate call to the candidate without sending any messages.
     * @summary Call Immediate
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallImmediate: async (
      candidateId: number,
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("postCallImmediate", "candidateId", candidateId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCallImmediate", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/calls/immediate/`
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          )
          .replace(
            `{${"position_id"}}`,
            encodeURIComponent(String(positionId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Call Simulation Post
     * @param {number} positionId
     * @param {CallSimulationRequest} [callSimulationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallSimulation: async (
      positionId: number,
      callSimulationRequest?: CallSimulationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCallSimulation", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/call_simulations/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        callSimulationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Revise the suggested rewrite of one settings-coverage judgement using the recruiter\'s comment.  Returns only the revised judgement — the client already holds the rest of the job and must not re-download the transcript.
     * @summary Call Simulation Coverage Rewrite Post
     * @param {number} positionId
     * @param {number} jobId
     * @param {string} settingKey
     * @param {SettingsCoverageRewriteRequest} settingsCoverageRewriteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallSimulationCoverageRewrite: async (
      positionId: number,
      jobId: number,
      settingKey: string,
      settingsCoverageRewriteRequest: SettingsCoverageRewriteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "postCallSimulationCoverageRewrite",
        "positionId",
        positionId,
      );
      // verify required parameter 'jobId' is not null or undefined
      assertParamExists("postCallSimulationCoverageRewrite", "jobId", jobId);
      // verify required parameter 'settingKey' is not null or undefined
      assertParamExists(
        "postCallSimulationCoverageRewrite",
        "settingKey",
        settingKey,
      );
      // verify required parameter 'settingsCoverageRewriteRequest' is not null or undefined
      assertParamExists(
        "postCallSimulationCoverageRewrite",
        "settingsCoverageRewriteRequest",
        settingsCoverageRewriteRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/call_simulations/{job_id}/settings_coverage/{setting_key}/rewrite`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)))
          .replace(
            `{${"setting_key"}}`,
            encodeURIComponent(String(settingKey)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        settingsCoverageRewriteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Call Test Post
     * @param {number} positionId
     * @param {CallTestRequest} callTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallTest: async (
      positionId: number,
      callTestRequest: CallTestRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCallTest", "positionId", positionId);
      // verify required parameter 'callTestRequest' is not null or undefined
      assertParamExists("postCallTest", "callTestRequest", callTestRequest);
      const localVarPath = `/api/positions/{position_id}/call/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        callTestRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidates Post
     * @param {number} positionId
     * @param {CandidateRequest} candidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidate: async (
      positionId: number,
      candidateRequest: CandidateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCandidate", "positionId", positionId);
      // verify required parameter 'candidateRequest' is not null or undefined
      assertParamExists("postCandidate", "candidateRequest", candidateRequest);
      const localVarPath = `/api/positions/{position_id}/candidates/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        candidateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Idempotently move ``candidate`` to In Process; returns 409 if archived/withdrawn, already offered, or a concurrent race is lost (retry).
     * @summary Candidate Advancement Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateAdvancement: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCandidateAdvancement", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("postCandidateAdvancement", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/advancement/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidates Post Bulk
     * @param {number} positionId
     * @param {Array<CandidateRequest>} candidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateBulk: async (
      positionId: number,
      candidateRequest: Array<CandidateRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCandidateBulk", "positionId", positionId);
      // verify required parameter 'candidateRequest' is not null or undefined
      assertParamExists(
        "postCandidateBulk",
        "candidateRequest",
        candidateRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/bulk`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        candidateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Decision Reject
     * @param {number} positionId
     * @param {number} candidateId
     * @param {CandidateDecisionRejectRequest} candidateDecisionRejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateDecisionReject: async (
      positionId: number,
      candidateId: number,
      candidateDecisionRejectRequest: CandidateDecisionRejectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "postCandidateDecisionReject",
        "positionId",
        positionId,
      );
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists(
        "postCandidateDecisionReject",
        "candidateId",
        candidateId,
      );
      // verify required parameter 'candidateDecisionRejectRequest' is not null or undefined
      assertParamExists(
        "postCandidateDecisionReject",
        "candidateDecisionRejectRequest",
        candidateDecisionRejectRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/decisions/reject`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        candidateDecisionRejectRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Return the email the signed-in recruiter can send to reach this candidate through the relay.  The address comes from the authenticated identity rather than the request body. The first sender to write to a relay address claims it, so a client-supplied value could claim a colleague\'s thread.  Raises:     HTTPException: 409 if the candidate\'s AI screening has not produced a usable evaluation yet.
     * @summary Candidate Relay Draft Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateRelayDraft: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCandidateRelayDraft", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("postCandidateRelayDraft", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/relay_draft/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Candidate Integration Sync Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateSync: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCandidateSync", "positionId", positionId);
      const localVarPath =
        `/api/positions/{position_id}/candidates/sync/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Guidance Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateTodoGuidance: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postCandidateTodoGuidance", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists(
        "postCandidateTodoGuidance",
        "candidateId",
        candidateId,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/todo_guidance/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Guidance Mark As Completed
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateTodoGuidanceMarkAsCompleted: async (
      positionId: number,
      candidateId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "postCandidateTodoGuidanceMarkAsCompleted",
        "positionId",
        positionId,
      );
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists(
        "postCandidateTodoGuidanceMarkAsCompleted",
        "candidateId",
        candidateId,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/todo_guidance/action/mark_as_completed/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Companies Post
     * @param {CompanyRequest} companyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompany: async (
      companyRequest: CompanyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyRequest' is not null or undefined
      assertParamExists("postCompany", "companyRequest", companyRequest);
      const localVarPath = `/api/companies/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        companyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Agent Preview Post
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAgentPreview: async (
      companyId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("postCompanyAgentPreview", "companyId", companyId);
      const localVarPath = `/api/companies/{company_id}/agent_preview/`.replace(
        `{${"company_id"}}`,
        encodeURIComponent(String(companyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Analyses Post
     * @param {CompanyAnalysisRequest} companyAnalysisRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAnalysis: async (
      companyAnalysisRequest: CompanyAnalysisRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyAnalysisRequest' is not null or undefined
      assertParamExists(
        "postCompanyAnalysis",
        "companyAnalysisRequest",
        companyAnalysisRequest,
      );
      const localVarPath = `/api/companies/analyses/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        companyAnalysisRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Faq Create
     * @param {number} companyId
     * @param {CompanyFaqRequest} companyFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyFaq: async (
      companyId: number,
      companyFaqRequest: CompanyFaqRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("postCompanyFaq", "companyId", companyId);
      // verify required parameter 'companyFaqRequest' is not null or undefined
      assertParamExists(
        "postCompanyFaq",
        "companyFaqRequest",
        companyFaqRequest,
      );
      const localVarPath = `/api/companies/{company_id}/faqs/`.replace(
        `{${"company_id"}}`,
        encodeURIComponent(String(companyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        companyFaqRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Logo Post
     * @param {number} companyId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyLogo: async (
      companyId: number,
      file: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("postCompanyLogo", "companyId", companyId);
      // verify required parameter 'file' is not null or undefined
      assertParamExists("postCompanyLogo", "file", file);
      const localVarPath = `/api/companies/{company_id}/logo`.replace(
        `{${"company_id"}}`,
        encodeURIComponent(String(companyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )();

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Voice Preview Post
     * @param {AgentVoice} agentVoiceId
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyVoicePreview: async (
      agentVoiceId: AgentVoice,
      companyId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'agentVoiceId' is not null or undefined
      assertParamExists(
        "postCompanyVoicePreview",
        "agentVoiceId",
        agentVoiceId,
      );
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("postCompanyVoicePreview", "companyId", companyId);
      const localVarPath =
        `/api/companies/{company_id}/voice_preview/{agent_voice_id}/`
          .replace(
            `{${"agent_voice_id"}}`,
            encodeURIComponent(String(agentVoiceId)),
          )
          .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Daily Recipient Post
     * @param {Array<DailySummaryRecipientRequest>} dailySummaryRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDailySummaryRecipients: async (
      dailySummaryRecipientRequest: Array<DailySummaryRecipientRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dailySummaryRecipientRequest' is not null or undefined
      assertParamExists(
        "postDailySummaryRecipients",
        "dailySummaryRecipientRequest",
        dailySummaryRecipientRequest,
      );
      const localVarPath = `/api/automations/summary_recipients/daily/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        dailySummaryRecipientRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Chat Post
     * @param {number} positionId
     * @param {number} evaluationId
     * @param {EvaluationChatRequest} evaluationChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEvaluationChat: async (
      positionId: number,
      evaluationId: number,
      evaluationChatRequest: EvaluationChatRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postEvaluationChat", "positionId", positionId);
      // verify required parameter 'evaluationId' is not null or undefined
      assertParamExists("postEvaluationChat", "evaluationId", evaluationId);
      // verify required parameter 'evaluationChatRequest' is not null or undefined
      assertParamExists(
        "postEvaluationChat",
        "evaluationChatRequest",
        evaluationChatRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{evaluation_id}/chat/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"evaluation_id"}}`,
            encodeURIComponent(String(evaluationId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        evaluationChatRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Email Recipient Post
     * @param {number} positionId
     * @param {Array<EvaluationEmailRecipientRequest>} evaluationEmailRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEvaluationEmailRecipients: async (
      positionId: number,
      evaluationEmailRecipientRequest: Array<EvaluationEmailRecipientRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "postEvaluationEmailRecipients",
        "positionId",
        positionId,
      );
      // verify required parameter 'evaluationEmailRecipientRequest' is not null or undefined
      assertParamExists(
        "postEvaluationEmailRecipients",
        "evaluationEmailRecipientRequest",
        evaluationEmailRecipientRequest,
      );
      const localVarPath =
        `/api/automations/evaluation_email_recipients/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        evaluationEmailRecipientRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Export Post
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {number} candidateId
     * @param {boolean} [skipIntegration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEvaluationExport: async (
      evaluationId: number,
      positionId: number,
      candidateId: number,
      skipIntegration?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'evaluationId' is not null or undefined
      assertParamExists("postEvaluationExport", "evaluationId", evaluationId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postEvaluationExport", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("postEvaluationExport", "candidateId", candidateId);
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{candidate_id}/export/{evaluation_id}`
          .replace(
            `{${"evaluation_id"}}`,
            encodeURIComponent(String(evaluationId)),
          )
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (skipIntegration !== undefined) {
        localVarQueryParameter["skip_integration"] = skipIntegration;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Generate a question for the new-position wizard before a position row exists.
     * @summary Qualification Question Post
     * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postGenerateQualificationQuestion: async (
      positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionQualificationQuestionGenerationRequest' is not null or undefined
      assertParamExists(
        "postGenerateQualificationQuestion",
        "positionQualificationQuestionGenerationRequest",
        positionQualificationQuestionGenerationRequest,
      );
      const localVarPath = `/api/positions/qualification/generate_question`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionQualificationQuestionGenerationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Help Center Chat Post
     * @param {HelpCenterChatRequest} helpCenterChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postHelpCenterChat: async (
      helpCenterChatRequest: HelpCenterChatRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'helpCenterChatRequest' is not null or undefined
      assertParamExists(
        "postHelpCenterChat",
        "helpCenterChatRequest",
        helpCenterChatRequest,
      );
      const localVarPath = `/api/help_center/chat/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        helpCenterChatRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Integrations Post
     * @param {IntegrationRequest} integrationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postIntegration: async (
      integrationRequest: IntegrationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'integrationRequest' is not null or undefined
      assertParamExists(
        "postIntegration",
        "integrationRequest",
        integrationRequest,
      );
      const localVarPath = `/api/integrations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        integrationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Post Deploy Call Post
     * @param {string} xPostDeployE2EToken
     * @param {PostDeployCallRequest} postDeployCallRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternalE2EPostDeployCall: async (
      xPostDeployE2EToken: string,
      postDeployCallRequest: PostDeployCallRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'xPostDeployE2EToken' is not null or undefined
      assertParamExists(
        "postInternalE2EPostDeployCall",
        "xPostDeployE2EToken",
        xPostDeployE2EToken,
      );
      // verify required parameter 'postDeployCallRequest' is not null or undefined
      assertParamExists(
        "postInternalE2EPostDeployCall",
        "postDeployCallRequest",
        postDeployCallRequest,
      );
      const localVarPath = `/internal/e2e/post_deploy_call/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (xPostDeployE2EToken != null) {
        localVarHeaderParameter["X-Post-Deploy-E2E-Token"] =
          String(xPostDeployE2EToken);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        postDeployCallRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Job Analyses Post
     * @param {JobAnalysisRequest} jobAnalysisRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobAnalysis: async (
      jobAnalysisRequest: JobAnalysisRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'jobAnalysisRequest' is not null or undefined
      assertParamExists(
        "postJobAnalysis",
        "jobAnalysisRequest",
        jobAnalysisRequest,
      );
      const localVarPath = `/api/positions/analyses/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        jobAnalysisRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Job Analyses Upload Post
     * @param {number} companyId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobAnalysisUpload: async (
      companyId: number,
      file: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("postJobAnalysisUpload", "companyId", companyId);
      // verify required parameter 'file' is not null or undefined
      assertParamExists("postJobAnalysisUpload", "file", file);
      const localVarPath = `/api/positions/analyses/file_upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )();

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (companyId !== undefined) {
        localVarQueryParameter["company_id"] = companyId;
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Job Analyses Start Web Call Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobAnalysisWebCall: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/positions/analyses/web_call`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Boost Checkout Post
     * @param {number} positionId
     * @param {JobBoardBoostCheckoutRequest} jobBoardBoostCheckoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobBoardBoostCheckout: async (
      positionId: number,
      jobBoardBoostCheckoutRequest: JobBoardBoostCheckoutRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postJobBoardBoostCheckout", "positionId", positionId);
      // verify required parameter 'jobBoardBoostCheckoutRequest' is not null or undefined
      assertParamExists(
        "postJobBoardBoostCheckout",
        "jobBoardBoostCheckoutRequest",
        jobBoardBoostCheckoutRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/job_board_boost/checkout`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        jobBoardBoostCheckoutRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Boost Recommendation Post
     * @param {number} positionId
     * @param {JobBoardBoostRecommendationRequest} jobBoardBoostRecommendationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobBoardBoostRecommendation: async (
      positionId: number,
      jobBoardBoostRecommendationRequest: JobBoardBoostRecommendationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "postJobBoardBoostRecommendation",
        "positionId",
        positionId,
      );
      // verify required parameter 'jobBoardBoostRecommendationRequest' is not null or undefined
      assertParamExists(
        "postJobBoardBoostRecommendation",
        "jobBoardBoostRecommendationRequest",
        jobBoardBoostRecommendationRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/job_board_boost/recommendation`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        jobBoardBoostRecommendationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Kombo Activate Post
     * @param {BodyPostKomboActivate} bodyPostKomboActivate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboActivate: async (
      bodyPostKomboActivate: BodyPostKomboActivate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'bodyPostKomboActivate' is not null or undefined
      assertParamExists(
        "postKomboActivate",
        "bodyPostKomboActivate",
        bodyPostKomboActivate,
      );
      const localVarPath = `/api/integrations/kombo/activate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bodyPostKomboActivate,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Webhook Kombo Data Changed
     * @param {KomboDataChangedWebhook} komboDataChangedWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboDataChanged: async (
      komboDataChangedWebhook: KomboDataChangedWebhook,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'komboDataChangedWebhook' is not null or undefined
      assertParamExists(
        "postKomboDataChanged",
        "komboDataChangedWebhook",
        komboDataChangedWebhook,
      );
      const localVarPath = `/webhook/kombo/data_changed/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        komboDataChangedWebhook,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Kombo Init Post
     * @param {BodyPostKomboInit} [bodyPostKomboInit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboInit: async (
      bodyPostKomboInit?: BodyPostKomboInit,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/integrations/kombo/init`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bodyPostKomboInit,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Webhook Kombo Sync Finished
     * @param {KomboSyncFinishedWebhook} komboSyncFinishedWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboSyncFinished: async (
      komboSyncFinishedWebhook: KomboSyncFinishedWebhook,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'komboSyncFinishedWebhook' is not null or undefined
      assertParamExists(
        "postKomboSyncFinished",
        "komboSyncFinishedWebhook",
        komboSyncFinishedWebhook,
      );
      const localVarPath = `/webhook/kombo/sync_finished/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        komboSyncFinishedWebhook,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Onboarding Tour Complete Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOnboardingTour: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/onboarding_tour/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Invite User Post
     * @param {UserInvitationRequest} userInvitationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationInvitation: async (
      userInvitationRequest: UserInvitationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userInvitationRequest' is not null or undefined
      assertParamExists(
        "postOrganizationInvitation",
        "userInvitationRequest",
        userInvitationRequest,
      );
      const localVarPath = `/api/organization/invitations/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userInvitationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Permission Post
     * @param {number} positionId
     * @param {string} userId
     * @param {PositionRole} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationPermission: async (
      positionId: number,
      userId: string,
      role: PositionRole,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postOrganizationPermission", "positionId", positionId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("postOrganizationPermission", "userId", userId);
      // verify required parameter 'role' is not null or undefined
      assertParamExists("postOrganizationPermission", "role", role);
      const localVarPath =
        `/api/organization/permissions/{user_id}/{position_id}/{role}`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
          .replace(`{${"role"}}`, encodeURIComponent(String(role)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Role Post
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationRole: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("postOrganizationRole", "userId", userId);
      const localVarPath = `/api/organization/roles/{user_id}/admin`.replace(
        `{${"user_id"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Positions Post
     * @param {PositionRequest} positionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPosition: async (
      positionRequest: PositionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionRequest' is not null or undefined
      assertParamExists("postPosition", "positionRequest", positionRequest);
      const localVarPath = `/api/positions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Chat Post
     * @param {number} positionId
     * @param {PositionChatRequest} positionChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionChat: async (
      positionId: number,
      positionChatRequest: PositionChatRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postPositionChat", "positionId", positionId);
      // verify required parameter 'positionChatRequest' is not null or undefined
      assertParamExists(
        "postPositionChat",
        "positionChatRequest",
        positionChatRequest,
      );
      const localVarPath = `/api/positions/{position_id}/chat/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionChatRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Duplicate Post
     * @param {number} positionId
     * @param {BodyPostPositionDuplicate} [bodyPostPositionDuplicate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionDuplicate: async (
      positionId: number,
      bodyPostPositionDuplicate?: BodyPostPositionDuplicate,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postPositionDuplicate", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/duplicate`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bodyPostPositionDuplicate,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Faqs Post
     * @param {number} positionId
     * @param {PositionFaqRequest} positionFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionFaq: async (
      positionId: number,
      positionFaqRequest: PositionFaqRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postPositionFaq", "positionId", positionId);
      // verify required parameter 'positionFaqRequest' is not null or undefined
      assertParamExists(
        "postPositionFaq",
        "positionFaqRequest",
        positionFaqRequest,
      );
      const localVarPath = `/api/positions/{position_id}/faqs/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionFaqRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Generate a qualification question for an existing position (FGA + org check via router deps).  The validated position\'s title, overview, and other qualification lines are always used as type-inference context; the client never supplies them.
     * @summary Position Qualification Question Post
     * @param {number} positionId
     * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionGenerateQualificationQuestion: async (
      positionId: number,
      positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "postPositionGenerateQualificationQuestion",
        "positionId",
        positionId,
      );
      // verify required parameter 'positionQualificationQuestionGenerationRequest' is not null or undefined
      assertParamExists(
        "postPositionGenerateQualificationQuestion",
        "positionQualificationQuestionGenerationRequest",
        positionQualificationQuestionGenerationRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/qualification/generate_question`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionQualificationQuestionGenerationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Metrics Post
     * @param {number} positionId
     * @param {PositionConversationFlowMetricsRequest} positionConversationFlowMetricsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionMetrics: async (
      positionId: number,
      positionConversationFlowMetricsRequest: PositionConversationFlowMetricsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postPositionMetrics", "positionId", positionId);
      // verify required parameter 'positionConversationFlowMetricsRequest' is not null or undefined
      assertParamExists(
        "postPositionMetrics",
        "positionConversationFlowMetricsRequest",
        positionConversationFlowMetricsRequest,
      );
      const localVarPath = `/api/positions/{position_id}/metrics`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionConversationFlowMetricsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Qualification Chat Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionQualificationChat: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists(
        "postPositionQualificationChat",
        "positionId",
        positionId,
      );
      const localVarPath =
        `/api/positions/{position_id}/qualification/chat/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Integration Sync Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionSync: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/positions/sync/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Chat Post
     * @param {number} positionId
     * @param {number} resumeId
     * @param {ResumeChatRequest} resumeChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumeChat: async (
      positionId: number,
      resumeId: number,
      resumeChatRequest: ResumeChatRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postResumeChat", "positionId", positionId);
      // verify required parameter 'resumeId' is not null or undefined
      assertParamExists("postResumeChat", "resumeId", resumeId);
      // verify required parameter 'resumeChatRequest' is not null or undefined
      assertParamExists(
        "postResumeChat",
        "resumeChatRequest",
        resumeChatRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/resumes/{resume_id}/chat/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(`{${"resume_id"}}`, encodeURIComponent(String(resumeId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        resumeChatRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Rejection Post
     * @param {number} positionId
     * @param {number} resumeId
     * @param {BodyPostResumeRejection} bodyPostResumeRejection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumeRejection: async (
      positionId: number,
      resumeId: number,
      bodyPostResumeRejection: BodyPostResumeRejection,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postResumeRejection", "positionId", positionId);
      // verify required parameter 'resumeId' is not null or undefined
      assertParamExists("postResumeRejection", "resumeId", resumeId);
      // verify required parameter 'bodyPostResumeRejection' is not null or undefined
      assertParamExists(
        "postResumeRejection",
        "bodyPostResumeRejection",
        bodyPostResumeRejection,
      );
      const localVarPath =
        `/api/positions/{position_id}/resumes/{resume_id}/rejection/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(`{${"resume_id"}}`, encodeURIComponent(String(resumeId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bodyPostResumeRejection,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resume Integration Sync Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumeSync: async (
      positionId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postResumeSync", "positionId", positionId);
      const localVarPath = `/api/positions/{position_id}/resumes/sync/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Resumes Post
     * @param {number} positionId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumes: async (
      positionId: number,
      file: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postResumes", "positionId", positionId);
      // verify required parameter 'file' is not null or undefined
      assertParamExists("postResumes", "file", file);
      const localVarPath = `/api/positions/{position_id}/resumes/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )();

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Share Post
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {number} candidateId
     * @param {Array<EvaluationRecipientRequest>} evaluationRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postShareEvaluation: async (
      evaluationId: number,
      positionId: number,
      candidateId: number,
      evaluationRecipientRequest: Array<EvaluationRecipientRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'evaluationId' is not null or undefined
      assertParamExists("postShareEvaluation", "evaluationId", evaluationId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postShareEvaluation", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("postShareEvaluation", "candidateId", candidateId);
      // verify required parameter 'evaluationRecipientRequest' is not null or undefined
      assertParamExists(
        "postShareEvaluation",
        "evaluationRecipientRequest",
        evaluationRecipientRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/evaluations/{candidate_id}/share/{evaluation_id}`
          .replace(
            `{${"evaluation_id"}}`,
            encodeURIComponent(String(evaluationId)),
          )
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        evaluationRecipientRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Short Messages Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {string} body
     * @param {boolean} [resumeAutomation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postShortMessage: async (
      positionId: number,
      candidateId: number,
      body: string,
      resumeAutomation?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postShortMessage", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("postShortMessage", "candidateId", candidateId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists("postShortMessage", "body", body);
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/timeline/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (resumeAutomation !== undefined) {
        localVarQueryParameter["resume_automation"] = resumeAutomation;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stage Transitions Post
     * @param {number} positionId
     * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postStageTransitions: async (
      positionId: number,
      komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("postStageTransitions", "positionId", positionId);
      // verify required parameter 'komboApplicationStageTransitionRequest' is not null or undefined
      assertParamExists(
        "postStageTransitions",
        "komboApplicationStageTransitionRequest",
        komboApplicationStageTransitionRequest,
      );
      const localVarPath =
        `/api/automations/stage_transitions/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        komboApplicationStageTransitionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Stage Transitions Default Post
     * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postStageTransitionsDefault: async (
      komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'komboApplicationStageTransitionRequest' is not null or undefined
      assertParamExists(
        "postStageTransitionsDefault",
        "komboApplicationStageTransitionRequest",
        komboApplicationStageTransitionRequest,
      );
      const localVarPath = `/api/automations/stage_transitions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        komboApplicationStageTransitionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Subscription Agent Voice Post
     * @param {AgentVoice} agentVoiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptionAgentVoice: async (
      agentVoiceId: AgentVoice,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'agentVoiceId' is not null or undefined
      assertParamExists(
        "postSubscriptionAgentVoice",
        "agentVoiceId",
        agentVoiceId,
      );
      const localVarPath =
        `/api/subscription/agent_voice/{agent_voice_id}/`.replace(
          `{${"agent_voice_id"}}`,
          encodeURIComponent(String(agentVoiceId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Webhook Retell
     * @param {CallWebhook} callWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookRetell: async (
      callWebhook: CallWebhook,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'callWebhook' is not null or undefined
      assertParamExists("postWebhookRetell", "callWebhook", callWebhook);
      const localVarPath = `/webhook/retell/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        callWebhook,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Authenticate and accept a recruiter email for delivery to its opaque candidate relay address.
     * @summary Webhook Sendgrid Inbound Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookSendgridInboundEmail: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/webhook/sendgrid/inbound_email`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Delegate the \"Reply via SMS\" / \"Mark Resolved\" interactivity to the service (the dependency verifies the signature and supplies the payload).  The service returns a Slack ``response_action`` dict for a modal submit (echoed verbatim), a background-work callback for a \"Mark Resolved\" click (scheduled here so the ack returns within Slack\'s 3s window), or ``None`` to acknowledge with an empty 200 for a \"Reply via SMS\" click or an unrelated payload.
     * @summary Webhook Slack Interactivity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookSlackInteractivity: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/webhook/slack/interactivity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Fail-closed when the signing secret is unset.  The DB confirm runs synchronously so a failure returns a non-2xx for Stripe\'s retry policy; only the resulting Slack post, if any, moves to a background task.
     * @summary Webhook Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookStripe: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/webhook/stripe`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Webhook Twilio Message
     * @param {string} from
     * @param {string} to
     * @param {string} messageSid
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioMessage: async (
      from: string,
      to: string,
      messageSid: string,
      body: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'from' is not null or undefined
      assertParamExists("postWebhookTwilioMessage", "from", from);
      // verify required parameter 'to' is not null or undefined
      assertParamExists("postWebhookTwilioMessage", "to", to);
      // verify required parameter 'messageSid' is not null or undefined
      assertParamExists("postWebhookTwilioMessage", "messageSid", messageSid);
      // verify required parameter 'body' is not null or undefined
      assertParamExists("postWebhookTwilioMessage", "body", body);
      const localVarPath = `/webhook/twilio/message`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new URLSearchParams();

      if (from !== undefined) {
        localVarFormParams.set("From", from as any);
      }

      if (to !== undefined) {
        localVarFormParams.set("To", to as any);
      }

      if (messageSid !== undefined) {
        localVarFormParams.set("MessageSid", messageSid as any);
      }

      if (body !== undefined) {
        localVarFormParams.set("Body", body as any);
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams.toString();

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Webhook Twilio Message Status
     * @param {string} messageSid
     * @param {string} messageStatus
     * @param {string | null} [errorCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioStatus: async (
      messageSid: string,
      messageStatus: string,
      errorCode?: string | null,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'messageSid' is not null or undefined
      assertParamExists("postWebhookTwilioStatus", "messageSid", messageSid);
      // verify required parameter 'messageStatus' is not null or undefined
      assertParamExists(
        "postWebhookTwilioStatus",
        "messageStatus",
        messageStatus,
      );
      const localVarPath = `/webhook/twilio/message/status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new URLSearchParams();

      if (messageSid !== undefined) {
        localVarFormParams.set("MessageSid", messageSid as any);
      }

      if (messageStatus !== undefined) {
        localVarFormParams.set("MessageStatus", messageStatus as any);
      }

      if (errorCode !== undefined) {
        localVarFormParams.set("ErrorCode", errorCode as any);
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams.toString();

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Webhook Twilio Status
     * @param {string} recordingUrl
     * @param {string} callSid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioStatusCallback: async (
      recordingUrl: string,
      callSid: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'recordingUrl' is not null or undefined
      assertParamExists(
        "postWebhookTwilioStatusCallback",
        "recordingUrl",
        recordingUrl,
      );
      // verify required parameter 'callSid' is not null or undefined
      assertParamExists("postWebhookTwilioStatusCallback", "callSid", callSid);
      const localVarPath = `/webhook/twilio/status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new URLSearchParams();

      if (recordingUrl !== undefined) {
        localVarFormParams.set("RecordingUrl", recordingUrl as any);
      }

      if (callSid !== undefined) {
        localVarFormParams.set("CallSid", callSid as any);
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams.toString();

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Webhook Twilio Voice
     * @param {string} from
     * @param {string} to
     * @param {string} callSid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioVoice: async (
      from: string,
      to: string,
      callSid: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'from' is not null or undefined
      assertParamExists("postWebhookTwilioVoice", "from", from);
      // verify required parameter 'to' is not null or undefined
      assertParamExists("postWebhookTwilioVoice", "to", to);
      // verify required parameter 'callSid' is not null or undefined
      assertParamExists("postWebhookTwilioVoice", "callSid", callSid);
      const localVarPath = `/webhook/twilio/voice`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new URLSearchParams();

      if (from !== undefined) {
        localVarFormParams.set("From", from as any);
      }

      if (to !== undefined) {
        localVarFormParams.set("To", to as any);
      }

      if (callSid !== undefined) {
        localVarFormParams.set("CallSid", callSid as any);
      }

      localVarHeaderParameter["Content-Type"] =
        "application/x-www-form-urlencoded";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams.toString();

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Weekly Recipient Post
     * @param {Array<WeeklySummaryRecipientRequest>} weeklySummaryRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWeeklySummaryRecipients: async (
      weeklySummaryRecipientRequest: Array<WeeklySummaryRecipientRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'weeklySummaryRecipientRequest' is not null or undefined
      assertParamExists(
        "postWeeklySummaryRecipients",
        "weeklySummaryRecipientRequest",
        weeklySummaryRecipientRequest,
      );
      const localVarPath = `/api/automations/summary_recipients/weekly/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        weeklySummaryRecipientRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Record or revise ``candidate``\'s offer; returns 409 when the candidate has left the process, has started, or when an acceptance is being undone.
     * @summary Candidate Offer Put
     * @param {number} positionId
     * @param {number} candidateId
     * @param {HiringStageOfferRequest} hiringStageOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putCandidateOffer: async (
      positionId: number,
      candidateId: number,
      hiringStageOfferRequest: HiringStageOfferRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("putCandidateOffer", "positionId", positionId);
      // verify required parameter 'candidateId' is not null or undefined
      assertParamExists("putCandidateOffer", "candidateId", candidateId);
      // verify required parameter 'hiringStageOfferRequest' is not null or undefined
      assertParamExists(
        "putCandidateOffer",
        "hiringStageOfferRequest",
        hiringStageOfferRequest,
      );
      const localVarPath =
        `/api/positions/{position_id}/candidates/{candidate_id}/hiring_stage/offer/`
          .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)))
          .replace(
            `{${"candidate_id"}}`,
            encodeURIComponent(String(candidateId)),
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        hiringStageOfferRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Company Faq Update
     * @param {number} faqId
     * @param {number} companyId
     * @param {CompanyFaqRequest} companyFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putCompanyFaq: async (
      faqId: number,
      companyId: number,
      companyFaqRequest: CompanyFaqRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'faqId' is not null or undefined
      assertParamExists("putCompanyFaq", "faqId", faqId);
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists("putCompanyFaq", "companyId", companyId);
      // verify required parameter 'companyFaqRequest' is not null or undefined
      assertParamExists(
        "putCompanyFaq",
        "companyFaqRequest",
        companyFaqRequest,
      );
      const localVarPath = `/api/companies/{company_id}/faqs/{faq_id}/`
        .replace(`{${"faq_id"}}`, encodeURIComponent(String(faqId)))
        .replace(`{${"company_id"}}`, encodeURIComponent(String(companyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        companyFaqRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Email Setting Put
     * @param {number} positionId
     * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putEvaluationEmailSetting: async (
      positionId: number,
      evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("putEvaluationEmailSetting", "positionId", positionId);
      // verify required parameter 'evaluationEmailSettingRequest' is not null or undefined
      assertParamExists(
        "putEvaluationEmailSetting",
        "evaluationEmailSettingRequest",
        evaluationEmailSettingRequest,
      );
      const localVarPath =
        `/api/automations/evaluation_email_settings/positions/{position_id}/`.replace(
          `{${"position_id"}}`,
          encodeURIComponent(String(positionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        evaluationEmailSettingRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Evaluation Email Setting Default Put
     * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putEvaluationEmailSettingDefault: async (
      evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'evaluationEmailSettingRequest' is not null or undefined
      assertParamExists(
        "putEvaluationEmailSettingDefault",
        "evaluationEmailSettingRequest",
        evaluationEmailSettingRequest,
      );
      const localVarPath = `/api/automations/evaluation_email_settings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        evaluationEmailSettingRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Faq Put
     * @param {number} faqId
     * @param {number} positionId
     * @param {PositionFaqRequest} positionFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPositionFaq: async (
      faqId: number,
      positionId: number,
      positionFaqRequest: PositionFaqRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'faqId' is not null or undefined
      assertParamExists("putPositionFaq", "faqId", faqId);
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("putPositionFaq", "positionId", positionId);
      // verify required parameter 'positionFaqRequest' is not null or undefined
      assertParamExists(
        "putPositionFaq",
        "positionFaqRequest",
        positionFaqRequest,
      );
      const localVarPath = `/api/positions/{position_id}/faqs/{faq_id}/`
        .replace(`{${"faq_id"}}`, encodeURIComponent(String(faqId)))
        .replace(`{${"position_id"}}`, encodeURIComponent(String(positionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionFaqRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Position Faqs Put
     * @param {number} positionId
     * @param {PositionFaqBulkRequest} positionFaqBulkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPositionFaqs: async (
      positionId: number,
      positionFaqBulkRequest: PositionFaqBulkRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionId' is not null or undefined
      assertParamExists("putPositionFaqs", "positionId", positionId);
      // verify required parameter 'positionFaqBulkRequest' is not null or undefined
      assertParamExists(
        "putPositionFaqs",
        "positionFaqBulkRequest",
        positionFaqBulkRequest,
      );
      const localVarPath = `/api/positions/{position_id}/faqs/`.replace(
        `{${"position_id"}}`,
        encodeURIComponent(String(positionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        positionFaqBulkRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Rejection Message Put
     * @param {RejectionMessageRequest} rejectionMessageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putRejectionMessage: async (
      rejectionMessageRequest: RejectionMessageRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'rejectionMessageRequest' is not null or undefined
      assertParamExists(
        "putRejectionMessage",
        "rejectionMessageRequest",
        rejectionMessageRequest,
      );
      const localVarPath = `/api/rejection_message/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        rejectionMessageRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Offer Stages Put
     * @param {OfferStageConfigRequest} offerStageConfigRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setOfferStages: async (
      offerStageConfigRequest: OfferStageConfigRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'offerStageConfigRequest' is not null or undefined
      assertParamExists(
        "setOfferStages",
        "offerStageConfigRequest",
        offerStageConfigRequest,
      );
      const localVarPath = `/api/integrations/stages/offer/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        offerStageConfigRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Upsert the organization\'s shared ROI dashboard settings (any member may set them).
     * @summary Roi Metrics Settings Put
     * @param {RoiMetricsSettingsRequest} roiMetricsSettingsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setRoiSettings: async (
      roiMetricsSettingsRequest: RoiMetricsSettingsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'roiMetricsSettingsRequest' is not null or undefined
      assertParamExists(
        "setRoiSettings",
        "roiMetricsSettingsRequest",
        roiMetricsSettingsRequest,
      );
      const localVarPath = `/api/roi_settings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        roiMetricsSettingsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Submit Application
     * @param {string} positionPublicId
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} phoneNumber
     * @param {string | null} [emailAddress]
     * @param {File | null} [file]
     * @param {Array<File>} [attachments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitApplication: async (
      positionPublicId: string,
      firstName: string,
      lastName: string,
      phoneNumber: string,
      emailAddress?: string | null,
      file?: File | null,
      attachments?: Array<File>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'positionPublicId' is not null or undefined
      assertParamExists(
        "submitApplication",
        "positionPublicId",
        positionPublicId,
      );
      // verify required parameter 'firstName' is not null or undefined
      assertParamExists("submitApplication", "firstName", firstName);
      // verify required parameter 'lastName' is not null or undefined
      assertParamExists("submitApplication", "lastName", lastName);
      // verify required parameter 'phoneNumber' is not null or undefined
      assertParamExists("submitApplication", "phoneNumber", phoneNumber);
      const localVarPath =
        `/public_api/position/{position_public_id}/applications/`.replace(
          `{${"position_public_id"}}`,
          encodeURIComponent(String(positionPublicId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )();

      if (firstName !== undefined) {
        localVarFormParams.append("first_name", firstName as any);
      }

      if (lastName !== undefined) {
        localVarFormParams.append("last_name", lastName as any);
      }

      if (phoneNumber !== undefined) {
        localVarFormParams.append("phone_number", phoneNumber as any);
      }

      if (emailAddress !== undefined) {
        localVarFormParams.append("email_address", emailAddress as any);
      }

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }
      if (attachments) {
        attachments.forEach((element) => {
          localVarFormParams.append("attachments", element as any);
        });
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Member Profile Put
     * @param {string} userId
     * @param {ProfileRequest} profileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMemberProfile: async (
      userId: string,
      profileRequest: ProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("updateMemberProfile", "userId", userId);
      // verify required parameter 'profileRequest' is not null or undefined
      assertParamExists(
        "updateMemberProfile",
        "profileRequest",
        profileRequest,
      );
      const localVarPath = `/api/profile/{user_id}`.replace(
        `{${"user_id"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        profileRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Profile Put
     * @param {ProfileRequest} profileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProfile: async (
      profileRequest: ProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'profileRequest' is not null or undefined
      assertParamExists("updateProfile", "profileRequest", profileRequest);
      const localVarPath = `/api/profile/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication HTTPBearer required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        profileRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Member Activate
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async activateOrganizationMember(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.activateOrganizationMember(
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.activateOrganizationMember"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Automated Invite Default Source Filter Apply
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async applyAutomatedInviteDefaultSourceFilter(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AutomatedInviteDefaultSourceFilterApplyResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.applyAutomatedInviteDefaultSourceFilter(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.applyAutomatedInviteDefaultSourceFilter"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Complete Login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async completeLogin(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.completeLogin(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.completeLogin"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Member Deactivate
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deactivateOrganizationMember(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deactivateOrganizationMember(
          userId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deactivateOrganizationMember"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Faq Delete
     * @param {number} faqId
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteCompanyFaq(
      faqId: number,
      companyId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteCompanyFaq(
          faqId,
          companyId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteCompanyFaq"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Invite User Delete
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteOrganizationInvitation(
      invitationId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteOrganizationInvitation(
          invitationId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteOrganizationInvitation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Permission Delete
     * @param {number} positionId
     * @param {string} userId
     * @param {PositionRole} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteOrganizationPermission(
      positionId: number,
      userId: string,
      role: PositionRole,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteOrganizationPermission(
          positionId,
          userId,
          role,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteOrganizationPermission"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Role Delete
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteOrganizationRole(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteOrganizationRole(userId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteOrganizationRole"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Faq Delete
     * @param {number} faqId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePositionFaq(
      faqId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deletePositionFaq(
          faqId,
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deletePositionFaq"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Activity Logs Get
     * @param {number | null} [candidateId]
     * @param {number | null} [positionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActivityLogs(
      candidateId?: number | null,
      positionId?: number | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ActivityLogResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityLogs(
        candidateId,
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getActivityLogs"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllStages(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<KomboApplicationStage>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAllStages(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAllStages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Automated Invite Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAutomatedInvite(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AutomatedInvite>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAutomatedInvite(positionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAutomatedInvite"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Automated Invite Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAutomatedInviteDefault(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AutomatedInviteDefault>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAutomatedInviteDefault(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAutomatedInviteDefault"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Excluded Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAutomatedInviteExcludedStages(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AutomatedInviteExcludedStage>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAutomatedInviteExcludedStages(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAutomatedInviteExcludedStages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Return saved source filters from positions this member can edit.
     * @summary Automated Invite Source Filter Options Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAutomatedInviteSourceFilterOptions(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AutomatedInviteSourceFilterOptionResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAutomatedInviteSourceFilterOptions(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.getAutomatedInviteSourceFilterOptions"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Call Analysis Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCallAnalysis(
      candidateId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CallAnalysisResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCallAnalysis(
        candidateId,
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCallAnalysis"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Calls Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCalls(
      candidateId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Call>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCalls(
        candidateId,
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCalls"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCandidate(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CandidateWithContactStatusResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidate(
        positionId,
        candidateId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCandidate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Get Previous Applications
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCandidatePreviousApplications(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CandidateApplicationsResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCandidatePreviousApplications(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCandidatePreviousApplications"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Sources Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCandidateSources(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCandidateSources(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCandidateSources"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Integration Sync Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCandidateSyncHistory(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<SyncCandidateResultResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCandidateSyncHistory(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCandidateSyncHistory"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Timeline Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCandidateTimeline(
      candidateId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CandidateTimelineEntry>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCandidateTimeline(
          candidateId,
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCandidateTimeline"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Guidance Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCandidateTodoGuidance(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoGuidance>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCandidateTodoGuidance(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCandidateTodoGuidance"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidates Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCandidates(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CandidateFullResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidates(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCandidates"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Companies Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCompanies(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CompanyResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCompanies(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCompanies"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Get
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCompany(
      companyId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(
        companyId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCompany"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Analysis Get
     * @param {number} companyAnalysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCompanyAnalysis(
      companyAnalysisId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CompanyAnalysisResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getCompanyAnalysis(
          companyAnalysisId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCompanyAnalysis"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Faq List
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCompanyFaqs(
      companyId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CompanyFaq>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyFaqs(
        companyId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCompanyFaqs"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Daily Recipient Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDailySummaryRecipients(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DailySummaryRecipientResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDailySummaryRecipients(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getDailySummaryRecipients"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Deactivated Members Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDeactivatedOrganizationMembers(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganizationMemberResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDeactivatedOrganizationMembers(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getDeactivatedOrganizationMembers"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvaluation(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationFullResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluation(
        positionId,
        candidateId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEvaluation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Chat Get
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvaluationChat(
      evaluationId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EvaluationChatResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEvaluationChat(
          evaluationId,
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEvaluationChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Email Recipient Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvaluationEmailRecipients(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EvaluationEmailRecipient>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEvaluationEmailRecipients(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEvaluationEmailRecipients"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Email Setting Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvaluationEmailSetting(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationEmailSettingResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEvaluationEmailSetting(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEvaluationEmailSetting"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Email Setting Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvaluationEmailSettingDefault(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationEmailSettingResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEvaluationEmailSettingDefault(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEvaluationEmailSettingDefault"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Latest Recipients Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvaluationRecipients(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EvaluationRecipientRequest>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEvaluationRecipients(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEvaluationRecipients"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluations Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvaluations(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<{ [key: string]: EvaluationResponse }>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluations(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEvaluations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Return candidates from live positions visible to the caller.
     * @summary Live Position Candidates Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGlobalCandidates(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CandidateFullResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getGlobalCandidates(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getGlobalCandidates"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * List hiring-stage rows across the caller\'s org, scoped to (for non-admins) the positions they may edit.
     * @summary Hiring Stages Get
     * @param {Array<HiringStage>} [stage]
     * @param {number} [limit]
     * @param {boolean} [pending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHiringStages(
      stage?: Array<HiringStage>,
      limit?: number,
      pending?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<HiringStageListItemResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHiringStages(
        stage,
        limit,
        pending,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getHiringStages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Read the current sync statuses for the active integration.
     * @summary Integration Sync Statuses Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIntegrationSyncStatuses(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<IntegrationSyncStatusResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getIntegrationSyncStatuses(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getIntegrationSyncStatuses"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Integrations Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getIntegrations(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<IntegrationResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getIntegrations(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getIntegrations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Invitation Slots Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getInvitationSlots(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<InvitationSlotsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getInvitationSlots(positionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getInvitationSlots"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Job Analysis Get
     * @param {number} jobAnalysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getJobAnalysis(
      jobAnalysisId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobAnalysisResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getJobAnalysis(
        jobAnalysisId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getJobAnalysis"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Called by the frontend on ``?boost=success``; shares the confirm routine with the Stripe webhook so payment is recorded exactly once regardless of which one lands first.
     * @summary Boost Checkout Confirm Get
     * @param {number} positionId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getJobBoardBoostCheckoutConfirm(
      positionId: number,
      sessionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobBoardBoostCheckoutConfirmResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getJobBoardBoostCheckoutConfirm(
          positionId,
          sessionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getJobBoardBoostCheckoutConfirm"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Boost Recommendation Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getJobBoardBoostRecommendation(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobBoardBoostRecommendationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getJobBoardBoostRecommendation(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getJobBoardBoostRecommendation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Job States Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getJobStates(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<KomboJobState>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getJobStates(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getJobStates"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Kombo Tools Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getKomboTools(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<KomboTool>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getKomboTools(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getKomboTools"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Call Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestCall(
      candidateId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Call>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestCall(
        candidateId,
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getLatestCall"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Call Simulation Get Latest
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestCallSimulation(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CallSimulationJobResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getLatestCallSimulation(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getLatestCallSimulation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Qualification Chat Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLatestPositionQualificationChat(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PositionQualificationChatResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getLatestPositionQualificationChat(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getLatestPositionQualificationChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Live Positions Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLivePositions(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<LivePositionResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getLivePositions(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getLivePositions"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Offer Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOfferStages(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OfferStageConfigResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getOfferStages(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getOfferStages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * No `validate_subscription`: a first-time user may not have an active subscription yet.
     * @summary Onboarding Tour Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOnboardingTour(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OnboardingTourResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getOnboardingTour(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getOnboardingTour"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Invite User Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrganizationInvitations(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<UserInvitationResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getOrganizationInvitations(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getOrganizationInvitations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Members Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOrganizationMembers(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganizationMemberResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getOrganizationMembers(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getOrganizationMembers"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Phone Number Lookup Get
     * @param {string} phoneNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPhoneNumberLookup(
      phoneNumber: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PhoneNumberLookupResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPhoneNumberLookup(
          phoneNumber,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPhoneNumberLookup"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPosition(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionFullResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPosition(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPosition"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Chat Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositionChat(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PositionChatResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionChat(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositionChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Faqs Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositionFaqs(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PositionFaq>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPositionFaqs(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositionFaqs"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Return each active member\'s positions with the requested role.
     * @summary Position Memberships Get
     * @param {PositionRole} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositionMemberships(
      role?: PositionRole,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<{ [key: string]: Array<number> }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPositionMemberships(role, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositionMemberships"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Return the findings on the stored qualification lines that keep the position from going live.  Only block-severity findings are included; warnings are not. The call has no side effects, and a position of another organization responds 404.
     * @summary Position Qualification Check Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositionQualificationCheck(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionQualificationCheckResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPositionQualificationCheck(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositionQualificationCheck"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Stages Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositionStages(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<KomboApplicationStage>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPositionStages(positionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositionStages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Integration Sync Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositionSyncHistory(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<SyncPositionResultResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPositionSyncHistory(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositionSyncHistory"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Users Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositionUsers(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPositionUsers(positionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositionUsers"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Positions Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPositions(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PositionListItemResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPositions(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPositions"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Public Position
     * @param {string} positionPublicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPublicPosition(
      positionPublicId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PublicPositionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPublicPosition(
          positionPublicId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPublicPosition"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Public Positions
     * @param {string} companySlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPublicPositions(
      companySlug: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PublicPositionResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPublicPositions(
          companySlug,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPublicPositions"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Rejection Message Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRejectionMessage(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RejectionMessageResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getRejectionMessage(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getRejectionMessage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Rejection Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRejectionReasons(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<KomboRejectionReason>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getRejectionReasons(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getRejectionReasons"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Get
     * @param {number} positionId
     * @param {number} resumeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResume(
      positionId: number,
      resumeId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResumeWithMatchesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getResume(
        positionId,
        resumeId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getResume"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Chat Get
     * @param {number} resumeId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResumeChat(
      resumeId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ResumeChatResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getResumeChat(
        resumeId,
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getResumeChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Integration Sync Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResumeSyncHistory(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<SyncResumeResultResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getResumeSyncHistory(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getResumeSyncHistory"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resumes Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResumes(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ResumeListResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getResumes(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getResumes"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * List open review items, scoped to the caller\'s org and (for non-admins) editable positions.
     * @summary Review Items Get
     * @param {Array<ReviewItemCategory>} [category]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReviewItems(
      category?: Array<ReviewItemCategory>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ReviewItemResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewItems(
        category,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getReviewItems"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Return the organization\'s ROI dashboard settings, or ``null`` when no member has saved them yet.
     * @summary Roi Metrics Settings Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoiSettings(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RoiMetricsSettingsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getRoiSettings(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getRoiSettings"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Share Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getShareEvaluation(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationRecipientResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getShareEvaluation(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getShareEvaluation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Stage Transitions Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStageTransitions(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<KomboApplicationStageTransitionResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getStageTransitions(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getStageTransitions"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Stage Transitions Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStageTransitionsDefault(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<KomboApplicationStageTransitionDefaultResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getStageTransitionsDefault(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getStageTransitionsDefault"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Statistics Get
     * @param {string | null} [before]
     * @param {string | null} [after]
     * @param {Array<number>} [companyIds]
     * @param {Array<number>} [positionIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStatistics(
      before?: string | null,
      after?: string | null,
      companyIds?: Array<number>,
      positionIds?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<StatisticsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStatistics(
        before,
        after,
        companyIds,
        positionIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getStatistics"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Subscription Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSubscription(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SubscriptionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getSubscription(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getSubscription"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Integration Sync Status Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSyncCandidateStatus(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SyncCandidateStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getSyncCandidateStatus(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getSyncCandidateStatus"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Integration Sync Status Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSyncPositionStatus(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SyncPositionStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getSyncPositionStatus(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getSyncPositionStatus"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Integration Sync Status Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSyncResumeStatus(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SyncResumeStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getSyncResumeStatus(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getSyncResumeStatus"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Timeline Translate Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTranslatedCandidateTimeline(
      candidateId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<CandidateTimelineEntry>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getTranslatedCandidateTimeline(
          candidateId,
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getTranslatedCandidateTimeline"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Unresponsive Candidate Log
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUnresponsiveCandidateLog(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UnresponsiveCandidateLogResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getUnresponsiveCandidateLog(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getUnresponsiveCandidateLog"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary User Positions Get
     * @param {string} userId
     * @param {PositionRole} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserPositions(
      userId: string,
      role?: PositionRole,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getUserPositions(userId, role, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getUserPositions"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Weekly Statistics Get
     * @param {string | null} [before]
     * @param {string | null} [after]
     * @param {Array<number>} [companyIds]
     * @param {Array<number>} [positionIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWeeklyStatistics(
      before?: string | null,
      after?: string | null,
      companyIds?: Array<number>,
      positionIds?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WeeklyStatisticsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getWeeklyStatistics(
          before,
          after,
          companyIds,
          positionIds,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getWeeklyStatistics"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Weekly Recipient Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWeeklySummaryRecipients(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<WeeklySummaryRecipientResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getWeeklySummaryRecipients(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getWeeklySummaryRecipients"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Admin-only atomic move of an answered position FAQ into the company library; see ``PositionService.move_faq_to_company`` for the locking/transaction contract.
     * @summary Position Faq Move To Company
     * @param {number} faqId
     * @param {number} positionId
     * @param {PositionFaqMoveRequest} positionFaqMoveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async movePositionFaqToCompany(
      faqId: number,
      positionId: number,
      positionFaqMoveRequest: PositionFaqMoveRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyFaq>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.movePositionFaqToCompany(
          faqId,
          positionId,
          positionFaqMoveRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.movePositionFaqToCompany"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Automated Invite Paused Patch
     * @param {number} positionId
     * @param {AutomatedInvitePausedRequest} automatedInvitePausedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchAutomatedInvitePaused(
      positionId: number,
      automatedInvitePausedRequest: AutomatedInvitePausedRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AutomatedInvite>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patchAutomatedInvitePaused(
          positionId,
          automatedInvitePausedRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchAutomatedInvitePaused"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {CandidatePatchRequest} candidatePatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchCandidate(
      positionId: number,
      candidateId: number,
      candidatePatchRequest: CandidatePatchRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CandidateWithContactStatusResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchCandidate(
        positionId,
        candidateId,
        candidatePatchRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchCandidate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Mark ``candidate``\'s placement as ours to follow, or stop following it, without touching the offer.  Separate from the PUT: the toggle must work with no offer to resend — an In Process candidate has none yet, an Onboarding one can no longer submit one.
     * @summary Candidate Tracked Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {HiringStageTrackedRequest} hiringStageTrackedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchCandidateTracked(
      positionId: number,
      candidateId: number,
      hiringStageTrackedRequest: HiringStageTrackedRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HiringStageResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patchCandidateTracked(
          positionId,
          candidateId,
          hiringStageTrackedRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchCandidateTracked"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Patch
     * @param {number} companyId
     * @param {CompanyRequest} companyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchCompany(
      companyId: number,
      companyRequest: CompanyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchCompany(
        companyId,
        companyRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchCompany"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchEvaluation(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchEvaluation(
        positionId,
        candidateId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchEvaluation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Checkpoint Patch
     * @param {number} candidateId
     * @param {number} evaluationCheckpointId
     * @param {number} positionId
     * @param {BodyPatchEvaluationCheckpoint} bodyPatchEvaluationCheckpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchEvaluationCheckpoint(
      candidateId: number,
      evaluationCheckpointId: number,
      positionId: number,
      bodyPatchEvaluationCheckpoint: BodyPatchEvaluationCheckpoint,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationFullResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patchEvaluationCheckpoint(
          candidateId,
          evaluationCheckpointId,
          positionId,
          bodyPatchEvaluationCheckpoint,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchEvaluationCheckpoint"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluations Patch
     * @param {number} positionId
     * @param {Array<EvaluateCandidateRequest>} evaluateCandidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchEvaluationsBulk(
      positionId: number,
      evaluateCandidateRequest: Array<EvaluateCandidateRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluateCandidateBulkResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.patchEvaluationsBulk(
          positionId,
          evaluateCandidateRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchEvaluationsBulk"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Patch
     * @param {number} positionId
     * @param {PositionPatchRequest} positionPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchPosition(
      positionId: number,
      positionPatchRequest: PositionPatchRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionFullResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchPosition(
        positionId,
        positionPatchRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchPosition"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Patch
     * @param {number} positionId
     * @param {number} resumeId
     * @param {ResumeRequest} resumeRequest
     * @param {boolean} [cancelQueuedInvite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchResume(
      positionId: number,
      resumeId: number,
      resumeRequest: ResumeRequest,
      cancelQueuedInvite?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResumeIndividualResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchResume(
        positionId,
        resumeId,
        resumeRequest,
        cancelQueuedInvite,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchResume"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Apply a resolution transition (admin bypass; non-admin needs CAN_EDIT on the item\'s position).  Domain errors map to 409: an ``unknown``-row transition, an Undo colliding with another open advancement, or an Undo of an already-offered candidate.
     * @summary Review Item Patch
     * @param {number} reviewItemId
     * @param {ReviewItemResolutionRequest} reviewItemResolutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchReviewItem(
      reviewItemId: number,
      reviewItemResolutionRequest: ReviewItemResolutionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ReviewItemResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchReviewItem(
        reviewItemId,
        reviewItemResolutionRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.patchReviewItem"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Automated Invite Post
     * @param {number} positionId
     * @param {AutomatedInviteRequest} automatedInviteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postAutomatedInvite(
      positionId: number,
      automatedInviteRequest: AutomatedInviteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AutomatedInvite>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postAutomatedInvite(
          positionId,
          automatedInviteRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postAutomatedInvite"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Automated Invite Default Post
     * @param {AutomatedInviteDefaultRequest} automatedInviteDefaultRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postAutomatedInviteDefault(
      automatedInviteDefaultRequest: AutomatedInviteDefaultRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AutomatedInviteDefault>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postAutomatedInviteDefault(
          automatedInviteDefaultRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postAutomatedInviteDefault"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Excluded Stages Post
     * @param {BodyPostAutomatedInviteExcludedStages} bodyPostAutomatedInviteExcludedStages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postAutomatedInviteExcludedStages(
      bodyPostAutomatedInviteExcludedStages: BodyPostAutomatedInviteExcludedStages,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AutomatedInviteExcludedStage>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postAutomatedInviteExcludedStages(
          bodyPostAutomatedInviteExcludedStages,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postAutomatedInviteExcludedStages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Initiate an immediate call to the candidate without sending any messages.
     * @summary Call Immediate
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCallImmediate(
      candidateId: number,
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCallImmediate(
          candidateId,
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCallImmediate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Call Simulation Post
     * @param {number} positionId
     * @param {CallSimulationRequest} [callSimulationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCallSimulation(
      positionId: number,
      callSimulationRequest?: CallSimulationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CallSimulationJobResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCallSimulation(
          positionId,
          callSimulationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCallSimulation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Revise the suggested rewrite of one settings-coverage judgement using the recruiter\'s comment.  Returns only the revised judgement — the client already holds the rest of the job and must not re-download the transcript.
     * @summary Call Simulation Coverage Rewrite Post
     * @param {number} positionId
     * @param {number} jobId
     * @param {string} settingKey
     * @param {SettingsCoverageRewriteRequest} settingsCoverageRewriteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCallSimulationCoverageRewrite(
      positionId: number,
      jobId: number,
      settingKey: string,
      settingsCoverageRewriteRequest: SettingsCoverageRewriteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SimulationSettingCoverageResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCallSimulationCoverageRewrite(
          positionId,
          jobId,
          settingKey,
          settingsCoverageRewriteRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCallSimulationCoverageRewrite"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Call Test Post
     * @param {number} positionId
     * @param {CallTestRequest} callTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCallTest(
      positionId: number,
      callTestRequest: CallTestRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postCallTest(
        positionId,
        callTestRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCallTest"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidates Post
     * @param {number} positionId
     * @param {CandidateRequest} candidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidate(
      positionId: number,
      candidateRequest: CandidateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CandidateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postCandidate(
        positionId,
        candidateRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCandidate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Idempotently move ``candidate`` to In Process; returns 409 if archived/withdrawn, already offered, or a concurrent race is lost (retry).
     * @summary Candidate Advancement Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidateAdvancement(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ReviewItemResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCandidateAdvancement(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCandidateAdvancement"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidates Post Bulk
     * @param {number} positionId
     * @param {Array<CandidateRequest>} candidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidateBulk(
      positionId: number,
      candidateRequest: Array<CandidateRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CandidateBulkCreateResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCandidateBulk(
          positionId,
          candidateRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCandidateBulk"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Decision Reject
     * @param {number} positionId
     * @param {number} candidateId
     * @param {CandidateDecisionRejectRequest} candidateDecisionRejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidateDecisionReject(
      positionId: number,
      candidateId: number,
      candidateDecisionRejectRequest: CandidateDecisionRejectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CandidateDecisionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCandidateDecisionReject(
          positionId,
          candidateId,
          candidateDecisionRejectRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCandidateDecisionReject"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Return the email the signed-in recruiter can send to reach this candidate through the relay.  The address comes from the authenticated identity rather than the request body. The first sender to write to a relay address claims it, so a client-supplied value could claim a colleague\'s thread.  Raises:     HTTPException: 409 if the candidate\'s AI screening has not produced a usable evaluation yet.
     * @summary Candidate Relay Draft Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidateRelayDraft(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CommunicationRelayDraftResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCandidateRelayDraft(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCandidateRelayDraft"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Candidate Integration Sync Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidateSync(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCandidateSync(positionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCandidateSync"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Guidance Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidateTodoGuidance(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoGuidance>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCandidateTodoGuidance(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCandidateTodoGuidance"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Guidance Mark As Completed
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCandidateTodoGuidanceMarkAsCompleted(
      positionId: number,
      candidateId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCandidateTodoGuidanceMarkAsCompleted(
          positionId,
          candidateId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.postCandidateTodoGuidanceMarkAsCompleted"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Companies Post
     * @param {CompanyRequest} companyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCompany(
      companyRequest: CompanyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postCompany(
        companyRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCompany"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Agent Preview Post
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCompanyAgentPreview(
      companyId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WebCallConnectionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCompanyAgentPreview(
          companyId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCompanyAgentPreview"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Analyses Post
     * @param {CompanyAnalysisRequest} companyAnalysisRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCompanyAnalysis(
      companyAnalysisRequest: CompanyAnalysisRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CompanyAnalysisResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCompanyAnalysis(
          companyAnalysisRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCompanyAnalysis"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Faq Create
     * @param {number} companyId
     * @param {CompanyFaqRequest} companyFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCompanyFaq(
      companyId: number,
      companyFaqRequest: CompanyFaqRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyFaq>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyFaq(
        companyId,
        companyFaqRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCompanyFaq"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Logo Post
     * @param {number} companyId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCompanyLogo(
      companyId: number,
      file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyLogo(
        companyId,
        file,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCompanyLogo"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Voice Preview Post
     * @param {AgentVoice} agentVoiceId
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postCompanyVoicePreview(
      agentVoiceId: AgentVoice,
      companyId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postCompanyVoicePreview(
          agentVoiceId,
          companyId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postCompanyVoicePreview"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Daily Recipient Post
     * @param {Array<DailySummaryRecipientRequest>} dailySummaryRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postDailySummaryRecipients(
      dailySummaryRecipientRequest: Array<DailySummaryRecipientRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DailySummaryRecipientResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postDailySummaryRecipients(
          dailySummaryRecipientRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postDailySummaryRecipients"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Chat Post
     * @param {number} positionId
     * @param {number} evaluationId
     * @param {EvaluationChatRequest} evaluationChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postEvaluationChat(
      positionId: number,
      evaluationId: number,
      evaluationChatRequest: EvaluationChatRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EvaluationChatResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postEvaluationChat(
          positionId,
          evaluationId,
          evaluationChatRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postEvaluationChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Email Recipient Post
     * @param {number} positionId
     * @param {Array<EvaluationEmailRecipientRequest>} evaluationEmailRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postEvaluationEmailRecipients(
      positionId: number,
      evaluationEmailRecipientRequest: Array<EvaluationEmailRecipientRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EvaluationEmailRecipient>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postEvaluationEmailRecipients(
          positionId,
          evaluationEmailRecipientRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postEvaluationEmailRecipients"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Export Post
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {number} candidateId
     * @param {boolean} [skipIntegration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postEvaluationExport(
      evaluationId: number,
      positionId: number,
      candidateId: number,
      skipIntegration?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationFullResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postEvaluationExport(
          evaluationId,
          positionId,
          candidateId,
          skipIntegration,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postEvaluationExport"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Generate a question for the new-position wizard before a position row exists.
     * @summary Qualification Question Post
     * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postGenerateQualificationQuestion(
      positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionQualificationQuestionGenerationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postGenerateQualificationQuestion(
          positionQualificationQuestionGenerationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postGenerateQualificationQuestion"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Help Center Chat Post
     * @param {HelpCenterChatRequest} helpCenterChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postHelpCenterChat(
      helpCenterChatRequest: HelpCenterChatRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HelpCenterChatResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postHelpCenterChat(
          helpCenterChatRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postHelpCenterChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Integrations Post
     * @param {IntegrationRequest} integrationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postIntegration(
      integrationRequest: IntegrationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<IntegrationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postIntegration(
        integrationRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postIntegration"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Post Deploy Call Post
     * @param {string} xPostDeployE2EToken
     * @param {PostDeployCallRequest} postDeployCallRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postInternalE2EPostDeployCall(
      xPostDeployE2EToken: string,
      postDeployCallRequest: PostDeployCallRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PostDeployCallDispatchResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postInternalE2EPostDeployCall(
          xPostDeployE2EToken,
          postDeployCallRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postInternalE2EPostDeployCall"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Job Analyses Post
     * @param {JobAnalysisRequest} jobAnalysisRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postJobAnalysis(
      jobAnalysisRequest: JobAnalysisRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobAnalysisResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postJobAnalysis(
        jobAnalysisRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postJobAnalysis"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Job Analyses Upload Post
     * @param {number} companyId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postJobAnalysisUpload(
      companyId: number,
      file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobAnalysisResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postJobAnalysisUpload(
          companyId,
          file,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postJobAnalysisUpload"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Job Analyses Start Web Call Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postJobAnalysisWebCall(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WebCallConnectionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postJobAnalysisWebCall(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postJobAnalysisWebCall"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Boost Checkout Post
     * @param {number} positionId
     * @param {JobBoardBoostCheckoutRequest} jobBoardBoostCheckoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postJobBoardBoostCheckout(
      positionId: number,
      jobBoardBoostCheckoutRequest: JobBoardBoostCheckoutRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobBoardBoostCheckoutResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postJobBoardBoostCheckout(
          positionId,
          jobBoardBoostCheckoutRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postJobBoardBoostCheckout"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Boost Recommendation Post
     * @param {number} positionId
     * @param {JobBoardBoostRecommendationRequest} jobBoardBoostRecommendationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postJobBoardBoostRecommendation(
      positionId: number,
      jobBoardBoostRecommendationRequest: JobBoardBoostRecommendationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<JobBoardBoostRecommendationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postJobBoardBoostRecommendation(
          positionId,
          jobBoardBoostRecommendationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postJobBoardBoostRecommendation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Kombo Activate Post
     * @param {BodyPostKomboActivate} bodyPostKomboActivate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postKomboActivate(
      bodyPostKomboActivate: BodyPostKomboActivate,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postKomboActivate(
          bodyPostKomboActivate,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postKomboActivate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Webhook Kombo Data Changed
     * @param {KomboDataChangedWebhook} komboDataChangedWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postKomboDataChanged(
      komboDataChangedWebhook: KomboDataChangedWebhook,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postKomboDataChanged(
          komboDataChangedWebhook,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postKomboDataChanged"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Kombo Init Post
     * @param {BodyPostKomboInit} [bodyPostKomboInit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postKomboInit(
      bodyPostKomboInit?: BodyPostKomboInit,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postKomboInit(
        bodyPostKomboInit,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postKomboInit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Webhook Kombo Sync Finished
     * @param {KomboSyncFinishedWebhook} komboSyncFinishedWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postKomboSyncFinished(
      komboSyncFinishedWebhook: KomboSyncFinishedWebhook,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postKomboSyncFinished(
          komboSyncFinishedWebhook,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postKomboSyncFinished"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Onboarding Tour Complete Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postOnboardingTour(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postOnboardingTour(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postOnboardingTour"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Invite User Post
     * @param {UserInvitationRequest} userInvitationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postOrganizationInvitation(
      userInvitationRequest: UserInvitationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserInvitationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postOrganizationInvitation(
          userInvitationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postOrganizationInvitation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Permission Post
     * @param {number} positionId
     * @param {string} userId
     * @param {PositionRole} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postOrganizationPermission(
      positionId: number,
      userId: string,
      role: PositionRole,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postOrganizationPermission(
          positionId,
          userId,
          role,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postOrganizationPermission"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Role Post
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postOrganizationRole(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postOrganizationRole(userId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postOrganizationRole"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Positions Post
     * @param {PositionRequest} positionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPosition(
      positionRequest: PositionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postPosition(
        positionRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postPosition"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Chat Post
     * @param {number} positionId
     * @param {PositionChatRequest} positionChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPositionChat(
      positionId: number,
      positionChatRequest: PositionChatRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PositionChatResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postPositionChat(
          positionId,
          positionChatRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postPositionChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Duplicate Post
     * @param {number} positionId
     * @param {BodyPostPositionDuplicate} [bodyPostPositionDuplicate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPositionDuplicate(
      positionId: number,
      bodyPostPositionDuplicate?: BodyPostPositionDuplicate,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionFullResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postPositionDuplicate(
          positionId,
          bodyPostPositionDuplicate,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postPositionDuplicate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Faqs Post
     * @param {number} positionId
     * @param {PositionFaqRequest} positionFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPositionFaq(
      positionId: number,
      positionFaqRequest: PositionFaqRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionFaq>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postPositionFaq(
        positionId,
        positionFaqRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postPositionFaq"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Generate a qualification question for an existing position (FGA + org check via router deps).  The validated position\'s title, overview, and other qualification lines are always used as type-inference context; the client never supplies them.
     * @summary Position Qualification Question Post
     * @param {number} positionId
     * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPositionGenerateQualificationQuestion(
      positionId: number,
      positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionQualificationQuestionGenerationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postPositionGenerateQualificationQuestion(
          positionId,
          positionQualificationQuestionGenerationRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.postPositionGenerateQualificationQuestion"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Metrics Post
     * @param {number} positionId
     * @param {PositionConversationFlowMetricsRequest} positionConversationFlowMetricsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPositionMetrics(
      positionId: number,
      positionConversationFlowMetricsRequest: PositionConversationFlowMetricsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PositionConversationFlowMetrics>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postPositionMetrics(
          positionId,
          positionConversationFlowMetricsRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postPositionMetrics"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Qualification Chat Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPositionQualificationChat(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PositionQualificationChatResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postPositionQualificationChat(
          positionId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postPositionQualificationChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Integration Sync Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postPositionSync(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postPositionSync(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postPositionSync"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Chat Post
     * @param {number} positionId
     * @param {number} resumeId
     * @param {ResumeChatRequest} resumeChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postResumeChat(
      positionId: number,
      resumeId: number,
      resumeChatRequest: ResumeChatRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ResumeChatResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postResumeChat(
        positionId,
        resumeId,
        resumeChatRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postResumeChat"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Rejection Post
     * @param {number} positionId
     * @param {number} resumeId
     * @param {BodyPostResumeRejection} bodyPostResumeRejection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postResumeRejection(
      positionId: number,
      resumeId: number,
      bodyPostResumeRejection: BodyPostResumeRejection,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CandidateDecisionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postResumeRejection(
          positionId,
          resumeId,
          bodyPostResumeRejection,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postResumeRejection"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resume Integration Sync Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postResumeSync(
      positionId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postResumeSync(
        positionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postResumeSync"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Resumes Post
     * @param {number} positionId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postResumes(
      positionId: number,
      file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ResponsePostresumes>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.postResumes(
        positionId,
        file,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postResumes"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Share Post
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {number} candidateId
     * @param {Array<EvaluationRecipientRequest>} evaluationRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postShareEvaluation(
      evaluationId: number,
      positionId: number,
      candidateId: number,
      evaluationRecipientRequest: Array<EvaluationRecipientRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EvaluationRecipientRequest>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postShareEvaluation(
          evaluationId,
          positionId,
          candidateId,
          evaluationRecipientRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postShareEvaluation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Short Messages Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {string} body
     * @param {boolean} [resumeAutomation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postShortMessage(
      positionId: number,
      candidateId: number,
      body: string,
      resumeAutomation?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postShortMessage(
          positionId,
          candidateId,
          body,
          resumeAutomation,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postShortMessage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Stage Transitions Post
     * @param {number} positionId
     * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postStageTransitions(
      positionId: number,
      komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postStageTransitions(
          positionId,
          komboApplicationStageTransitionRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postStageTransitions"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Stage Transitions Default Post
     * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postStageTransitionsDefault(
      komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postStageTransitionsDefault(
          komboApplicationStageTransitionRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postStageTransitionsDefault"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Subscription Agent Voice Post
     * @param {AgentVoice} agentVoiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postSubscriptionAgentVoice(
      agentVoiceId: AgentVoice,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SubscriptionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postSubscriptionAgentVoice(
          agentVoiceId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postSubscriptionAgentVoice"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Webhook Retell
     * @param {CallWebhook} callWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookRetell(
      callWebhook: CallWebhook,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookRetell(callWebhook, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookRetell"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Authenticate and accept a recruiter email for delivery to its opaque candidate relay address.
     * @summary Webhook Sendgrid Inbound Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookSendgridInboundEmail(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookSendgridInboundEmail(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookSendgridInboundEmail"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Delegate the \"Reply via SMS\" / \"Mark Resolved\" interactivity to the service (the dependency verifies the signature and supplies the payload).  The service returns a Slack ``response_action`` dict for a modal submit (echoed verbatim), a background-work callback for a \"Mark Resolved\" click (scheduled here so the ack returns within Slack\'s 3s window), or ``None`` to acknowledge with an empty 200 for a \"Reply via SMS\" click or an unrelated payload.
     * @summary Webhook Slack Interactivity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookSlackInteractivity(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookSlackInteractivity(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookSlackInteractivity"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Fail-closed when the signing secret is unset.  The DB confirm runs synchronously so a failure returns a non-2xx for Stripe\'s retry policy; only the resulting Slack post, if any, moves to a background task.
     * @summary Webhook Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookStripe(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookStripe(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookStripe"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Webhook Twilio Message
     * @param {string} from
     * @param {string} to
     * @param {string} messageSid
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookTwilioMessage(
      from: string,
      to: string,
      messageSid: string,
      body: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookTwilioMessage(
          from,
          to,
          messageSid,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookTwilioMessage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Webhook Twilio Message Status
     * @param {string} messageSid
     * @param {string} messageStatus
     * @param {string | null} [errorCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookTwilioStatus(
      messageSid: string,
      messageStatus: string,
      errorCode?: string | null,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookTwilioStatus(
          messageSid,
          messageStatus,
          errorCode,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookTwilioStatus"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Webhook Twilio Status
     * @param {string} recordingUrl
     * @param {string} callSid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookTwilioStatusCallback(
      recordingUrl: string,
      callSid: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookTwilioStatusCallback(
          recordingUrl,
          callSid,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookTwilioStatusCallback"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Webhook Twilio Voice
     * @param {string} from
     * @param {string} to
     * @param {string} callSid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWebhookTwilioVoice(
      from: string,
      to: string,
      callSid: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWebhookTwilioVoice(
          from,
          to,
          callSid,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWebhookTwilioVoice"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Weekly Recipient Post
     * @param {Array<WeeklySummaryRecipientRequest>} weeklySummaryRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async postWeeklySummaryRecipients(
      weeklySummaryRecipientRequest: Array<WeeklySummaryRecipientRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<WeeklySummaryRecipientResponse>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.postWeeklySummaryRecipients(
          weeklySummaryRecipientRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.postWeeklySummaryRecipients"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Record or revise ``candidate``\'s offer; returns 409 when the candidate has left the process, has started, or when an acceptance is being undone.
     * @summary Candidate Offer Put
     * @param {number} positionId
     * @param {number} candidateId
     * @param {HiringStageOfferRequest} hiringStageOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putCandidateOffer(
      positionId: number,
      candidateId: number,
      hiringStageOfferRequest: HiringStageOfferRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<HiringStageResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.putCandidateOffer(
          positionId,
          candidateId,
          hiringStageOfferRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.putCandidateOffer"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Company Faq Update
     * @param {number} faqId
     * @param {number} companyId
     * @param {CompanyFaqRequest} companyFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putCompanyFaq(
      faqId: number,
      companyId: number,
      companyFaqRequest: CompanyFaqRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyFaq>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.putCompanyFaq(
        faqId,
        companyId,
        companyFaqRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.putCompanyFaq"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Email Setting Put
     * @param {number} positionId
     * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putEvaluationEmailSetting(
      positionId: number,
      evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationEmailSettingResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.putEvaluationEmailSetting(
          positionId,
          evaluationEmailSettingRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.putEvaluationEmailSetting"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Evaluation Email Setting Default Put
     * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putEvaluationEmailSettingDefault(
      evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EvaluationEmailSettingResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.putEvaluationEmailSettingDefault(
          evaluationEmailSettingRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.putEvaluationEmailSettingDefault"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Faq Put
     * @param {number} faqId
     * @param {number} positionId
     * @param {PositionFaqRequest} positionFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putPositionFaq(
      faqId: number,
      positionId: number,
      positionFaqRequest: PositionFaqRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PositionFaq>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.putPositionFaq(
        faqId,
        positionId,
        positionFaqRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.putPositionFaq"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Position Faqs Put
     * @param {number} positionId
     * @param {PositionFaqBulkRequest} positionFaqBulkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putPositionFaqs(
      positionId: number,
      positionFaqBulkRequest: PositionFaqBulkRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PositionFaq>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.putPositionFaqs(
        positionId,
        positionFaqBulkRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.putPositionFaqs"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Rejection Message Put
     * @param {RejectionMessageRequest} rejectionMessageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async putRejectionMessage(
      rejectionMessageRequest: RejectionMessageRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RejectionMessageResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.putRejectionMessage(
          rejectionMessageRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.putRejectionMessage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Offer Stages Put
     * @param {OfferStageConfigRequest} offerStageConfigRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setOfferStages(
      offerStageConfigRequest: OfferStageConfigRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OfferStageConfigResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.setOfferStages(
        offerStageConfigRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.setOfferStages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Upsert the organization\'s shared ROI dashboard settings (any member may set them).
     * @summary Roi Metrics Settings Put
     * @param {RoiMetricsSettingsRequest} roiMetricsSettingsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setRoiSettings(
      roiMetricsSettingsRequest: RoiMetricsSettingsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RoiMetricsSettingsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.setRoiSettings(
        roiMetricsSettingsRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.setRoiSettings"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Submit Application
     * @param {string} positionPublicId
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} phoneNumber
     * @param {string | null} [emailAddress]
     * @param {File | null} [file]
     * @param {Array<File>} [attachments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async submitApplication(
      positionPublicId: string,
      firstName: string,
      lastName: string,
      phoneNumber: string,
      emailAddress?: string | null,
      file?: File | null,
      attachments?: Array<File>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ApplicationSubmissionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.submitApplication(
          positionPublicId,
          firstName,
          lastName,
          phoneNumber,
          emailAddress,
          file,
          attachments,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.submitApplication"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Member Profile Put
     * @param {string} userId
     * @param {ProfileRequest} profileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateMemberProfile(
      userId: string,
      profileRequest: ProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateMemberProfile(
          userId,
          profileRequest,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateMemberProfile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Profile Put
     * @param {ProfileRequest} profileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProfile(
      profileRequest: ProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(
        profileRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateProfile"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     *
     * @summary Member Activate
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    activateOrganizationMember(
      userId: string,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .activateOrganizationMember(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Automated Invite Default Source Filter Apply
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyAutomatedInviteDefaultSourceFilter(
      options?: any,
    ): AxiosPromise<AutomatedInviteDefaultSourceFilterApplyResponse> {
      return localVarFp
        .applyAutomatedInviteDefaultSourceFilter(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Complete Login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeLogin(options?: any): AxiosPromise<void> {
      return localVarFp
        .completeLogin(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Member Deactivate
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deactivateOrganizationMember(
      userId: string,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .deactivateOrganizationMember(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Faq Delete
     * @param {number} faqId
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCompanyFaq(
      faqId: number,
      companyId: number,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .deleteCompanyFaq(faqId, companyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Invite User Delete
     * @param {string} invitationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationInvitation(
      invitationId: string,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .deleteOrganizationInvitation(invitationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Permission Delete
     * @param {number} positionId
     * @param {string} userId
     * @param {PositionRole} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationPermission(
      positionId: number,
      userId: string,
      role: PositionRole,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .deleteOrganizationPermission(positionId, userId, role, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Role Delete
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteOrganizationRole(userId: string, options?: any): AxiosPromise<any> {
      return localVarFp
        .deleteOrganizationRole(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Faq Delete
     * @param {number} faqId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePositionFaq(
      faqId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .deletePositionFaq(faqId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Activity Logs Get
     * @param {number | null} [candidateId]
     * @param {number | null} [positionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActivityLogs(
      candidateId?: number | null,
      positionId?: number | null,
      options?: any,
    ): AxiosPromise<Array<ActivityLogResponse>> {
      return localVarFp
        .getActivityLogs(candidateId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllStages(options?: any): AxiosPromise<Array<KomboApplicationStage>> {
      return localVarFp
        .getAllStages(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Automated Invite Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInvite(
      positionId: number,
      options?: any,
    ): AxiosPromise<AutomatedInvite> {
      return localVarFp
        .getAutomatedInvite(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Automated Invite Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInviteDefault(
      options?: any,
    ): AxiosPromise<AutomatedInviteDefault> {
      return localVarFp
        .getAutomatedInviteDefault(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Excluded Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInviteExcludedStages(
      options?: any,
    ): AxiosPromise<Array<AutomatedInviteExcludedStage>> {
      return localVarFp
        .getAutomatedInviteExcludedStages(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Return saved source filters from positions this member can edit.
     * @summary Automated Invite Source Filter Options Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAutomatedInviteSourceFilterOptions(
      options?: any,
    ): AxiosPromise<Array<AutomatedInviteSourceFilterOptionResponse>> {
      return localVarFp
        .getAutomatedInviteSourceFilterOptions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Call Analysis Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCallAnalysis(
      candidateId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<CallAnalysisResponse> {
      return localVarFp
        .getCallAnalysis(candidateId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Calls Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCalls(
      candidateId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<Call>> {
      return localVarFp
        .getCalls(candidateId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidate(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<CandidateWithContactStatusResponse> {
      return localVarFp
        .getCandidate(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Get Previous Applications
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidatePreviousApplications(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<Array<CandidateApplicationsResponse>> {
      return localVarFp
        .getCandidatePreviousApplications(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Sources Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateSources(options?: any): AxiosPromise<Array<string>> {
      return localVarFp
        .getCandidateSources(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Integration Sync Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateSyncHistory(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<SyncCandidateResultResponse>> {
      return localVarFp
        .getCandidateSyncHistory(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Timeline Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateTimeline(
      candidateId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<CandidateTimelineEntry>> {
      return localVarFp
        .getCandidateTimeline(candidateId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Guidance Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateTodoGuidance(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<TodoGuidance> {
      return localVarFp
        .getCandidateTodoGuidance(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidates Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidates(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<CandidateFullResponse>> {
      return localVarFp
        .getCandidates(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Companies Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(options?: any): AxiosPromise<Array<CompanyResponse>> {
      return localVarFp
        .getCompanies(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Get
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(
      companyId: number,
      options?: any,
    ): AxiosPromise<CompanyResponse> {
      return localVarFp
        .getCompany(companyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Analysis Get
     * @param {number} companyAnalysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAnalysis(
      companyAnalysisId: number,
      options?: any,
    ): AxiosPromise<CompanyAnalysisResponse> {
      return localVarFp
        .getCompanyAnalysis(companyAnalysisId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Faq List
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyFaqs(
      companyId: number,
      options?: any,
    ): AxiosPromise<Array<CompanyFaq>> {
      return localVarFp
        .getCompanyFaqs(companyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Daily Recipient Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailySummaryRecipients(
      options?: any,
    ): AxiosPromise<Array<DailySummaryRecipientResponse>> {
      return localVarFp
        .getDailySummaryRecipients(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Deactivated Members Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeactivatedOrganizationMembers(
      options?: any,
    ): AxiosPromise<Array<OrganizationMemberResponse>> {
      return localVarFp
        .getDeactivatedOrganizationMembers(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluation(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<EvaluationFullResponse> {
      return localVarFp
        .getEvaluation(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Chat Get
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationChat(
      evaluationId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<EvaluationChatResponse>> {
      return localVarFp
        .getEvaluationChat(evaluationId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Email Recipient Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationEmailRecipients(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<EvaluationEmailRecipient>> {
      return localVarFp
        .getEvaluationEmailRecipients(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Email Setting Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationEmailSetting(
      positionId: number,
      options?: any,
    ): AxiosPromise<EvaluationEmailSettingResponse> {
      return localVarFp
        .getEvaluationEmailSetting(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Email Setting Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationEmailSettingDefault(
      options?: any,
    ): AxiosPromise<EvaluationEmailSettingResponse> {
      return localVarFp
        .getEvaluationEmailSettingDefault(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Latest Recipients Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluationRecipients(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<EvaluationRecipientRequest>> {
      return localVarFp
        .getEvaluationRecipients(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluations Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvaluations(
      positionId: number,
      options?: any,
    ): AxiosPromise<{ [key: string]: EvaluationResponse }> {
      return localVarFp
        .getEvaluations(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Return candidates from live positions visible to the caller.
     * @summary Live Position Candidates Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGlobalCandidates(
      options?: any,
    ): AxiosPromise<Array<CandidateFullResponse>> {
      return localVarFp
        .getGlobalCandidates(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * List hiring-stage rows across the caller\'s org, scoped to (for non-admins) the positions they may edit.
     * @summary Hiring Stages Get
     * @param {Array<HiringStage>} [stage]
     * @param {number} [limit]
     * @param {boolean} [pending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHiringStages(
      stage?: Array<HiringStage>,
      limit?: number,
      pending?: boolean,
      options?: any,
    ): AxiosPromise<Array<HiringStageListItemResponse>> {
      return localVarFp
        .getHiringStages(stage, limit, pending, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Read the current sync statuses for the active integration.
     * @summary Integration Sync Statuses Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrationSyncStatuses(
      options?: any,
    ): AxiosPromise<Array<IntegrationSyncStatusResponse>> {
      return localVarFp
        .getIntegrationSyncStatuses(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Integrations Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getIntegrations(options?: any): AxiosPromise<Array<IntegrationResponse>> {
      return localVarFp
        .getIntegrations(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Invitation Slots Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvitationSlots(
      positionId: number,
      options?: any,
    ): AxiosPromise<InvitationSlotsResponse> {
      return localVarFp
        .getInvitationSlots(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Job Analysis Get
     * @param {number} jobAnalysisId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobAnalysis(
      jobAnalysisId: number,
      options?: any,
    ): AxiosPromise<JobAnalysisResponse> {
      return localVarFp
        .getJobAnalysis(jobAnalysisId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Called by the frontend on ``?boost=success``; shares the confirm routine with the Stripe webhook so payment is recorded exactly once regardless of which one lands first.
     * @summary Boost Checkout Confirm Get
     * @param {number} positionId
     * @param {string} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobBoardBoostCheckoutConfirm(
      positionId: number,
      sessionId: string,
      options?: any,
    ): AxiosPromise<JobBoardBoostCheckoutConfirmResponse> {
      return localVarFp
        .getJobBoardBoostCheckoutConfirm(positionId, sessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Boost Recommendation Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobBoardBoostRecommendation(
      positionId: number,
      options?: any,
    ): AxiosPromise<JobBoardBoostRecommendationResponse> {
      return localVarFp
        .getJobBoardBoostRecommendation(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Job States Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobStates(options?: any): AxiosPromise<Array<KomboJobState>> {
      return localVarFp
        .getJobStates(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Kombo Tools Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getKomboTools(options?: any): AxiosPromise<Array<KomboTool>> {
      return localVarFp
        .getKomboTools(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Call Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestCall(
      candidateId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<Call> {
      return localVarFp
        .getLatestCall(candidateId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Call Simulation Get Latest
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestCallSimulation(
      positionId: number,
      options?: any,
    ): AxiosPromise<CallSimulationJobResponse> {
      return localVarFp
        .getLatestCallSimulation(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Qualification Chat Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestPositionQualificationChat(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<PositionQualificationChatResponse>> {
      return localVarFp
        .getLatestPositionQualificationChat(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Live Positions Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLivePositions(options?: any): AxiosPromise<Array<LivePositionResponse>> {
      return localVarFp
        .getLivePositions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Offer Stages Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferStages(options?: any): AxiosPromise<OfferStageConfigResponse> {
      return localVarFp
        .getOfferStages(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * No `validate_subscription`: a first-time user may not have an active subscription yet.
     * @summary Onboarding Tour Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOnboardingTour(options?: any): AxiosPromise<OnboardingTourResponse> {
      return localVarFp
        .getOnboardingTour(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Invite User Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationInvitations(
      options?: any,
    ): AxiosPromise<Array<UserInvitationResponse>> {
      return localVarFp
        .getOrganizationInvitations(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Members Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOrganizationMembers(
      options?: any,
    ): AxiosPromise<Array<OrganizationMemberResponse>> {
      return localVarFp
        .getOrganizationMembers(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Phone Number Lookup Get
     * @param {string} phoneNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPhoneNumberLookup(
      phoneNumber: string,
      options?: any,
    ): AxiosPromise<PhoneNumberLookupResponse> {
      return localVarFp
        .getPhoneNumberLookup(phoneNumber, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPosition(
      positionId: number,
      options?: any,
    ): AxiosPromise<PositionFullResponse> {
      return localVarFp
        .getPosition(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Chat Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionChat(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<PositionChatResponse>> {
      return localVarFp
        .getPositionChat(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Faqs Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionFaqs(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<PositionFaq>> {
      return localVarFp
        .getPositionFaqs(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Return each active member\'s positions with the requested role.
     * @summary Position Memberships Get
     * @param {PositionRole} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionMemberships(
      role?: PositionRole,
      options?: any,
    ): AxiosPromise<{ [key: string]: Array<number> }> {
      return localVarFp
        .getPositionMemberships(role, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Return the findings on the stored qualification lines that keep the position from going live.  Only block-severity findings are included; warnings are not. The call has no side effects, and a position of another organization responds 404.
     * @summary Position Qualification Check Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionQualificationCheck(
      positionId: number,
      options?: any,
    ): AxiosPromise<PositionQualificationCheckResponse> {
      return localVarFp
        .getPositionQualificationCheck(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Stages Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionStages(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<KomboApplicationStage>> {
      return localVarFp
        .getPositionStages(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Integration Sync Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionSyncHistory(
      options?: any,
    ): AxiosPromise<Array<SyncPositionResultResponse>> {
      return localVarFp
        .getPositionSyncHistory(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Users Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositionUsers(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .getPositionUsers(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Positions Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPositions(options?: any): AxiosPromise<Array<PositionListItemResponse>> {
      return localVarFp
        .getPositions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Public Position
     * @param {string} positionPublicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPosition(
      positionPublicId: string,
      options?: any,
    ): AxiosPromise<PublicPositionResponse> {
      return localVarFp
        .getPublicPosition(positionPublicId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Public Positions
     * @param {string} companySlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPublicPositions(
      companySlug: string,
      options?: any,
    ): AxiosPromise<Array<PublicPositionResponse>> {
      return localVarFp
        .getPublicPositions(companySlug, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Rejection Message Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRejectionMessage(options?: any): AxiosPromise<RejectionMessageResponse> {
      return localVarFp
        .getRejectionMessage(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Rejection Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRejectionReasons(
      options?: any,
    ): AxiosPromise<Array<KomboRejectionReason>> {
      return localVarFp
        .getRejectionReasons(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Get
     * @param {number} positionId
     * @param {number} resumeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResume(
      positionId: number,
      resumeId: number,
      options?: any,
    ): AxiosPromise<ResumeWithMatchesResponse> {
      return localVarFp
        .getResume(positionId, resumeId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Chat Get
     * @param {number} resumeId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResumeChat(
      resumeId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<ResumeChatResponse>> {
      return localVarFp
        .getResumeChat(resumeId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Integration Sync Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResumeSyncHistory(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<SyncResumeResultResponse>> {
      return localVarFp
        .getResumeSyncHistory(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resumes Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResumes(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<ResumeListResponse>> {
      return localVarFp
        .getResumes(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * List open review items, scoped to the caller\'s org and (for non-admins) editable positions.
     * @summary Review Items Get
     * @param {Array<ReviewItemCategory>} [category]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReviewItems(
      category?: Array<ReviewItemCategory>,
      options?: any,
    ): AxiosPromise<Array<ReviewItemResponse>> {
      return localVarFp
        .getReviewItems(category, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Return the organization\'s ROI dashboard settings, or ``null`` when no member has saved them yet.
     * @summary Roi Metrics Settings Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoiSettings(options?: any): AxiosPromise<RoiMetricsSettingsResponse> {
      return localVarFp
        .getRoiSettings(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Share Get
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getShareEvaluation(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<EvaluationRecipientResponse> {
      return localVarFp
        .getShareEvaluation(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Stage Transitions Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStageTransitions(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<KomboApplicationStageTransitionResponse>> {
      return localVarFp
        .getStageTransitions(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Stage Transitions Default Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStageTransitionsDefault(
      options?: any,
    ): AxiosPromise<Array<KomboApplicationStageTransitionDefaultResponse>> {
      return localVarFp
        .getStageTransitionsDefault(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Statistics Get
     * @param {string | null} [before]
     * @param {string | null} [after]
     * @param {Array<number>} [companyIds]
     * @param {Array<number>} [positionIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStatistics(
      before?: string | null,
      after?: string | null,
      companyIds?: Array<number>,
      positionIds?: Array<number>,
      options?: any,
    ): AxiosPromise<StatisticsResponse> {
      return localVarFp
        .getStatistics(before, after, companyIds, positionIds, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Subscription Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSubscription(options?: any): AxiosPromise<SubscriptionResponse> {
      return localVarFp
        .getSubscription(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Integration Sync Status Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncCandidateStatus(
      positionId: number,
      options?: any,
    ): AxiosPromise<SyncCandidateStatusResponse> {
      return localVarFp
        .getSyncCandidateStatus(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Integration Sync Status Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncPositionStatus(
      options?: any,
    ): AxiosPromise<SyncPositionStatusResponse> {
      return localVarFp
        .getSyncPositionStatus(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Integration Sync Status Get
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSyncResumeStatus(
      positionId: number,
      options?: any,
    ): AxiosPromise<SyncResumeStatusResponse> {
      return localVarFp
        .getSyncResumeStatus(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Timeline Translate Get
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTranslatedCandidateTimeline(
      candidateId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<CandidateTimelineEntry>> {
      return localVarFp
        .getTranslatedCandidateTimeline(candidateId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Unresponsive Candidate Log
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUnresponsiveCandidateLog(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<UnresponsiveCandidateLogResponse> {
      return localVarFp
        .getUnresponsiveCandidateLog(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary User Positions Get
     * @param {string} userId
     * @param {PositionRole} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserPositions(
      userId: string,
      role?: PositionRole,
      options?: any,
    ): AxiosPromise<Array<number>> {
      return localVarFp
        .getUserPositions(userId, role, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Weekly Statistics Get
     * @param {string | null} [before]
     * @param {string | null} [after]
     * @param {Array<number>} [companyIds]
     * @param {Array<number>} [positionIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWeeklyStatistics(
      before?: string | null,
      after?: string | null,
      companyIds?: Array<number>,
      positionIds?: Array<number>,
      options?: any,
    ): AxiosPromise<WeeklyStatisticsResponse> {
      return localVarFp
        .getWeeklyStatistics(before, after, companyIds, positionIds, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Weekly Recipient Get
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWeeklySummaryRecipients(
      options?: any,
    ): AxiosPromise<Array<WeeklySummaryRecipientResponse>> {
      return localVarFp
        .getWeeklySummaryRecipients(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Admin-only atomic move of an answered position FAQ into the company library; see ``PositionService.move_faq_to_company`` for the locking/transaction contract.
     * @summary Position Faq Move To Company
     * @param {number} faqId
     * @param {number} positionId
     * @param {PositionFaqMoveRequest} positionFaqMoveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    movePositionFaqToCompany(
      faqId: number,
      positionId: number,
      positionFaqMoveRequest: PositionFaqMoveRequest,
      options?: any,
    ): AxiosPromise<CompanyFaq> {
      return localVarFp
        .movePositionFaqToCompany(
          faqId,
          positionId,
          positionFaqMoveRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Automated Invite Paused Patch
     * @param {number} positionId
     * @param {AutomatedInvitePausedRequest} automatedInvitePausedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAutomatedInvitePaused(
      positionId: number,
      automatedInvitePausedRequest: AutomatedInvitePausedRequest,
      options?: any,
    ): AxiosPromise<AutomatedInvite> {
      return localVarFp
        .patchAutomatedInvitePaused(
          positionId,
          automatedInvitePausedRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {CandidatePatchRequest} candidatePatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCandidate(
      positionId: number,
      candidateId: number,
      candidatePatchRequest: CandidatePatchRequest,
      options?: any,
    ): AxiosPromise<CandidateWithContactStatusResponse> {
      return localVarFp
        .patchCandidate(positionId, candidateId, candidatePatchRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Mark ``candidate``\'s placement as ours to follow, or stop following it, without touching the offer.  Separate from the PUT: the toggle must work with no offer to resend — an In Process candidate has none yet, an Onboarding one can no longer submit one.
     * @summary Candidate Tracked Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {HiringStageTrackedRequest} hiringStageTrackedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCandidateTracked(
      positionId: number,
      candidateId: number,
      hiringStageTrackedRequest: HiringStageTrackedRequest,
      options?: any,
    ): AxiosPromise<HiringStageResponse> {
      return localVarFp
        .patchCandidateTracked(
          positionId,
          candidateId,
          hiringStageTrackedRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Patch
     * @param {number} companyId
     * @param {CompanyRequest} companyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchCompany(
      companyId: number,
      companyRequest: CompanyRequest,
      options?: any,
    ): AxiosPromise<CompanyResponse> {
      return localVarFp
        .patchCompany(companyId, companyRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Patch
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvaluation(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .patchEvaluation(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Checkpoint Patch
     * @param {number} candidateId
     * @param {number} evaluationCheckpointId
     * @param {number} positionId
     * @param {BodyPatchEvaluationCheckpoint} bodyPatchEvaluationCheckpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvaluationCheckpoint(
      candidateId: number,
      evaluationCheckpointId: number,
      positionId: number,
      bodyPatchEvaluationCheckpoint: BodyPatchEvaluationCheckpoint,
      options?: any,
    ): AxiosPromise<EvaluationFullResponse> {
      return localVarFp
        .patchEvaluationCheckpoint(
          candidateId,
          evaluationCheckpointId,
          positionId,
          bodyPatchEvaluationCheckpoint,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluations Patch
     * @param {number} positionId
     * @param {Array<EvaluateCandidateRequest>} evaluateCandidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchEvaluationsBulk(
      positionId: number,
      evaluateCandidateRequest: Array<EvaluateCandidateRequest>,
      options?: any,
    ): AxiosPromise<EvaluateCandidateBulkResponse> {
      return localVarFp
        .patchEvaluationsBulk(positionId, evaluateCandidateRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Patch
     * @param {number} positionId
     * @param {PositionPatchRequest} positionPatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPosition(
      positionId: number,
      positionPatchRequest: PositionPatchRequest,
      options?: any,
    ): AxiosPromise<PositionFullResponse> {
      return localVarFp
        .patchPosition(positionId, positionPatchRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Patch
     * @param {number} positionId
     * @param {number} resumeId
     * @param {ResumeRequest} resumeRequest
     * @param {boolean} [cancelQueuedInvite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchResume(
      positionId: number,
      resumeId: number,
      resumeRequest: ResumeRequest,
      cancelQueuedInvite?: boolean,
      options?: any,
    ): AxiosPromise<ResumeIndividualResponse> {
      return localVarFp
        .patchResume(
          positionId,
          resumeId,
          resumeRequest,
          cancelQueuedInvite,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Apply a resolution transition (admin bypass; non-admin needs CAN_EDIT on the item\'s position).  Domain errors map to 409: an ``unknown``-row transition, an Undo colliding with another open advancement, or an Undo of an already-offered candidate.
     * @summary Review Item Patch
     * @param {number} reviewItemId
     * @param {ReviewItemResolutionRequest} reviewItemResolutionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchReviewItem(
      reviewItemId: number,
      reviewItemResolutionRequest: ReviewItemResolutionRequest,
      options?: any,
    ): AxiosPromise<ReviewItemResponse> {
      return localVarFp
        .patchReviewItem(reviewItemId, reviewItemResolutionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Automated Invite Post
     * @param {number} positionId
     * @param {AutomatedInviteRequest} automatedInviteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutomatedInvite(
      positionId: number,
      automatedInviteRequest: AutomatedInviteRequest,
      options?: any,
    ): AxiosPromise<AutomatedInvite> {
      return localVarFp
        .postAutomatedInvite(positionId, automatedInviteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Automated Invite Default Post
     * @param {AutomatedInviteDefaultRequest} automatedInviteDefaultRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutomatedInviteDefault(
      automatedInviteDefaultRequest: AutomatedInviteDefaultRequest,
      options?: any,
    ): AxiosPromise<AutomatedInviteDefault> {
      return localVarFp
        .postAutomatedInviteDefault(automatedInviteDefaultRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Excluded Stages Post
     * @param {BodyPostAutomatedInviteExcludedStages} bodyPostAutomatedInviteExcludedStages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAutomatedInviteExcludedStages(
      bodyPostAutomatedInviteExcludedStages: BodyPostAutomatedInviteExcludedStages,
      options?: any,
    ): AxiosPromise<Array<AutomatedInviteExcludedStage>> {
      return localVarFp
        .postAutomatedInviteExcludedStages(
          bodyPostAutomatedInviteExcludedStages,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Initiate an immediate call to the candidate without sending any messages.
     * @summary Call Immediate
     * @param {number} candidateId
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallImmediate(
      candidateId: number,
      positionId: number,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postCallImmediate(candidateId, positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Call Simulation Post
     * @param {number} positionId
     * @param {CallSimulationRequest} [callSimulationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallSimulation(
      positionId: number,
      callSimulationRequest?: CallSimulationRequest,
      options?: any,
    ): AxiosPromise<CallSimulationJobResponse> {
      return localVarFp
        .postCallSimulation(positionId, callSimulationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Revise the suggested rewrite of one settings-coverage judgement using the recruiter\'s comment.  Returns only the revised judgement — the client already holds the rest of the job and must not re-download the transcript.
     * @summary Call Simulation Coverage Rewrite Post
     * @param {number} positionId
     * @param {number} jobId
     * @param {string} settingKey
     * @param {SettingsCoverageRewriteRequest} settingsCoverageRewriteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallSimulationCoverageRewrite(
      positionId: number,
      jobId: number,
      settingKey: string,
      settingsCoverageRewriteRequest: SettingsCoverageRewriteRequest,
      options?: any,
    ): AxiosPromise<SimulationSettingCoverageResult> {
      return localVarFp
        .postCallSimulationCoverageRewrite(
          positionId,
          jobId,
          settingKey,
          settingsCoverageRewriteRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Call Test Post
     * @param {number} positionId
     * @param {CallTestRequest} callTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCallTest(
      positionId: number,
      callTestRequest: CallTestRequest,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postCallTest(positionId, callTestRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidates Post
     * @param {number} positionId
     * @param {CandidateRequest} candidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidate(
      positionId: number,
      candidateRequest: CandidateRequest,
      options?: any,
    ): AxiosPromise<CandidateResponse> {
      return localVarFp
        .postCandidate(positionId, candidateRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Idempotently move ``candidate`` to In Process; returns 409 if archived/withdrawn, already offered, or a concurrent race is lost (retry).
     * @summary Candidate Advancement Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateAdvancement(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<ReviewItemResponse> {
      return localVarFp
        .postCandidateAdvancement(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidates Post Bulk
     * @param {number} positionId
     * @param {Array<CandidateRequest>} candidateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateBulk(
      positionId: number,
      candidateRequest: Array<CandidateRequest>,
      options?: any,
    ): AxiosPromise<CandidateBulkCreateResponse> {
      return localVarFp
        .postCandidateBulk(positionId, candidateRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Decision Reject
     * @param {number} positionId
     * @param {number} candidateId
     * @param {CandidateDecisionRejectRequest} candidateDecisionRejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateDecisionReject(
      positionId: number,
      candidateId: number,
      candidateDecisionRejectRequest: CandidateDecisionRejectRequest,
      options?: any,
    ): AxiosPromise<CandidateDecisionResponse> {
      return localVarFp
        .postCandidateDecisionReject(
          positionId,
          candidateId,
          candidateDecisionRejectRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Return the email the signed-in recruiter can send to reach this candidate through the relay.  The address comes from the authenticated identity rather than the request body. The first sender to write to a relay address claims it, so a client-supplied value could claim a colleague\'s thread.  Raises:     HTTPException: 409 if the candidate\'s AI screening has not produced a usable evaluation yet.
     * @summary Candidate Relay Draft Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateRelayDraft(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<CommunicationRelayDraftResponse> {
      return localVarFp
        .postCandidateRelayDraft(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Candidate Integration Sync Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateSync(positionId: number, options?: any): AxiosPromise<any> {
      return localVarFp
        .postCandidateSync(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Guidance Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateTodoGuidance(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<TodoGuidance> {
      return localVarFp
        .postCandidateTodoGuidance(positionId, candidateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Guidance Mark As Completed
     * @param {number} positionId
     * @param {number} candidateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCandidateTodoGuidanceMarkAsCompleted(
      positionId: number,
      candidateId: number,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postCandidateTodoGuidanceMarkAsCompleted(
          positionId,
          candidateId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Companies Post
     * @param {CompanyRequest} companyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompany(
      companyRequest: CompanyRequest,
      options?: any,
    ): AxiosPromise<CompanyResponse> {
      return localVarFp
        .postCompany(companyRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Agent Preview Post
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAgentPreview(
      companyId: number,
      options?: any,
    ): AxiosPromise<WebCallConnectionResponse> {
      return localVarFp
        .postCompanyAgentPreview(companyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Analyses Post
     * @param {CompanyAnalysisRequest} companyAnalysisRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAnalysis(
      companyAnalysisRequest: CompanyAnalysisRequest,
      options?: any,
    ): AxiosPromise<CompanyAnalysisResponse> {
      return localVarFp
        .postCompanyAnalysis(companyAnalysisRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Faq Create
     * @param {number} companyId
     * @param {CompanyFaqRequest} companyFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyFaq(
      companyId: number,
      companyFaqRequest: CompanyFaqRequest,
      options?: any,
    ): AxiosPromise<CompanyFaq> {
      return localVarFp
        .postCompanyFaq(companyId, companyFaqRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Logo Post
     * @param {number} companyId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyLogo(
      companyId: number,
      file: File,
      options?: any,
    ): AxiosPromise<CompanyResponse> {
      return localVarFp
        .postCompanyLogo(companyId, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Voice Preview Post
     * @param {AgentVoice} agentVoiceId
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyVoicePreview(
      agentVoiceId: AgentVoice,
      companyId: number,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postCompanyVoicePreview(agentVoiceId, companyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Daily Recipient Post
     * @param {Array<DailySummaryRecipientRequest>} dailySummaryRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postDailySummaryRecipients(
      dailySummaryRecipientRequest: Array<DailySummaryRecipientRequest>,
      options?: any,
    ): AxiosPromise<Array<DailySummaryRecipientResponse>> {
      return localVarFp
        .postDailySummaryRecipients(dailySummaryRecipientRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Chat Post
     * @param {number} positionId
     * @param {number} evaluationId
     * @param {EvaluationChatRequest} evaluationChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEvaluationChat(
      positionId: number,
      evaluationId: number,
      evaluationChatRequest: EvaluationChatRequest,
      options?: any,
    ): AxiosPromise<Array<EvaluationChatResponse>> {
      return localVarFp
        .postEvaluationChat(
          positionId,
          evaluationId,
          evaluationChatRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Email Recipient Post
     * @param {number} positionId
     * @param {Array<EvaluationEmailRecipientRequest>} evaluationEmailRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEvaluationEmailRecipients(
      positionId: number,
      evaluationEmailRecipientRequest: Array<EvaluationEmailRecipientRequest>,
      options?: any,
    ): AxiosPromise<Array<EvaluationEmailRecipient>> {
      return localVarFp
        .postEvaluationEmailRecipients(
          positionId,
          evaluationEmailRecipientRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Export Post
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {number} candidateId
     * @param {boolean} [skipIntegration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEvaluationExport(
      evaluationId: number,
      positionId: number,
      candidateId: number,
      skipIntegration?: boolean,
      options?: any,
    ): AxiosPromise<EvaluationFullResponse> {
      return localVarFp
        .postEvaluationExport(
          evaluationId,
          positionId,
          candidateId,
          skipIntegration,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Generate a question for the new-position wizard before a position row exists.
     * @summary Qualification Question Post
     * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postGenerateQualificationQuestion(
      positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
      options?: any,
    ): AxiosPromise<PositionQualificationQuestionGenerationResponse> {
      return localVarFp
        .postGenerateQualificationQuestion(
          positionQualificationQuestionGenerationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Help Center Chat Post
     * @param {HelpCenterChatRequest} helpCenterChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postHelpCenterChat(
      helpCenterChatRequest: HelpCenterChatRequest,
      options?: any,
    ): AxiosPromise<HelpCenterChatResponse> {
      return localVarFp
        .postHelpCenterChat(helpCenterChatRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Integrations Post
     * @param {IntegrationRequest} integrationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postIntegration(
      integrationRequest: IntegrationRequest,
      options?: any,
    ): AxiosPromise<IntegrationResponse> {
      return localVarFp
        .postIntegration(integrationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Post Deploy Call Post
     * @param {string} xPostDeployE2EToken
     * @param {PostDeployCallRequest} postDeployCallRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postInternalE2EPostDeployCall(
      xPostDeployE2EToken: string,
      postDeployCallRequest: PostDeployCallRequest,
      options?: any,
    ): AxiosPromise<PostDeployCallDispatchResponse> {
      return localVarFp
        .postInternalE2EPostDeployCall(
          xPostDeployE2EToken,
          postDeployCallRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Job Analyses Post
     * @param {JobAnalysisRequest} jobAnalysisRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobAnalysis(
      jobAnalysisRequest: JobAnalysisRequest,
      options?: any,
    ): AxiosPromise<JobAnalysisResponse> {
      return localVarFp
        .postJobAnalysis(jobAnalysisRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Job Analyses Upload Post
     * @param {number} companyId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobAnalysisUpload(
      companyId: number,
      file: File,
      options?: any,
    ): AxiosPromise<JobAnalysisResponse> {
      return localVarFp
        .postJobAnalysisUpload(companyId, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Job Analyses Start Web Call Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobAnalysisWebCall(
      options?: any,
    ): AxiosPromise<WebCallConnectionResponse> {
      return localVarFp
        .postJobAnalysisWebCall(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Boost Checkout Post
     * @param {number} positionId
     * @param {JobBoardBoostCheckoutRequest} jobBoardBoostCheckoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobBoardBoostCheckout(
      positionId: number,
      jobBoardBoostCheckoutRequest: JobBoardBoostCheckoutRequest,
      options?: any,
    ): AxiosPromise<JobBoardBoostCheckoutResponse> {
      return localVarFp
        .postJobBoardBoostCheckout(
          positionId,
          jobBoardBoostCheckoutRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Boost Recommendation Post
     * @param {number} positionId
     * @param {JobBoardBoostRecommendationRequest} jobBoardBoostRecommendationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postJobBoardBoostRecommendation(
      positionId: number,
      jobBoardBoostRecommendationRequest: JobBoardBoostRecommendationRequest,
      options?: any,
    ): AxiosPromise<JobBoardBoostRecommendationResponse> {
      return localVarFp
        .postJobBoardBoostRecommendation(
          positionId,
          jobBoardBoostRecommendationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Kombo Activate Post
     * @param {BodyPostKomboActivate} bodyPostKomboActivate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboActivate(
      bodyPostKomboActivate: BodyPostKomboActivate,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postKomboActivate(bodyPostKomboActivate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Webhook Kombo Data Changed
     * @param {KomboDataChangedWebhook} komboDataChangedWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboDataChanged(
      komboDataChangedWebhook: KomboDataChangedWebhook,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postKomboDataChanged(komboDataChangedWebhook, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Kombo Init Post
     * @param {BodyPostKomboInit} [bodyPostKomboInit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboInit(
      bodyPostKomboInit?: BodyPostKomboInit,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postKomboInit(bodyPostKomboInit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Webhook Kombo Sync Finished
     * @param {KomboSyncFinishedWebhook} komboSyncFinishedWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postKomboSyncFinished(
      komboSyncFinishedWebhook: KomboSyncFinishedWebhook,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postKomboSyncFinished(komboSyncFinishedWebhook, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Onboarding Tour Complete Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOnboardingTour(options?: any): AxiosPromise<void> {
      return localVarFp
        .postOnboardingTour(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Invite User Post
     * @param {UserInvitationRequest} userInvitationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationInvitation(
      userInvitationRequest: UserInvitationRequest,
      options?: any,
    ): AxiosPromise<UserInvitationResponse> {
      return localVarFp
        .postOrganizationInvitation(userInvitationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Permission Post
     * @param {number} positionId
     * @param {string} userId
     * @param {PositionRole} role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationPermission(
      positionId: number,
      userId: string,
      role: PositionRole,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postOrganizationPermission(positionId, userId, role, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Role Post
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postOrganizationRole(userId: string, options?: any): AxiosPromise<any> {
      return localVarFp
        .postOrganizationRole(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Positions Post
     * @param {PositionRequest} positionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPosition(
      positionRequest: PositionRequest,
      options?: any,
    ): AxiosPromise<PositionResponse> {
      return localVarFp
        .postPosition(positionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Chat Post
     * @param {number} positionId
     * @param {PositionChatRequest} positionChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionChat(
      positionId: number,
      positionChatRequest: PositionChatRequest,
      options?: any,
    ): AxiosPromise<Array<PositionChatResponse>> {
      return localVarFp
        .postPositionChat(positionId, positionChatRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Duplicate Post
     * @param {number} positionId
     * @param {BodyPostPositionDuplicate} [bodyPostPositionDuplicate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionDuplicate(
      positionId: number,
      bodyPostPositionDuplicate?: BodyPostPositionDuplicate,
      options?: any,
    ): AxiosPromise<PositionFullResponse> {
      return localVarFp
        .postPositionDuplicate(positionId, bodyPostPositionDuplicate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Faqs Post
     * @param {number} positionId
     * @param {PositionFaqRequest} positionFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionFaq(
      positionId: number,
      positionFaqRequest: PositionFaqRequest,
      options?: any,
    ): AxiosPromise<PositionFaq> {
      return localVarFp
        .postPositionFaq(positionId, positionFaqRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Generate a qualification question for an existing position (FGA + org check via router deps).  The validated position\'s title, overview, and other qualification lines are always used as type-inference context; the client never supplies them.
     * @summary Position Qualification Question Post
     * @param {number} positionId
     * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionGenerateQualificationQuestion(
      positionId: number,
      positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
      options?: any,
    ): AxiosPromise<PositionQualificationQuestionGenerationResponse> {
      return localVarFp
        .postPositionGenerateQualificationQuestion(
          positionId,
          positionQualificationQuestionGenerationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Metrics Post
     * @param {number} positionId
     * @param {PositionConversationFlowMetricsRequest} positionConversationFlowMetricsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionMetrics(
      positionId: number,
      positionConversationFlowMetricsRequest: PositionConversationFlowMetricsRequest,
      options?: any,
    ): AxiosPromise<PositionConversationFlowMetrics> {
      return localVarFp
        .postPositionMetrics(
          positionId,
          positionConversationFlowMetricsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Qualification Chat Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionQualificationChat(
      positionId: number,
      options?: any,
    ): AxiosPromise<Array<PositionQualificationChatResponse>> {
      return localVarFp
        .postPositionQualificationChat(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Integration Sync Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postPositionSync(options?: any): AxiosPromise<any> {
      return localVarFp
        .postPositionSync(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Chat Post
     * @param {number} positionId
     * @param {number} resumeId
     * @param {ResumeChatRequest} resumeChatRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumeChat(
      positionId: number,
      resumeId: number,
      resumeChatRequest: ResumeChatRequest,
      options?: any,
    ): AxiosPromise<Array<ResumeChatResponse>> {
      return localVarFp
        .postResumeChat(positionId, resumeId, resumeChatRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Rejection Post
     * @param {number} positionId
     * @param {number} resumeId
     * @param {BodyPostResumeRejection} bodyPostResumeRejection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumeRejection(
      positionId: number,
      resumeId: number,
      bodyPostResumeRejection: BodyPostResumeRejection,
      options?: any,
    ): AxiosPromise<CandidateDecisionResponse> {
      return localVarFp
        .postResumeRejection(
          positionId,
          resumeId,
          bodyPostResumeRejection,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resume Integration Sync Post
     * @param {number} positionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumeSync(positionId: number, options?: any): AxiosPromise<any> {
      return localVarFp
        .postResumeSync(positionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Resumes Post
     * @param {number} positionId
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postResumes(
      positionId: number,
      file: File,
      options?: any,
    ): AxiosPromise<ResponsePostresumes> {
      return localVarFp
        .postResumes(positionId, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Share Post
     * @param {number} evaluationId
     * @param {number} positionId
     * @param {number} candidateId
     * @param {Array<EvaluationRecipientRequest>} evaluationRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postShareEvaluation(
      evaluationId: number,
      positionId: number,
      candidateId: number,
      evaluationRecipientRequest: Array<EvaluationRecipientRequest>,
      options?: any,
    ): AxiosPromise<Array<EvaluationRecipientRequest>> {
      return localVarFp
        .postShareEvaluation(
          evaluationId,
          positionId,
          candidateId,
          evaluationRecipientRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Short Messages Post
     * @param {number} positionId
     * @param {number} candidateId
     * @param {string} body
     * @param {boolean} [resumeAutomation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postShortMessage(
      positionId: number,
      candidateId: number,
      body: string,
      resumeAutomation?: boolean,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postShortMessage(
          positionId,
          candidateId,
          body,
          resumeAutomation,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Stage Transitions Post
     * @param {number} positionId
     * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postStageTransitions(
      positionId: number,
      komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postStageTransitions(
          positionId,
          komboApplicationStageTransitionRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Stage Transitions Default Post
     * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postStageTransitionsDefault(
      komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postStageTransitionsDefault(
          komboApplicationStageTransitionRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Subscription Agent Voice Post
     * @param {AgentVoice} agentVoiceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postSubscriptionAgentVoice(
      agentVoiceId: AgentVoice,
      options?: any,
    ): AxiosPromise<SubscriptionResponse> {
      return localVarFp
        .postSubscriptionAgentVoice(agentVoiceId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Webhook Retell
     * @param {CallWebhook} callWebhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookRetell(
      callWebhook: CallWebhook,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postWebhookRetell(callWebhook, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Authenticate and accept a recruiter email for delivery to its opaque candidate relay address.
     * @summary Webhook Sendgrid Inbound Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookSendgridInboundEmail(options?: any): AxiosPromise<any> {
      return localVarFp
        .postWebhookSendgridInboundEmail(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Delegate the \"Reply via SMS\" / \"Mark Resolved\" interactivity to the service (the dependency verifies the signature and supplies the payload).  The service returns a Slack ``response_action`` dict for a modal submit (echoed verbatim), a background-work callback for a \"Mark Resolved\" click (scheduled here so the ack returns within Slack\'s 3s window), or ``None`` to acknowledge with an empty 200 for a \"Reply via SMS\" click or an unrelated payload.
     * @summary Webhook Slack Interactivity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookSlackInteractivity(options?: any): AxiosPromise<any> {
      return localVarFp
        .postWebhookSlackInteractivity(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Fail-closed when the signing secret is unset.  The DB confirm runs synchronously so a failure returns a non-2xx for Stripe\'s retry policy; only the resulting Slack post, if any, moves to a background task.
     * @summary Webhook Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookStripe(options?: any): AxiosPromise<any> {
      return localVarFp
        .postWebhookStripe(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Webhook Twilio Message
     * @param {string} from
     * @param {string} to
     * @param {string} messageSid
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioMessage(
      from: string,
      to: string,
      messageSid: string,
      body: string,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postWebhookTwilioMessage(from, to, messageSid, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Webhook Twilio Message Status
     * @param {string} messageSid
     * @param {string} messageStatus
     * @param {string | null} [errorCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioStatus(
      messageSid: string,
      messageStatus: string,
      errorCode?: string | null,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postWebhookTwilioStatus(messageSid, messageStatus, errorCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Webhook Twilio Status
     * @param {string} recordingUrl
     * @param {string} callSid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioStatusCallback(
      recordingUrl: string,
      callSid: string,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postWebhookTwilioStatusCallback(recordingUrl, callSid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Webhook Twilio Voice
     * @param {string} from
     * @param {string} to
     * @param {string} callSid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWebhookTwilioVoice(
      from: string,
      to: string,
      callSid: string,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .postWebhookTwilioVoice(from, to, callSid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Weekly Recipient Post
     * @param {Array<WeeklySummaryRecipientRequest>} weeklySummaryRecipientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postWeeklySummaryRecipients(
      weeklySummaryRecipientRequest: Array<WeeklySummaryRecipientRequest>,
      options?: any,
    ): AxiosPromise<Array<WeeklySummaryRecipientResponse>> {
      return localVarFp
        .postWeeklySummaryRecipients(weeklySummaryRecipientRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Record or revise ``candidate``\'s offer; returns 409 when the candidate has left the process, has started, or when an acceptance is being undone.
     * @summary Candidate Offer Put
     * @param {number} positionId
     * @param {number} candidateId
     * @param {HiringStageOfferRequest} hiringStageOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putCandidateOffer(
      positionId: number,
      candidateId: number,
      hiringStageOfferRequest: HiringStageOfferRequest,
      options?: any,
    ): AxiosPromise<HiringStageResponse> {
      return localVarFp
        .putCandidateOffer(
          positionId,
          candidateId,
          hiringStageOfferRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Company Faq Update
     * @param {number} faqId
     * @param {number} companyId
     * @param {CompanyFaqRequest} companyFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putCompanyFaq(
      faqId: number,
      companyId: number,
      companyFaqRequest: CompanyFaqRequest,
      options?: any,
    ): AxiosPromise<CompanyFaq> {
      return localVarFp
        .putCompanyFaq(faqId, companyId, companyFaqRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Email Setting Put
     * @param {number} positionId
     * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putEvaluationEmailSetting(
      positionId: number,
      evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
      options?: any,
    ): AxiosPromise<EvaluationEmailSettingResponse> {
      return localVarFp
        .putEvaluationEmailSetting(
          positionId,
          evaluationEmailSettingRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Evaluation Email Setting Default Put
     * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putEvaluationEmailSettingDefault(
      evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
      options?: any,
    ): AxiosPromise<EvaluationEmailSettingResponse> {
      return localVarFp
        .putEvaluationEmailSettingDefault(
          evaluationEmailSettingRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Faq Put
     * @param {number} faqId
     * @param {number} positionId
     * @param {PositionFaqRequest} positionFaqRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPositionFaq(
      faqId: number,
      positionId: number,
      positionFaqRequest: PositionFaqRequest,
      options?: any,
    ): AxiosPromise<PositionFaq> {
      return localVarFp
        .putPositionFaq(faqId, positionId, positionFaqRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Position Faqs Put
     * @param {number} positionId
     * @param {PositionFaqBulkRequest} positionFaqBulkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPositionFaqs(
      positionId: number,
      positionFaqBulkRequest: PositionFaqBulkRequest,
      options?: any,
    ): AxiosPromise<Array<PositionFaq>> {
      return localVarFp
        .putPositionFaqs(positionId, positionFaqBulkRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Rejection Message Put
     * @param {RejectionMessageRequest} rejectionMessageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putRejectionMessage(
      rejectionMessageRequest: RejectionMessageRequest,
      options?: any,
    ): AxiosPromise<RejectionMessageResponse> {
      return localVarFp
        .putRejectionMessage(rejectionMessageRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Offer Stages Put
     * @param {OfferStageConfigRequest} offerStageConfigRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setOfferStages(
      offerStageConfigRequest: OfferStageConfigRequest,
      options?: any,
    ): AxiosPromise<OfferStageConfigResponse> {
      return localVarFp
        .setOfferStages(offerStageConfigRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Upsert the organization\'s shared ROI dashboard settings (any member may set them).
     * @summary Roi Metrics Settings Put
     * @param {RoiMetricsSettingsRequest} roiMetricsSettingsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setRoiSettings(
      roiMetricsSettingsRequest: RoiMetricsSettingsRequest,
      options?: any,
    ): AxiosPromise<RoiMetricsSettingsResponse> {
      return localVarFp
        .setRoiSettings(roiMetricsSettingsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Submit Application
     * @param {string} positionPublicId
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} phoneNumber
     * @param {string | null} [emailAddress]
     * @param {File | null} [file]
     * @param {Array<File>} [attachments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitApplication(
      positionPublicId: string,
      firstName: string,
      lastName: string,
      phoneNumber: string,
      emailAddress?: string | null,
      file?: File | null,
      attachments?: Array<File>,
      options?: any,
    ): AxiosPromise<ApplicationSubmissionResponse> {
      return localVarFp
        .submitApplication(
          positionPublicId,
          firstName,
          lastName,
          phoneNumber,
          emailAddress,
          file,
          attachments,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Member Profile Put
     * @param {string} userId
     * @param {ProfileRequest} profileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateMemberProfile(
      userId: string,
      profileRequest: ProfileRequest,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .updateMemberProfile(userId, profileRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Profile Put
     * @param {ProfileRequest} profileRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProfile(
      profileRequest: ProfileRequest,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .updateProfile(profileRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary Member Activate
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public activateOrganizationMember(
    userId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .activateOrganizationMember(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Automated Invite Default Source Filter Apply
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public applyAutomatedInviteDefaultSourceFilter(
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .applyAutomatedInviteDefaultSourceFilter(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Complete Login
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public completeLogin(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .completeLogin(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Member Deactivate
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deactivateOrganizationMember(
    userId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deactivateOrganizationMember(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Faq Delete
   * @param {number} faqId
   * @param {number} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteCompanyFaq(
    faqId: number,
    companyId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteCompanyFaq(faqId, companyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Invite User Delete
   * @param {string} invitationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteOrganizationInvitation(
    invitationId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteOrganizationInvitation(invitationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Permission Delete
   * @param {number} positionId
   * @param {string} userId
   * @param {PositionRole} role
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteOrganizationPermission(
    positionId: number,
    userId: string,
    role: PositionRole,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteOrganizationPermission(positionId, userId, role, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Role Delete
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteOrganizationRole(
    userId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteOrganizationRole(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Faq Delete
   * @param {number} faqId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deletePositionFaq(
    faqId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deletePositionFaq(faqId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Activity Logs Get
   * @param {number | null} [candidateId]
   * @param {number | null} [positionId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getActivityLogs(
    candidateId?: number | null,
    positionId?: number | null,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getActivityLogs(candidateId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Stages Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAllStages(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAllStages(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Automated Invite Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAutomatedInvite(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAutomatedInvite(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Automated Invite Default Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAutomatedInviteDefault(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAutomatedInviteDefault(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Excluded Stages Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAutomatedInviteExcludedStages(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAutomatedInviteExcludedStages(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Return saved source filters from positions this member can edit.
   * @summary Automated Invite Source Filter Options Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAutomatedInviteSourceFilterOptions(
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAutomatedInviteSourceFilterOptions(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Call Analysis Get
   * @param {number} candidateId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCallAnalysis(
    candidateId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCallAnalysis(candidateId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Calls Get
   * @param {number} candidateId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCalls(
    candidateId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCalls(candidateId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Get
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCandidate(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCandidate(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Get Previous Applications
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCandidatePreviousApplications(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCandidatePreviousApplications(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Sources Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCandidateSources(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getCandidateSources(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Integration Sync Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCandidateSyncHistory(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCandidateSyncHistory(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Timeline Get
   * @param {number} candidateId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCandidateTimeline(
    candidateId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCandidateTimeline(candidateId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Guidance Get
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCandidateTodoGuidance(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCandidateTodoGuidance(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidates Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCandidates(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getCandidates(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Companies Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCompanies(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getCompanies(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Get
   * @param {number} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCompany(companyId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getCompany(companyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Analysis Get
   * @param {number} companyAnalysisId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCompanyAnalysis(
    companyAnalysisId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getCompanyAnalysis(companyAnalysisId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Faq List
   * @param {number} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCompanyFaqs(companyId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getCompanyFaqs(companyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Daily Recipient Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getDailySummaryRecipients(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getDailySummaryRecipients(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Deactivated Members Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getDeactivatedOrganizationMembers(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getDeactivatedOrganizationMembers(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Get
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEvaluation(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEvaluation(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Chat Get
   * @param {number} evaluationId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEvaluationChat(
    evaluationId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEvaluationChat(evaluationId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Email Recipient Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEvaluationEmailRecipients(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEvaluationEmailRecipients(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Email Setting Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEvaluationEmailSetting(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEvaluationEmailSetting(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Email Setting Default Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEvaluationEmailSettingDefault(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getEvaluationEmailSettingDefault(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Latest Recipients Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEvaluationRecipients(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEvaluationRecipients(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluations Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEvaluations(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getEvaluations(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Return candidates from live positions visible to the caller.
   * @summary Live Position Candidates Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getGlobalCandidates(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getGlobalCandidates(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * List hiring-stage rows across the caller\'s org, scoped to (for non-admins) the positions they may edit.
   * @summary Hiring Stages Get
   * @param {Array<HiringStage>} [stage]
   * @param {number} [limit]
   * @param {boolean} [pending]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getHiringStages(
    stage?: Array<HiringStage>,
    limit?: number,
    pending?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getHiringStages(stage, limit, pending, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Read the current sync statuses for the active integration.
   * @summary Integration Sync Statuses Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIntegrationSyncStatuses(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getIntegrationSyncStatuses(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Integrations Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getIntegrations(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getIntegrations(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Invitation Slots Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getInvitationSlots(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getInvitationSlots(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Job Analysis Get
   * @param {number} jobAnalysisId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getJobAnalysis(
    jobAnalysisId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getJobAnalysis(jobAnalysisId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Called by the frontend on ``?boost=success``; shares the confirm routine with the Stripe webhook so payment is recorded exactly once regardless of which one lands first.
   * @summary Boost Checkout Confirm Get
   * @param {number} positionId
   * @param {string} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getJobBoardBoostCheckoutConfirm(
    positionId: number,
    sessionId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getJobBoardBoostCheckoutConfirm(positionId, sessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Boost Recommendation Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getJobBoardBoostRecommendation(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getJobBoardBoostRecommendation(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Job States Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getJobStates(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getJobStates(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Kombo Tools Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getKomboTools(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getKomboTools(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Call Get
   * @param {number} candidateId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLatestCall(
    candidateId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getLatestCall(candidateId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Call Simulation Get Latest
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLatestCallSimulation(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getLatestCallSimulation(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Qualification Chat Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLatestPositionQualificationChat(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getLatestPositionQualificationChat(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Live Positions Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLivePositions(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getLivePositions(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Offer Stages Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getOfferStages(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getOfferStages(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * No `validate_subscription`: a first-time user may not have an active subscription yet.
   * @summary Onboarding Tour Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getOnboardingTour(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getOnboardingTour(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Invite User Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getOrganizationInvitations(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getOrganizationInvitations(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Members Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getOrganizationMembers(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getOrganizationMembers(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Phone Number Lookup Get
   * @param {string} phoneNumber
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPhoneNumberLookup(
    phoneNumber: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPhoneNumberLookup(phoneNumber, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPosition(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getPosition(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Chat Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositionChat(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getPositionChat(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Faqs Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositionFaqs(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getPositionFaqs(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Return each active member\'s positions with the requested role.
   * @summary Position Memberships Get
   * @param {PositionRole} [role]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositionMemberships(
    role?: PositionRole,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPositionMemberships(role, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Return the findings on the stored qualification lines that keep the position from going live.  Only block-severity findings are included; warnings are not. The call has no side effects, and a position of another organization responds 404.
   * @summary Position Qualification Check Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositionQualificationCheck(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPositionQualificationCheck(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Stages Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositionStages(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPositionStages(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Integration Sync Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositionSyncHistory(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getPositionSyncHistory(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Users Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositionUsers(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getPositionUsers(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Positions Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPositions(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getPositions(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Public Position
   * @param {string} positionPublicId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPublicPosition(
    positionPublicId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPublicPosition(positionPublicId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Public Positions
   * @param {string} companySlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPublicPositions(
    companySlug: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPublicPositions(companySlug, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Rejection Message Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getRejectionMessage(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getRejectionMessage(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Rejection Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getRejectionReasons(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getRejectionReasons(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Get
   * @param {number} positionId
   * @param {number} resumeId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getResume(
    positionId: number,
    resumeId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getResume(positionId, resumeId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Chat Get
   * @param {number} resumeId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getResumeChat(
    resumeId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getResumeChat(resumeId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Integration Sync Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getResumeSyncHistory(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getResumeSyncHistory(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resumes Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getResumes(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getResumes(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * List open review items, scoped to the caller\'s org and (for non-admins) editable positions.
   * @summary Review Items Get
   * @param {Array<ReviewItemCategory>} [category]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getReviewItems(
    category?: Array<ReviewItemCategory>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getReviewItems(category, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Return the organization\'s ROI dashboard settings, or ``null`` when no member has saved them yet.
   * @summary Roi Metrics Settings Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getRoiSettings(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getRoiSettings(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Share Get
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getShareEvaluation(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getShareEvaluation(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Stage Transitions Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getStageTransitions(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getStageTransitions(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Stage Transitions Default Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getStageTransitionsDefault(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getStageTransitionsDefault(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Statistics Get
   * @param {string | null} [before]
   * @param {string | null} [after]
   * @param {Array<number>} [companyIds]
   * @param {Array<number>} [positionIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getStatistics(
    before?: string | null,
    after?: string | null,
    companyIds?: Array<number>,
    positionIds?: Array<number>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getStatistics(before, after, companyIds, positionIds, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Subscription Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSubscription(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getSubscription(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Integration Sync Status Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSyncCandidateStatus(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getSyncCandidateStatus(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Integration Sync Status Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSyncPositionStatus(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getSyncPositionStatus(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Integration Sync Status Get
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSyncResumeStatus(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getSyncResumeStatus(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Timeline Translate Get
   * @param {number} candidateId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getTranslatedCandidateTimeline(
    candidateId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getTranslatedCandidateTimeline(candidateId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Unresponsive Candidate Log
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUnresponsiveCandidateLog(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getUnresponsiveCandidateLog(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary User Positions Get
   * @param {string} userId
   * @param {PositionRole} [role]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getUserPositions(
    userId: string,
    role?: PositionRole,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getUserPositions(userId, role, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Weekly Statistics Get
   * @param {string | null} [before]
   * @param {string | null} [after]
   * @param {Array<number>} [companyIds]
   * @param {Array<number>} [positionIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getWeeklyStatistics(
    before?: string | null,
    after?: string | null,
    companyIds?: Array<number>,
    positionIds?: Array<number>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getWeeklyStatistics(before, after, companyIds, positionIds, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Weekly Recipient Get
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getWeeklySummaryRecipients(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getWeeklySummaryRecipients(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Admin-only atomic move of an answered position FAQ into the company library; see ``PositionService.move_faq_to_company`` for the locking/transaction contract.
   * @summary Position Faq Move To Company
   * @param {number} faqId
   * @param {number} positionId
   * @param {PositionFaqMoveRequest} positionFaqMoveRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public movePositionFaqToCompany(
    faqId: number,
    positionId: number,
    positionFaqMoveRequest: PositionFaqMoveRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .movePositionFaqToCompany(
        faqId,
        positionId,
        positionFaqMoveRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Automated Invite Paused Patch
   * @param {number} positionId
   * @param {AutomatedInvitePausedRequest} automatedInvitePausedRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchAutomatedInvitePaused(
    positionId: number,
    automatedInvitePausedRequest: AutomatedInvitePausedRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchAutomatedInvitePaused(
        positionId,
        automatedInvitePausedRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Patch
   * @param {number} positionId
   * @param {number} candidateId
   * @param {CandidatePatchRequest} candidatePatchRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchCandidate(
    positionId: number,
    candidateId: number,
    candidatePatchRequest: CandidatePatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchCandidate(positionId, candidateId, candidatePatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Mark ``candidate``\'s placement as ours to follow, or stop following it, without touching the offer.  Separate from the PUT: the toggle must work with no offer to resend — an In Process candidate has none yet, an Onboarding one can no longer submit one.
   * @summary Candidate Tracked Patch
   * @param {number} positionId
   * @param {number} candidateId
   * @param {HiringStageTrackedRequest} hiringStageTrackedRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchCandidateTracked(
    positionId: number,
    candidateId: number,
    hiringStageTrackedRequest: HiringStageTrackedRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchCandidateTracked(
        positionId,
        candidateId,
        hiringStageTrackedRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Patch
   * @param {number} companyId
   * @param {CompanyRequest} companyRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchCompany(
    companyId: number,
    companyRequest: CompanyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchCompany(companyId, companyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Patch
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchEvaluation(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchEvaluation(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Checkpoint Patch
   * @param {number} candidateId
   * @param {number} evaluationCheckpointId
   * @param {number} positionId
   * @param {BodyPatchEvaluationCheckpoint} bodyPatchEvaluationCheckpoint
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchEvaluationCheckpoint(
    candidateId: number,
    evaluationCheckpointId: number,
    positionId: number,
    bodyPatchEvaluationCheckpoint: BodyPatchEvaluationCheckpoint,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchEvaluationCheckpoint(
        candidateId,
        evaluationCheckpointId,
        positionId,
        bodyPatchEvaluationCheckpoint,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluations Patch
   * @param {number} positionId
   * @param {Array<EvaluateCandidateRequest>} evaluateCandidateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchEvaluationsBulk(
    positionId: number,
    evaluateCandidateRequest: Array<EvaluateCandidateRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchEvaluationsBulk(positionId, evaluateCandidateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Patch
   * @param {number} positionId
   * @param {PositionPatchRequest} positionPatchRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchPosition(
    positionId: number,
    positionPatchRequest: PositionPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchPosition(positionId, positionPatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Patch
   * @param {number} positionId
   * @param {number} resumeId
   * @param {ResumeRequest} resumeRequest
   * @param {boolean} [cancelQueuedInvite]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchResume(
    positionId: number,
    resumeId: number,
    resumeRequest: ResumeRequest,
    cancelQueuedInvite?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchResume(
        positionId,
        resumeId,
        resumeRequest,
        cancelQueuedInvite,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Apply a resolution transition (admin bypass; non-admin needs CAN_EDIT on the item\'s position).  Domain errors map to 409: an ``unknown``-row transition, an Undo colliding with another open advancement, or an Undo of an already-offered candidate.
   * @summary Review Item Patch
   * @param {number} reviewItemId
   * @param {ReviewItemResolutionRequest} reviewItemResolutionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public patchReviewItem(
    reviewItemId: number,
    reviewItemResolutionRequest: ReviewItemResolutionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .patchReviewItem(reviewItemId, reviewItemResolutionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Automated Invite Post
   * @param {number} positionId
   * @param {AutomatedInviteRequest} automatedInviteRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postAutomatedInvite(
    positionId: number,
    automatedInviteRequest: AutomatedInviteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postAutomatedInvite(positionId, automatedInviteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Automated Invite Default Post
   * @param {AutomatedInviteDefaultRequest} automatedInviteDefaultRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postAutomatedInviteDefault(
    automatedInviteDefaultRequest: AutomatedInviteDefaultRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postAutomatedInviteDefault(automatedInviteDefaultRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Excluded Stages Post
   * @param {BodyPostAutomatedInviteExcludedStages} bodyPostAutomatedInviteExcludedStages
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postAutomatedInviteExcludedStages(
    bodyPostAutomatedInviteExcludedStages: BodyPostAutomatedInviteExcludedStages,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postAutomatedInviteExcludedStages(
        bodyPostAutomatedInviteExcludedStages,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Initiate an immediate call to the candidate without sending any messages.
   * @summary Call Immediate
   * @param {number} candidateId
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCallImmediate(
    candidateId: number,
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCallImmediate(candidateId, positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Call Simulation Post
   * @param {number} positionId
   * @param {CallSimulationRequest} [callSimulationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCallSimulation(
    positionId: number,
    callSimulationRequest?: CallSimulationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCallSimulation(positionId, callSimulationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Revise the suggested rewrite of one settings-coverage judgement using the recruiter\'s comment.  Returns only the revised judgement — the client already holds the rest of the job and must not re-download the transcript.
   * @summary Call Simulation Coverage Rewrite Post
   * @param {number} positionId
   * @param {number} jobId
   * @param {string} settingKey
   * @param {SettingsCoverageRewriteRequest} settingsCoverageRewriteRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCallSimulationCoverageRewrite(
    positionId: number,
    jobId: number,
    settingKey: string,
    settingsCoverageRewriteRequest: SettingsCoverageRewriteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCallSimulationCoverageRewrite(
        positionId,
        jobId,
        settingKey,
        settingsCoverageRewriteRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Call Test Post
   * @param {number} positionId
   * @param {CallTestRequest} callTestRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCallTest(
    positionId: number,
    callTestRequest: CallTestRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCallTest(positionId, callTestRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidates Post
   * @param {number} positionId
   * @param {CandidateRequest} candidateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidate(
    positionId: number,
    candidateRequest: CandidateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidate(positionId, candidateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Idempotently move ``candidate`` to In Process; returns 409 if archived/withdrawn, already offered, or a concurrent race is lost (retry).
   * @summary Candidate Advancement Post
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidateAdvancement(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidateAdvancement(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidates Post Bulk
   * @param {number} positionId
   * @param {Array<CandidateRequest>} candidateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidateBulk(
    positionId: number,
    candidateRequest: Array<CandidateRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidateBulk(positionId, candidateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Decision Reject
   * @param {number} positionId
   * @param {number} candidateId
   * @param {CandidateDecisionRejectRequest} candidateDecisionRejectRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidateDecisionReject(
    positionId: number,
    candidateId: number,
    candidateDecisionRejectRequest: CandidateDecisionRejectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidateDecisionReject(
        positionId,
        candidateId,
        candidateDecisionRejectRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Return the email the signed-in recruiter can send to reach this candidate through the relay.  The address comes from the authenticated identity rather than the request body. The first sender to write to a relay address claims it, so a client-supplied value could claim a colleague\'s thread.  Raises:     HTTPException: 409 if the candidate\'s AI screening has not produced a usable evaluation yet.
   * @summary Candidate Relay Draft Post
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidateRelayDraft(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidateRelayDraft(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Candidate Integration Sync Post
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidateSync(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidateSync(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Guidance Post
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidateTodoGuidance(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidateTodoGuidance(positionId, candidateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Guidance Mark As Completed
   * @param {number} positionId
   * @param {number} candidateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCandidateTodoGuidanceMarkAsCompleted(
    positionId: number,
    candidateId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCandidateTodoGuidanceMarkAsCompleted(
        positionId,
        candidateId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Companies Post
   * @param {CompanyRequest} companyRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCompany(
    companyRequest: CompanyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCompany(companyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Agent Preview Post
   * @param {number} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCompanyAgentPreview(
    companyId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCompanyAgentPreview(companyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Analyses Post
   * @param {CompanyAnalysisRequest} companyAnalysisRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCompanyAnalysis(
    companyAnalysisRequest: CompanyAnalysisRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCompanyAnalysis(companyAnalysisRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Faq Create
   * @param {number} companyId
   * @param {CompanyFaqRequest} companyFaqRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCompanyFaq(
    companyId: number,
    companyFaqRequest: CompanyFaqRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCompanyFaq(companyId, companyFaqRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Logo Post
   * @param {number} companyId
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCompanyLogo(
    companyId: number,
    file: File,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCompanyLogo(companyId, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Voice Preview Post
   * @param {AgentVoice} agentVoiceId
   * @param {number} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postCompanyVoicePreview(
    agentVoiceId: AgentVoice,
    companyId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postCompanyVoicePreview(agentVoiceId, companyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Daily Recipient Post
   * @param {Array<DailySummaryRecipientRequest>} dailySummaryRecipientRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postDailySummaryRecipients(
    dailySummaryRecipientRequest: Array<DailySummaryRecipientRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postDailySummaryRecipients(dailySummaryRecipientRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Chat Post
   * @param {number} positionId
   * @param {number} evaluationId
   * @param {EvaluationChatRequest} evaluationChatRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postEvaluationChat(
    positionId: number,
    evaluationId: number,
    evaluationChatRequest: EvaluationChatRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postEvaluationChat(
        positionId,
        evaluationId,
        evaluationChatRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Email Recipient Post
   * @param {number} positionId
   * @param {Array<EvaluationEmailRecipientRequest>} evaluationEmailRecipientRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postEvaluationEmailRecipients(
    positionId: number,
    evaluationEmailRecipientRequest: Array<EvaluationEmailRecipientRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postEvaluationEmailRecipients(
        positionId,
        evaluationEmailRecipientRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Export Post
   * @param {number} evaluationId
   * @param {number} positionId
   * @param {number} candidateId
   * @param {boolean} [skipIntegration]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postEvaluationExport(
    evaluationId: number,
    positionId: number,
    candidateId: number,
    skipIntegration?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postEvaluationExport(
        evaluationId,
        positionId,
        candidateId,
        skipIntegration,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Generate a question for the new-position wizard before a position row exists.
   * @summary Qualification Question Post
   * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postGenerateQualificationQuestion(
    positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postGenerateQualificationQuestion(
        positionQualificationQuestionGenerationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Help Center Chat Post
   * @param {HelpCenterChatRequest} helpCenterChatRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postHelpCenterChat(
    helpCenterChatRequest: HelpCenterChatRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postHelpCenterChat(helpCenterChatRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Integrations Post
   * @param {IntegrationRequest} integrationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postIntegration(
    integrationRequest: IntegrationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postIntegration(integrationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Post Deploy Call Post
   * @param {string} xPostDeployE2EToken
   * @param {PostDeployCallRequest} postDeployCallRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postInternalE2EPostDeployCall(
    xPostDeployE2EToken: string,
    postDeployCallRequest: PostDeployCallRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postInternalE2EPostDeployCall(
        xPostDeployE2EToken,
        postDeployCallRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Job Analyses Post
   * @param {JobAnalysisRequest} jobAnalysisRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postJobAnalysis(
    jobAnalysisRequest: JobAnalysisRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postJobAnalysis(jobAnalysisRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Job Analyses Upload Post
   * @param {number} companyId
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postJobAnalysisUpload(
    companyId: number,
    file: File,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postJobAnalysisUpload(companyId, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Job Analyses Start Web Call Post
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postJobAnalysisWebCall(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postJobAnalysisWebCall(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Boost Checkout Post
   * @param {number} positionId
   * @param {JobBoardBoostCheckoutRequest} jobBoardBoostCheckoutRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postJobBoardBoostCheckout(
    positionId: number,
    jobBoardBoostCheckoutRequest: JobBoardBoostCheckoutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postJobBoardBoostCheckout(
        positionId,
        jobBoardBoostCheckoutRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Boost Recommendation Post
   * @param {number} positionId
   * @param {JobBoardBoostRecommendationRequest} jobBoardBoostRecommendationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postJobBoardBoostRecommendation(
    positionId: number,
    jobBoardBoostRecommendationRequest: JobBoardBoostRecommendationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postJobBoardBoostRecommendation(
        positionId,
        jobBoardBoostRecommendationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Kombo Activate Post
   * @param {BodyPostKomboActivate} bodyPostKomboActivate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postKomboActivate(
    bodyPostKomboActivate: BodyPostKomboActivate,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postKomboActivate(bodyPostKomboActivate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Webhook Kombo Data Changed
   * @param {KomboDataChangedWebhook} komboDataChangedWebhook
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postKomboDataChanged(
    komboDataChangedWebhook: KomboDataChangedWebhook,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postKomboDataChanged(komboDataChangedWebhook, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Kombo Init Post
   * @param {BodyPostKomboInit} [bodyPostKomboInit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postKomboInit(
    bodyPostKomboInit?: BodyPostKomboInit,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postKomboInit(bodyPostKomboInit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Webhook Kombo Sync Finished
   * @param {KomboSyncFinishedWebhook} komboSyncFinishedWebhook
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postKomboSyncFinished(
    komboSyncFinishedWebhook: KomboSyncFinishedWebhook,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postKomboSyncFinished(komboSyncFinishedWebhook, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Onboarding Tour Complete Post
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postOnboardingTour(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postOnboardingTour(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Invite User Post
   * @param {UserInvitationRequest} userInvitationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postOrganizationInvitation(
    userInvitationRequest: UserInvitationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postOrganizationInvitation(userInvitationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Permission Post
   * @param {number} positionId
   * @param {string} userId
   * @param {PositionRole} role
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postOrganizationPermission(
    positionId: number,
    userId: string,
    role: PositionRole,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postOrganizationPermission(positionId, userId, role, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Role Post
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postOrganizationRole(userId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postOrganizationRole(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Positions Post
   * @param {PositionRequest} positionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPosition(
    positionRequest: PositionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postPosition(positionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Chat Post
   * @param {number} positionId
   * @param {PositionChatRequest} positionChatRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPositionChat(
    positionId: number,
    positionChatRequest: PositionChatRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postPositionChat(positionId, positionChatRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Duplicate Post
   * @param {number} positionId
   * @param {BodyPostPositionDuplicate} [bodyPostPositionDuplicate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPositionDuplicate(
    positionId: number,
    bodyPostPositionDuplicate?: BodyPostPositionDuplicate,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postPositionDuplicate(positionId, bodyPostPositionDuplicate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Faqs Post
   * @param {number} positionId
   * @param {PositionFaqRequest} positionFaqRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPositionFaq(
    positionId: number,
    positionFaqRequest: PositionFaqRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postPositionFaq(positionId, positionFaqRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Generate a qualification question for an existing position (FGA + org check via router deps).  The validated position\'s title, overview, and other qualification lines are always used as type-inference context; the client never supplies them.
   * @summary Position Qualification Question Post
   * @param {number} positionId
   * @param {PositionQualificationQuestionGenerationRequest} positionQualificationQuestionGenerationRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPositionGenerateQualificationQuestion(
    positionId: number,
    positionQualificationQuestionGenerationRequest: PositionQualificationQuestionGenerationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postPositionGenerateQualificationQuestion(
        positionId,
        positionQualificationQuestionGenerationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Metrics Post
   * @param {number} positionId
   * @param {PositionConversationFlowMetricsRequest} positionConversationFlowMetricsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPositionMetrics(
    positionId: number,
    positionConversationFlowMetricsRequest: PositionConversationFlowMetricsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postPositionMetrics(
        positionId,
        positionConversationFlowMetricsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Qualification Chat Post
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPositionQualificationChat(
    positionId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postPositionQualificationChat(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Integration Sync Post
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postPositionSync(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postPositionSync(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Chat Post
   * @param {number} positionId
   * @param {number} resumeId
   * @param {ResumeChatRequest} resumeChatRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postResumeChat(
    positionId: number,
    resumeId: number,
    resumeChatRequest: ResumeChatRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postResumeChat(positionId, resumeId, resumeChatRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Rejection Post
   * @param {number} positionId
   * @param {number} resumeId
   * @param {BodyPostResumeRejection} bodyPostResumeRejection
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postResumeRejection(
    positionId: number,
    resumeId: number,
    bodyPostResumeRejection: BodyPostResumeRejection,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postResumeRejection(
        positionId,
        resumeId,
        bodyPostResumeRejection,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resume Integration Sync Post
   * @param {number} positionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postResumeSync(positionId: number, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postResumeSync(positionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Resumes Post
   * @param {number} positionId
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postResumes(
    positionId: number,
    file: File,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postResumes(positionId, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Share Post
   * @param {number} evaluationId
   * @param {number} positionId
   * @param {number} candidateId
   * @param {Array<EvaluationRecipientRequest>} evaluationRecipientRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postShareEvaluation(
    evaluationId: number,
    positionId: number,
    candidateId: number,
    evaluationRecipientRequest: Array<EvaluationRecipientRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postShareEvaluation(
        evaluationId,
        positionId,
        candidateId,
        evaluationRecipientRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Short Messages Post
   * @param {number} positionId
   * @param {number} candidateId
   * @param {string} body
   * @param {boolean} [resumeAutomation]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postShortMessage(
    positionId: number,
    candidateId: number,
    body: string,
    resumeAutomation?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postShortMessage(
        positionId,
        candidateId,
        body,
        resumeAutomation,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Stage Transitions Post
   * @param {number} positionId
   * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postStageTransitions(
    positionId: number,
    komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postStageTransitions(
        positionId,
        komboApplicationStageTransitionRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Stage Transitions Default Post
   * @param {Array<KomboApplicationStageTransitionRequest>} komboApplicationStageTransitionRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postStageTransitionsDefault(
    komboApplicationStageTransitionRequest: Array<KomboApplicationStageTransitionRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postStageTransitionsDefault(
        komboApplicationStageTransitionRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Subscription Agent Voice Post
   * @param {AgentVoice} agentVoiceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postSubscriptionAgentVoice(
    agentVoiceId: AgentVoice,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postSubscriptionAgentVoice(agentVoiceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Webhook Retell
   * @param {CallWebhook} callWebhook
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookRetell(
    callWebhook: CallWebhook,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postWebhookRetell(callWebhook, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Authenticate and accept a recruiter email for delivery to its opaque candidate relay address.
   * @summary Webhook Sendgrid Inbound Email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookSendgridInboundEmail(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postWebhookSendgridInboundEmail(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Delegate the \"Reply via SMS\" / \"Mark Resolved\" interactivity to the service (the dependency verifies the signature and supplies the payload).  The service returns a Slack ``response_action`` dict for a modal submit (echoed verbatim), a background-work callback for a \"Mark Resolved\" click (scheduled here so the ack returns within Slack\'s 3s window), or ``None`` to acknowledge with an empty 200 for a \"Reply via SMS\" click or an unrelated payload.
   * @summary Webhook Slack Interactivity
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookSlackInteractivity(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postWebhookSlackInteractivity(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Fail-closed when the signing secret is unset.  The DB confirm runs synchronously so a failure returns a non-2xx for Stripe\'s retry policy; only the resulting Slack post, if any, moves to a background task.
   * @summary Webhook Stripe
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookStripe(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .postWebhookStripe(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Webhook Twilio Message
   * @param {string} from
   * @param {string} to
   * @param {string} messageSid
   * @param {string} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookTwilioMessage(
    from: string,
    to: string,
    messageSid: string,
    body: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postWebhookTwilioMessage(from, to, messageSid, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Webhook Twilio Message Status
   * @param {string} messageSid
   * @param {string} messageStatus
   * @param {string | null} [errorCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookTwilioStatus(
    messageSid: string,
    messageStatus: string,
    errorCode?: string | null,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postWebhookTwilioStatus(messageSid, messageStatus, errorCode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Webhook Twilio Status
   * @param {string} recordingUrl
   * @param {string} callSid
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookTwilioStatusCallback(
    recordingUrl: string,
    callSid: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postWebhookTwilioStatusCallback(recordingUrl, callSid, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Webhook Twilio Voice
   * @param {string} from
   * @param {string} to
   * @param {string} callSid
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWebhookTwilioVoice(
    from: string,
    to: string,
    callSid: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postWebhookTwilioVoice(from, to, callSid, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Weekly Recipient Post
   * @param {Array<WeeklySummaryRecipientRequest>} weeklySummaryRecipientRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public postWeeklySummaryRecipients(
    weeklySummaryRecipientRequest: Array<WeeklySummaryRecipientRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .postWeeklySummaryRecipients(weeklySummaryRecipientRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Record or revise ``candidate``\'s offer; returns 409 when the candidate has left the process, has started, or when an acceptance is being undone.
   * @summary Candidate Offer Put
   * @param {number} positionId
   * @param {number} candidateId
   * @param {HiringStageOfferRequest} hiringStageOfferRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public putCandidateOffer(
    positionId: number,
    candidateId: number,
    hiringStageOfferRequest: HiringStageOfferRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .putCandidateOffer(
        positionId,
        candidateId,
        hiringStageOfferRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Company Faq Update
   * @param {number} faqId
   * @param {number} companyId
   * @param {CompanyFaqRequest} companyFaqRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public putCompanyFaq(
    faqId: number,
    companyId: number,
    companyFaqRequest: CompanyFaqRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .putCompanyFaq(faqId, companyId, companyFaqRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Email Setting Put
   * @param {number} positionId
   * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public putEvaluationEmailSetting(
    positionId: number,
    evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .putEvaluationEmailSetting(
        positionId,
        evaluationEmailSettingRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Evaluation Email Setting Default Put
   * @param {EvaluationEmailSettingRequest} evaluationEmailSettingRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public putEvaluationEmailSettingDefault(
    evaluationEmailSettingRequest: EvaluationEmailSettingRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .putEvaluationEmailSettingDefault(evaluationEmailSettingRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Faq Put
   * @param {number} faqId
   * @param {number} positionId
   * @param {PositionFaqRequest} positionFaqRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public putPositionFaq(
    faqId: number,
    positionId: number,
    positionFaqRequest: PositionFaqRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .putPositionFaq(faqId, positionId, positionFaqRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Position Faqs Put
   * @param {number} positionId
   * @param {PositionFaqBulkRequest} positionFaqBulkRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public putPositionFaqs(
    positionId: number,
    positionFaqBulkRequest: PositionFaqBulkRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .putPositionFaqs(positionId, positionFaqBulkRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Rejection Message Put
   * @param {RejectionMessageRequest} rejectionMessageRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public putRejectionMessage(
    rejectionMessageRequest: RejectionMessageRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .putRejectionMessage(rejectionMessageRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Offer Stages Put
   * @param {OfferStageConfigRequest} offerStageConfigRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public setOfferStages(
    offerStageConfigRequest: OfferStageConfigRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .setOfferStages(offerStageConfigRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Upsert the organization\'s shared ROI dashboard settings (any member may set them).
   * @summary Roi Metrics Settings Put
   * @param {RoiMetricsSettingsRequest} roiMetricsSettingsRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public setRoiSettings(
    roiMetricsSettingsRequest: RoiMetricsSettingsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .setRoiSettings(roiMetricsSettingsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Submit Application
   * @param {string} positionPublicId
   * @param {string} firstName
   * @param {string} lastName
   * @param {string} phoneNumber
   * @param {string | null} [emailAddress]
   * @param {File | null} [file]
   * @param {Array<File>} [attachments]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public submitApplication(
    positionPublicId: string,
    firstName: string,
    lastName: string,
    phoneNumber: string,
    emailAddress?: string | null,
    file?: File | null,
    attachments?: Array<File>,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .submitApplication(
        positionPublicId,
        firstName,
        lastName,
        phoneNumber,
        emailAddress,
        file,
        attachments,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Member Profile Put
   * @param {string} userId
   * @param {ProfileRequest} profileRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateMemberProfile(
    userId: string,
    profileRequest: ProfileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateMemberProfile(userId, profileRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Profile Put
   * @param {ProfileRequest} profileRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateProfile(
    profileRequest: ProfileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateProfile(profileRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
